/*! © School House Learning Centre (shlc-tutor.co.uk). All rights reserved. Not licensed for reuse, redistribution, resale or derivative works. Enquiries: info@shlc-tutor.co.uk · build SHLC-QM-7Q4M2 */
/* Quick Maths app script (was the inline <script> in templates/page.maths-challenge.liquid,
   moved out 2026-09-14 for the 256 KB template cap). No Liquid in this file. */
(function(){
  'use strict';
  /*! © School House Learning Centre (shlc-tutor.co.uk). All rights reserved. Not licensed for reuse, redistribution, resale or derivative works. Enquiries: info@shlc-tutor.co.uk · build SHLC-QM-7Q4M2 */
  /* host lock: only starts on our own hostnames; anywhere else it returns before the game is built.
     Allowed: shlc-tutor.co.uk + subdomains, the store myshopify host (theme previews), localhost, file://. */
  try { var __shlcH = String(location.hostname || '').toLowerCase();
    if (!(/(^|\.)shlc-tutor\.co\.uk$/.test(__shlcH) || __shlcH === 'c44a55-2.myshopify.com'
          || __shlcH === 'localhost' || __shlcH === '127.0.0.1' || __shlcH === '')) return;
  } catch (e) { return; }
  try { (window.SHLC_BUILD = window.SHLC_BUILD || {})['QM'] = 'SHLC-QM-7Q4M2'; } catch (e) {}
  var $ = function(id){ return document.getElementById(id); };
  if(!$('qmRoot') || !$('qmPlay')) return;

  /* ---------------------------------------------------------
     Utilities
     --------------------------------------------------------- */
  var R  = function(n){ return Math.floor(Math.random()*n); };
  var RI = function(a,b){ return a + R(b-a+1); };
  var pick = function(a){ return a[R(a.length)]; };
  var shuffle = function(a){ for(var i=a.length-1;i>0;i--){ var j=R(i+1); var t=a[i]; a[i]=a[j]; a[j]=t; } return a; };
  var round = function(n,p){ var f=Math.pow(10,p||0); return Math.round((n+Number.EPSILON)*f)/f; };
  var nstr = function(n){ return String(round(n,4)); };
  /* clock answers are stored as "21:15", every other answer is a number */
  var ansStr = function(a){ return (typeof a === 'string') ? a : nstr(a); };
  var lead = function(n){ return n<0 ? '−'+Math.abs(n) : String(n); };
  var pad2 = function(n){ n=String(n); return n.length<2 ? '0'+n : n; };
  var fmtTime = function(s){ s=Math.max(0,Math.round(s)); return pad2(Math.floor(s/60))+':'+pad2(s%60); };
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function rgba(hex,a){
    var n=parseInt(hex.slice(1),16);
    return 'rgba('+((n>>16)&255)+','+((n>>8)&255)+','+(n&255)+','+a+')';
  }

  var ICON = {
    tick:  '<svg class="shlc-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12.5l5 5 10-11"/></svg>',
    cross: '<svg class="shlc-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    up:    '<svg class="shlc-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>',
    down:  '<svg class="shlc-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12l7 7 7-7"/></svg>',
    same:  '<svg class="shlc-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 9h14M5 15h14"/></svg>'
  };

  /* ---------------------------------------------------------
     Question generators
     --------------------------------------------------------- */
  /* Weighted pick: items are [value, weight] pairs. */
  function weighted(list){
    var tot=0, i;
    for(i=0;i<list.length;i++) tot+=list[i][1];
    var r=Math.random()*tot;
    for(i=0;i<list.length;i++){ r-=list[i][1]; if(r<=0) return list[i][0]; }
    return list[list.length-1][0];
  }

  /* ---- Add & Subtract: built from real mental strategies, not random pairs ---- */
  function qPositives(){
    var shape=weighted([['bond100',2],['neardouble',2],['bridge',3],['multiple10',2],['general',3],['bond50',1],
                        ['missing',3],['three',2],['tomake',2],['hundreds',2]]);
    var a,b,c;
    /* the missing addend, which is a different job from working the sum out */
    if(shape==='missing'){
      a=RI(12,79); b=RI(11,60);
      if(Math.random()<0.5) return { t:a+' + □ = '+(a+b), a:b, list:true };
      return { t:(a+b)+' − □ = '+a, a:b, list:true };
    }
    if(shape==='three'){
      a=RI(5,29); b=RI(5,29); c=RI(5,29);
      return { t:a+' + '+b+' + '+c+' =', a:a+b+c };
    }
    if(shape==='tomake'){
      var target=pick([100,100,200,500,1000]);
      if(target===100) b=RI(11,89);
      else if(target===200) b=RI(15,185);
      else b=RI(2, target/10-2)*10;      /* to 500 and 1,000 the gap stays a multiple of ten */
      return { t:'What must be added to '+b+' to make '+target.toLocaleString('en-GB')+'?', a:target-b, list:true };
    }
    if(shape==='hundreds'){
      a=RI(2,9)*100 + RI(1,9)*10 + RI(1,9);
      b=RI(2,8)*10;
      if(Math.random()<0.5) return { t:a+' + '+b+' =', a:a+b };
      return { t:a+' − '+b+' =', a:a-b };
    }
    if(shape==='bond100'){                       /* bonds to 100 */
      b=RI(11,89); if(b%10===0) b+=RI(1,9);
      return { t:'100 − '+b+' =', a:100-b };
    }
    if(shape==='bond50'){
      b=RI(11,39); if(b%10===0) b+=RI(1,9);
      return { t:'50 − '+b+' =', a:50-b };
    }
    if(shape==='neardouble'){                    /* near doubles */
      a=RI(12,49); b=a+pick([-2,-1,0,1,2]);
      if(b<2) b=a+1;
      return { t:a+' + '+b+' =', a:a+b };
    }
    if(shape==='bridge'){                        /* bridging a ten */
      if(Math.random()<0.5){
        a=RI(2,9)*10 + RI(3,9); b=RI(3,9);
        return { t:a+' + '+b+' =', a:a+b };
      }
      a=RI(2,9)*10 + RI(1,5); b=RI(6,9);
      return { t:a+' − '+b+' =', a:a-b };
    }
    if(shape==='multiple10'){                    /* add or take a multiple of ten */
      a=RI(11,79); b=RI(2,6)*10;
      if(Math.random()<0.5) return { t:a+' + '+b+' =', a:a+b };
      if(a<=b) a=b+RI(1,20);
      return { t:a+' − '+b+' =', a:a-b };
    }
    a=RI(12,89); b=RI(12,49);                    /* general two-digit */
    if(Math.random()<0.5) return { t:a+' + '+b+' =', a:a+b };
    if(a<=b){ var sw=a; a=b; b=sw; }
    if(a===b) b=Math.max(2,b-RI(1,5));
    return { t:a+' − '+b+' =', a:a-b };
  }

  /* ---- Times & Divide: hard facts come up far more than free ones ---- */
  var TW={2:1,3:3,4:3,5:2,6:4,7:6,8:6,9:6,10:1,11:2,12:5};
  var TPAIRS=[];
  (function(){
    for(var a=2;a<=12;a++) for(var b=2;b<=12;b++) TPAIRS.push([[a,b], TW[a]*TW[b]]);
  })();
  function qTables(){
    var shape=weighted([['mul',7],['div',5],['missing',3],['tens',3],['dh',2],['rem',2],['triple',2]]);
    var p=weighted(TPAIRS), a=p[0], b=p[1], prod=a*b, d, v, t10;
    if(shape==='mul') return { t:a+' × '+b+' =', a:prod };
    if(shape==='div'){ d=(Math.random()<0.5?a:b); return { t:prod+' ÷ '+d+' =', a:prod/d }; }
    /* the same fact asked backwards, which is where the gaps usually show */
    if(shape==='missing'){
      if(Math.random()<0.5) return { t:a+' × □ = '+prod, a:b, list:true };
      return { t:'□ × '+b+' = '+prod, a:a, list:true };
    }
    if(shape==='tens'){
      t10=RI(2,9)*10;
      if(Math.random()<0.5) return { t:a+' × '+t10+' =', a:a*t10 };
      return { t:(a*t10)+' ÷ '+t10+' =', a:a };
    }
    if(shape==='dh'){
      if(Math.random()<0.5){ v=RI(13,99); return { t:'Double '+v, a:v*2, list:true }; }
      v=RI(11,60)*2; return { t:'Half of '+v, a:v/2, list:true };
    }
    if(shape==='rem'){
      d=pick([3,4,5,6,7,8,9]);
      var r=RI(1,d-1);
      return { t:'What is the remainder when '+(d*RI(3,12)+r)+' is divided by '+d+'?', a:r, list:true };
    }
    var f1=pick([2,3,4,5]), f2=pick([2,3,4,5]), f3=RI(2,9);
    return { t:f1+' × '+f2+' × '+f3+' =', a:f1*f2*f3 };
  }

  /* ---- Powers & Roots: pool widened so a long run stops repeating ---- */
  var SUPD=['⁰','¹','²','³','⁴','⁵','⁶','⁷','⁸','⁹'];
  /* superscript any number, so 2¹⁰ renders instead of breaking the lookup */
  function sup(n){ return String(n).split('').map(function(d){ return SUPD[+d]; }).join(''); }
  /* Squares and roots stop at 15², plus the round tens 20 to 100. Cubes stop at 6³. */
  var SQ_TENS=[20,30,40,50,60,70,80,90,100];
  var CB_TENS=[10,20];        /* 30³ and 40³ ask for five and six digit answers */
  function sqRoot(){ return Math.random()<0.62 ? RI(2,15) : pick(SQ_TENS); }
  function cbRoot(){ return Math.random()<0.66 ? RI(2,6) : pick(CB_TENS); }
  /* a drawn radical: tick plus a bar over the number, small index for a cube root */
  function rt(n, i){ return '<span class="qm-rt'+(i ? ' qm-rt-x' : '')+'">'+(i ? '<span class="qm-rt-i">'+i+'</span>' : '')+'<span class="qm-rt-r">'+n+'</span></span>'; }
  function qPowers(){
    var shape=weighted([['sq',4],['sqrt',4],['cube',2],['cbrt',2],['index',2],
                        ['rsq',3],['rcube',2],['sumsq',2],['diffsq',2],['rootpair',2],['rootmul',2],['ten',2]]);
    var n, a, b, sw;
    if(shape==='sq'){   n=sqRoot(); return { t:n+'² =', a:n*n }; }
    if(shape==='sqrt'){ n=sqRoot(); return { t:rt(n*n)+' =', a:n, html:true }; }
    if(shape==='cube'){ n=cbRoot(); return { t:n+'³ =', a:n*n*n }; }
    if(shape==='cbrt'){ n=cbRoot(); return { t:rt(n*n*n,3)+' =', a:n, html:true }; }
    /* backwards: given the square or cube, name the root */
    if(shape==='rsq'){   n=RI(2,15); return { t:'□² = '+(n*n), a:n, list:true }; }
    if(shape==='rcube'){ n=RI(2,6);  return { t:'□³ = '+(n*n*n), a:n, list:true }; }
    /* two powers in one line, still one mental step each */
    if(shape==='sumsq'){  a=RI(2,10); b=RI(2,10); return { t:a+'² + '+b+'² =', a:a*a+b*b }; }
    if(shape==='diffsq'){ a=RI(4,13); b=RI(2,a-1); return { t:a+'² − '+b+'² =', a:a*a-b*b }; }
    if(shape==='rootpair'){
      a=RI(2,12); b=RI(2,12);
      if(Math.random()<0.5) return { t:rt(a*a)+' + '+rt(b*b)+' =', a:a+b, html:true };
      if(a<b){ sw=a; a=b; b=sw; }
      return { t:rt(a*a)+' − '+rt(b*b)+' =', a:a-b, html:true };
    }
    if(shape==='rootmul'){ a=RI(2,9); b=RI(2,9); return { t:rt(a*a)+' × '+b+' =', a:a*b, html:true }; }
    if(shape==='ten'){ n=RI(2,4); return { t:'10'+sup(n)+' =', a:Math.pow(10,n) }; }
    var base=weighted([[2,5],[3,3],[5,2]]);   /* 10ⁿ has its own shape above, so it stays out of the cube list */
    var maxp = base===2 ? 6 : base===3 ? 4 : 3;   /* 2⁷ and 2⁸ sit above the rest of the pool */
    n=RI(2,maxp);
    return { t:String(base)+sup(n)+' =', a:Math.pow(base,n) };
  }

  /* ---- Negatives, written without brackets ---- */
  function qNegatives(){
    var shape=weighted([['submore',3],['addneg',3],['subneg',3],['mul',3],['div',2],
                        ['temp',3],['diff',3],['twostep',3],['order',2],['lessthan',2]]);
    var a, b, c;
    if(shape==='submore'){ b=RI(4,20); a=RI(1,b-1); return { t:a+' − '+b+' =', a:a-b }; }
    if(shape==='addneg'){ a=-RI(2,20); b=RI(1,25); return { t:lead(a)+' + '+b+' =', a:a+b }; }
    if(shape==='subneg'){ a=-RI(2,18); b=RI(1,18); return { t:lead(a)+' − '+b+' =', a:a-b }; }
    if(shape==='mul'){ a=-RI(2,12); b=RI(2,12); return { t:lead(a)+' × '+b+' =', a:a*b }; }
    if(shape==='div'){
      var d=pick([2,3,4,5,6]);
      a=-(d*RI(2,12));
      return { t:lead(a)+' ÷ '+d+' =', a:a/d };
    }
    /* temperature is where negatives are actually met, and it makes the
       direction of travel concrete instead of a rule about signs */
    if(shape==='temp'){
      a=-RI(2,15); b=RI(3,22);
      if(Math.random()<0.55) return { t:'The temperature is '+lead(a)+'°C and rises by '+b+'°C. What is it now?', a:a+b, list:true };
      a=RI(2,12); b=RI(a+2, a+18);
      return { t:'The temperature is '+a+'°C and falls by '+b+'°C. What is it now?', a:a-b, list:true };
    }
    if(shape==='diff'){
      a=-RI(2,16); b=RI(1,18);
      return { t:'How many degrees are there between '+lead(a)+'°C and '+b+'°C?', a:b-a, list:true };
    }
    if(shape==='twostep'){
      a=-RI(3,15); b=RI(2,20); c=RI(2,20);
      return { t:lead(a)+' + '+b+' − '+c+' =', a:a+b-c };
    }
    if(shape==='lessthan'){
      a=-RI(1,12); b=RI(2,15);
      return { t:'What is '+b+' less than '+lead(a)+'?', a:a-b, list:true };
    }
    /* which of three is smallest: press 1, 2 or 3 */
    var vals=[-RI(1,20), -RI(1,20), RI(1,15)];
    while(vals[0]===vals[1]) vals[1]=-RI(1,20);
    vals=shuffle(vals);
    var lo=Math.min.apply(null, vals);
    return { t:'Which is the smallest?', a:vals.indexOf(lo)+1, choices:vals.map(function(v){ return lead(v); }), list:true };
  }

  /* ---- Percentages: both directions, plus increase and decrease ---- */
  var PCT_STEP = { 1:100, 5:20, 10:10, 15:20, 20:5, 25:4, 30:10, 35:20, 40:5, 45:20, 50:2, 60:5, 75:4, 80:5, 90:10 };
  function pctBase(p, cap){
    var step=PCT_STEP[p];
    var maxK=Math.max(2, Math.min(50, Math.floor((cap||500)/step)));
    return step*RI(1,maxK);
  }
  function qPercentages(){
    var shape=weighted([['of',5],['whatpc',3],['increase',2],['decrease',2],
                        ['reverse',3],['dec2pc',2],['sale',3],['left',2]]);
    var p, base;
    if(shape==='of'){
      p=pick([1,5,10,15,20,25,30,35,40,45,50,60,75,80,90]);
      base=pctBase(p);
      return { t:p+'% of '+base+' =', a:Math.round(p*base/100) };
    }
    /* given the part, find the whole: the step most children skip */
    if(shape==='reverse'){
      p=pick([10,20,25,50]);
      base=pctBase(p, 300);
      return { t:p+'% of a number is '+Math.round(p*base/100)+'. What is the number?', a:base, list:true };
    }
    if(shape==='dec2pc'){
      var d=pick([0.05,0.1,0.15,0.2,0.25,0.3,0.4,0.5,0.6,0.7,0.75,0.8,0.9]);
      return { t:'Write '+nstr(d)+' as a percentage', a:Math.round(d*100), list:true };
    }
    if(shape==='sale'){
      p=pick([10,20,25,50]);
      base=pctBase(p, 200);
      if(base<20) base=20+base;
      var off=Math.round(p*base/100);
      return { t:'A £'+base+' coat has '+p+'% off. What is the sale price in pounds?', a:base-off, list:true };
    }
    if(shape==='left'){
      p=pick([10,20,25,30,40,60,75,80]);
      base=pctBase(p, 100);
      return { t:'A test has '+base+' marks. A child scores '+p+'%. How many marks is that?', a:Math.round(p*base/100), list:true };
    }
    if(shape==='whatpc'){
      p=pick([5,10,20,25,50,75]);
      base=pctBase(p, 200);
      var part=Math.round(p*base/100);
      return { t:part+' out of '+base+' = □%', a:p, list:true };
    }
    p=pick([5,10,20,25,50]);
    base=pctBase(p, 300);
    if(shape==='increase') return { t:'Increase '+base+' by '+p+'%', a:base+Math.round(p*base/100), list:true };
    return { t:'Decrease '+base+' by '+p+'%', a:base-Math.round(p*base/100), list:true };
  }

  function qPowers10(){
    var shape=weighted([['mul',5],['div',5],['index',2],['howmany',3],['hundredth',3],['chain',2]]);
    var pow=pick([10,100,1000]);
    /* × 1,000 keeps the starting number small, so no answer runs past five digits */
    var m = Math.random()<0.5 ? RI(2, pow===1000 ? 30 : 99) : round(RI(11,199)/10,1);
    if(shape==='mul') return { t:nstr(m)+' × '+pow+' =', a:round(m*pow,4) };
    if(shape==='div') return { t:nstr(round(m*pow,4))+' ÷ '+pow+' =', a:m };
    /* the same move written in index form, which is how papers print it */
    if(shape==='index'){
      var e=RI(1,3), p=Math.pow(10,e);
      if(Math.random()<0.5) return { t:nstr(m)+' × 10'+sup(e)+' =', a:round(m*p,4) };
      return { t:nstr(round(m*p,4))+' ÷ 10'+sup(e)+' =', a:m };
    }
    if(shape==='howmany'){
      var unit=pick([10,100,1000]), k=RI(11,99);
      return { t:'How many '+unit.toLocaleString('en-GB')+'s are there in '+(unit*k).toLocaleString('en-GB')+'?', a:k, list:true };
    }
    /* dividing past the decimal point, where the digits move the other way */
    if(shape==='hundredth'){
      var w=RI(2,99);
      if(Math.random()<0.5) return { t:w+' ÷ 100 =', a:round(w/100,2) };
      return { t:nstr(round(w/100,2))+' × 100 =', a:w };
    }
    var start=RI(2,99);
    return { t:start+' × 100 ÷ 10 =', a:start*10 };
  }

  /* ---- Decimals: four operations plus money ---- */
  function dec1(lo,hi){ return round(RI(lo,hi) + RI(1,9)/10, 1); }
  function qDecimals(){
    var shape=weighted([['add',3],['sub',3],['mul',2],['div',2],['money',2],
                        ['toone',3],['tenths',2],['double',2],['order',2]]);
    var a,b;
    /* complements to 1 and to 10, the decimal version of number bonds */
    if(shape==='toone'){
      var t1=pick([1,1,10]);
      if(t1===1){ a=round(RI(1,99)/100,2); return { t:'1 − '+nstr(a)+' =', a:round(1-a,2) }; }
      a=round(RI(1,95)/10,1); return { t:'10 − '+nstr(a)+' =', a:round(10-a,1) };
    }
    if(shape==='tenths'){                             /* 0.3 × 0.4 = 0.12 */
      a=RI(2,9); b=RI(2,9);
      return { t:nstr(round(a/10,1))+' × '+nstr(round(b/10,1))+' =', a:round(a*b/100,2) };
    }
    if(shape==='double'){
      a=round(RI(11,89)/10,1);
      if(Math.random()<0.5) return { t:'Double '+nstr(a), a:round(a*2,1), list:true };
      a=round(RI(11,89)*2/10,1);
      return { t:'Half of '+nstr(a), a:round(a/2,2), list:true };
    }
    if(shape==='order'){                              /* which is largest: 1, 2 or 3 */
      var vals=[], i, v;
      while(vals.length<3){
        v=round(RI(11,99)/(Math.random()<0.5?10:100), 2);
        if(vals.indexOf(v)===-1) vals.push(v);
      }
      var big=Math.max.apply(null, vals);
      return { t:'Which is the largest?', a:vals.indexOf(big)+1, choices:vals.map(nstr), list:true };
    }
    if(shape==='add'){ a=dec1(0,19); b=dec1(0,19); return { t:nstr(a)+' + '+nstr(b)+' =', a:round(a+b,1) }; }
    if(shape==='sub'){
      a=dec1(5,19);
      b=round(RI(0, Math.floor(a)-1) + RI(1,9)/10, 1);
      return { t:nstr(a)+' − '+nstr(b)+' =', a:round(a-b,1) };
    }
    /* Every decimal multiply and divide is built on a times-table fact, so it
       stays one mental step instead of long multiplication. */
    var f1,f2,w,tenth;
    if(shape==='mul'){
      if(Math.random()<0.55){
        f1=RI(2,9); f2=RI(2,9);                       /* 0.7 × 8 = 5.6 */
        return { t:nstr(round(f1/10,1))+' × '+f2+' =', a:round(f1*f2/10,2) };
      }
      w=RI(1,4); tenth=RI(1,9);                       /* 2.4 × 6 = 14.4 */
      a=round(w+tenth/10,1); b=RI(2,6);
      return { t:nstr(a)+' × '+b+' =', a:round(a*b,2) };
    }
    if(shape==='div'){
      if(Math.random()<0.55){
        f1=RI(2,9); f2=RI(2,9);                       /* 5.6 ÷ 8 = 0.7 */
        return { t:nstr(round(f1*f2/10,1))+' ÷ '+f2+' =', a:round(f1/10,2) };
      }
      w=RI(1,4); tenth=RI(1,9);                       /* 14.4 ÷ 6 = 2.4 */
      var q2=round(w+tenth/10,1), dv=RI(2,6);
      return { t:nstr(round(q2*dv,2))+' ÷ '+dv+' =', a:q2 };
    }
    /* Money uses pence people actually meet, and always prints two places. */
    var PENCE=[0,5,10,20,25,30,40,50,60,70,75,80,90,95,99];
    var m2=function(v){ return v.toFixed(2); };
    a=round(RI(2,19) + pick(PENCE)/100, 2);
    b=round(RI(1,9)  + pick(PENCE)/100, 2);
    if(Math.random()<0.5) return { t:m2(a)+' + '+m2(b)+' =', a:round(a+b,2) };
    if(b>=a) b=round(RI(1, Math.max(1,Math.floor(a)-1)) + pick(PENCE)/100, 2);
    if(b>=a) b=round(a-1,2);
    return { t:m2(a)+' − '+m2(b)+' =', a:round(a-b,2) };
  }

  /* ---- Fractions: of an amount, equivalent, as a percentage, and adding ---- */
  function gcd(a,b){ while(b){ var t=b; b=a%b; a=t; } return a; }
  function frac(n,d){ return '<span class="frac"><sup>'+n+'</sup>⁄<sub>'+d+'</sub></span>'; }
  function qFractions(){
    var shape=weighted([['of',4],['equiv',3],['aspc',2],['addsub',2],
                        ['simplify',3],['improper',2],['whole',2],['compare',2],['leftover',2]]);
    var d, n, guard=0, base;
    /* cancelling down, given the denominator it has to land on */
    if(shape==='simplify'){
      do { d=pick([2,3,4,5,6,8,10]); n=RI(1,d-1); guard++; } while(gcd(n,d)!==1 && guard<20);
      var k=RI(2,9);
      return { t:frac(n*k,d*k)+' = <span class="frac"><sup>□</sup>⁄<sub>'+d+'</sub></span>', a:n, html:true,
               plain:(n*k)+'/'+(d*k)+' = □/'+d };
    }
    if(shape==='improper'){
      do { d=pick([2,3,4,5,6,8]); n=RI(1,d-1); guard++; } while(gcd(n,d)!==1 && guard<20);
      var w=RI(1,5);
      return { t:w+frac(n,d)+' = <span class="frac"><sup>□</sup>⁄<sub>'+d+'</sub></span>', a:w*d+n, html:true,
               plain:w+' '+n+'/'+d+' = □/'+d };
    }
    /* the whole from a part, the reverse of "fraction of an amount" */
    if(shape==='whole'){
      d=pick([2,3,4,5,6,8,10]);
      var part=RI(2,12);
      return { t:frac(1,d)+' of a number is '+part+'. What is the number?', a:part*d, html:true, list:true,
               plain:'1/'+d+' of a number is '+part+'. What is the number?' };
    }
    if(shape==='compare'){                 /* which is bigger: press 1 or 2 */
      var opts=[[1,2],[1,3],[2,3],[1,4],[3,4],[2,5],[3,5],[4,5],[1,6],[5,6],[3,8],[5,8],[7,10],[3,10]];
      var f1=pick(opts), f2=pick(opts), tries=0;
      while(tries<30 && f1[0]/f1[1]===f2[0]/f2[1]){ f2=pick(opts); tries++; }
      var bigger = (f1[0]/f1[1] > f2[0]/f2[1]) ? 1 : 2;
      return { t:'Which is bigger?', a:bigger, choices:[f1[0]+'/'+f1[1], f2[0]+'/'+f2[1]], list:true };
    }
    if(shape==='leftover'){
      d=pick([4,5,6,8,10,12]); n=RI(1,d-2);
      return { t:frac(n,d)+' of a cake is eaten. What fraction is left, out of '+d+'?', a:d-n, html:true, list:true,
               plain:n+'/'+d+' of a cake is eaten. What fraction is left, out of '+d+'?' };
    }
    if(shape==='of'){
      do { d=pick([2,3,4,5,6,8,10]); n=RI(1,d-1); guard++; } while(gcd(n,d)!==1 && guard<20);
      base=d*RI(2,12);
      return { t:frac(n,d)+' of '+base+' =', a:(base/d)*n, html:true };
    }
    if(shape==='equiv'){
      do { d=pick([2,3,4,5,6,8,10]); n=RI(1,d-1); guard++; } while(gcd(n,d)!==1 && guard<20);
      var mult=RI(2,9), nd=d*mult;
      return { t:frac(n,d)+' = <span class="frac"><sup>□</sup>⁄<sub>'+nd+'</sub></span>', a:n*mult, html:true };
    }
    if(shape==='aspc'){
      var opt=pick([[1,2,50],[1,4,25],[3,4,75],[1,5,20],[2,5,40],[3,5,60],[4,5,80],[1,10,10],[3,10,30],[7,10,70],[1,20,5],[1,100,1]]);
      return { t:frac(opt[0],opt[1])+' as a % =', a:opt[2], html:true };
    }
    d=pick([5,6,7,8,9,10,12]);
    var n1=RI(1,d-2), n2=RI(1,d-n1-1<1?1:d-n1-1);
    if(Math.random()<0.5){
      return { t:frac(n1,d)+' + '+frac(n2,d)+' = <span class="frac"><sup>□</sup>⁄<sub>'+d+'</sub></span>', a:n1+n2, html:true };
    }
    var big=n1+n2;
    return { t:frac(big,d)+' − '+frac(n2,d)+' = <span class="frac"><sup>□</sup>⁄<sub>'+d+'</sub></span>', a:n1, html:true };
  }

  /* ---- Algebra: solve and substitute, never a negative right-hand side ---- */
  function qAlgebra(){
    var shape=weighted([['one',4],['two',3],['sub',3],
                        ['collect',3],['twovar',3],['square',2],['expand',2],['divsolve',2]]);
    var x,c,m,k;
    /* collecting like terms: the answer is the number of x's */
    if(shape==='collect'){
      var t1=RI(2,9), t2=RI(2,9);
      if(Math.random()<0.6) return { t:t1+'<i>x</i> + '+t2+'<i>x</i> = □<i>x</i>', a:t1+t2, html:true };
      if(t1<t2){ var sw=t1; t1=t2; t2=sw; }
      if(t1===t2) t1=t2+RI(1,5);
      return { t:t1+'<i>x</i> − '+t2+'<i>x</i> = □<i>x</i>', a:t1-t2, html:true };
    }
    if(shape==='twovar'){
      x=RI(2,9); var y=RI(2,9);
      if(Math.random()<0.5) return { t:'If <i>x</i> = '+x+' and <i>y</i> = '+y+',  <i>xy</i> =', a:x*y, html:true, list:true };
      m=pick([2,3,4,5]);
      return { t:'If <i>x</i> = '+x+' and <i>y</i> = '+y+',  '+m+'<i>x</i> + <i>y</i> =', a:m*x+y, html:true, list:true };
    }
    if(shape==='square'){
      x=RI(2,9); k=RI(1,12);
      if(Math.random()<0.5) return { t:'If <i>x</i> = '+x+',  <i>x</i>² =', a:x*x, html:true, list:true };
      return { t:'If <i>x</i> = '+x+',  <i>x</i>² + '+k+' =', a:x*x+k, html:true, list:true };
    }
    if(shape==='expand'){
      c=pick([2,3,4,5,6]); k=RI(2,9);
      return { t:c+'(<i>x</i> + '+k+') = '+c+'<i>x</i> + □', a:c*k, html:true };
    }
    if(shape==='divsolve'){
      c=pick([2,3,4,5]); x=RI(2,12)*c; k=RI(1,10);
      return { t:'<i>x</i> ÷ '+c+' + '+k+' = '+(x/c+k), a:x, html:true };
    }
    if(shape==='one'){
      var type=pick(['add','sub','mul','div']);
      if(type==='add'){ x=RI(1,15); c=RI(1,15); return { t:'<i>x</i> + '+c+' = '+(x+c), a:x, html:true }; }
      if(type==='sub'){ x=RI(6,25); c=RI(1,5);  return { t:'<i>x</i> − '+c+' = '+(x-c), a:x, html:true }; }
      if(type==='mul'){ x=RI(2,12); c=pick([2,3,4,5,6]); return { t:c+'<i>x</i> = '+(c*x), a:x, html:true }; }
      c=pick([2,3,4,5]); x=RI(2,12); return { t:'<i>x</i> ÷ '+c+' = '+x, a:x*c, html:true };
    }
    if(shape==='two'){
      x=RI(1,9); m=pick([2,3,4,5]);
      if(Math.random()<0.5){
        k=RI(1,12);
        return { t:m+'<i>x</i> + '+k+' = '+(m*x+k), a:x, html:true };
      }
      k=RI(1, Math.max(1, m*x-1));          /* keeps the answer side positive */
      return { t:m+'<i>x</i> − '+k+' = '+(m*x-k), a:x, html:true };
    }
    x=RI(2,10); m=pick([2,3,4,5,6]); k=RI(1,12);
    if(Math.random()<0.4) return { t:'If <i>x</i> = '+x+',  '+m+'<i>x</i> =', a:m*x, html:true, list:true };
    if(Math.random()<0.5) return { t:'If <i>x</i> = '+x+',  '+m+'<i>x</i> + '+k+' =', a:m*x+k, html:true, list:true };
    k=RI(1, m*x-1);
    return { t:'If <i>x</i> = '+x+',  '+m+'<i>x</i> − '+k+' =', a:m*x-k, html:true, list:true };
  }

  /* ---- Averages: median now uses even-length lists too ---- */
  function qAverages(){
    var type=weighted([['Mean',4],['Median',4],['Mode',4],['Range',4],['total',2],['missing',2],['pair',1]]);
    var nums=[], a, i, count;
    /* working back from an average, not just to one */
    if(type==='total'){
      a=RI(3,15); count=pick([3,4,5,6]);
      return { t:'The mean of '+count+' numbers is '+a+'. What is their total?', a:a*count, list:true };
    }
    if(type==='missing'){
      count=pick([3,4]);
      var known=[], sum=0, miss=0, tries=0, v;
      do {
        known=[]; sum=0;
        for(i=0;i<count-1;i++){ v=RI(2,15); known.push(v); sum+=v; }
        miss=RI(2,15); tries++;
      } while((sum+miss)%count!==0 && tries<50);
      if((sum+miss)%count!==0){ count=3; known=[4,6]; sum=10; miss=7; }
      var WORDN={2:'Two',3:'Three',4:'four',5:'five'};
      var listed = known.length>1 ? known.slice(0,-1).join(', ')+' and '+known[known.length-1] : String(known[0]);
      return { t:WORDN[count-1]+' of '+(count===3?'three':'four')+' numbers are '+listed
                 +'. The mean of all '+(count===3?'three':'four')+' is '+((sum+miss)/count)+'. What is the missing number?',
               a:miss, list:true };
    }
    if(type==='pair'){
      a=RI(6,20); var gap=pick([2,4,6,8]);
      return { t:'Two numbers have a range of '+gap+'. The smaller is '+a+'. What is the larger?', a:a+gap, list:true };
    }
    if(type==='Mean'){
      var mean=RI(4,20), tries=0, low=true;
      while(low && tries<30){
        count=pick([3,4,4,5,5,6]);
        var offs=[], sum=0, o;
        for(i=0;i<count-1;i++){ o=RI(-Math.min(mean-1,6), 6); offs.push(o); sum+=o; }
        offs.push(-sum);
        nums=offs.map(function(v){ return mean+v; });
        low=false;
        for(i=0;i<nums.length;i++){ if(nums[i]<1){ low=true; break; } }
        tries++;
      }
      if(low) nums=[mean,mean,mean];
      nums=shuffle(nums); a=mean;
    } else if(type==='Median'){
      count=pick([3,4,5,6]);
      if(count%2===0){
        /* Even list: the two middle values must average to a whole number, AND
           exactly half the remaining values must sit each side of them, or the
           pair picked is not actually in the middle once the list is sorted. */
        var half=(count-2)/2;
        var mid=RI(5,18), gap=pick([0,2,4]);
        var lowMid=mid, highMid=mid+gap;
        a=(lowMid+highMid)/2;
        nums=[lowMid, highMid];
        for(i=0;i<half;i++) nums.push(RI(1, lowMid-1));
        for(i=0;i<half;i++) nums.push(RI(highMid+1, highMid+14));
        nums=shuffle(nums);
      } else {
        for(i=0;i<count;i++) nums.push(RI(1,25));
        var sorted=nums.slice().sort(function(p,q){ return p-q; });
        a=sorted[Math.floor(count/2)];
      }
    } else if(type==='Mode'){
      var mv=RI(1,12);
      count=pick([5,6,7]);
      nums=[mv,mv,mv];
      while(nums.length<count){ var n2=RI(1,15); if(n2!==mv && nums.indexOf(n2)===-1) nums.push(n2); }
      nums=shuffle(nums); a=mv;
    } else {
      count=pick([4,5,6]);
      for(i=0;i<count;i++) nums.push(RI(1,40));
      a=Math.max.apply(null,nums)-Math.min.apply(null,nums);
    }
    return { t:type+' of '+nums.join(', '), a:a, list:true };
  }

  /* ---- BIDMAS: order of operations ---- */
  function qBidmas(){
    var shape=weighted([['addmul',4],['submul',3],['adddiv',3],['bracket',4],['power',2],
                        ['divbracket',3],['twoproducts',3],['bracketsq',2],['bracketdiv',2]]);
    var a,b,c,d;
    /* the bracket has to go first even though the division is written first */
    if(shape==='divbracket'){
      b=RI(2,9); c=RI(1,b-1>0?b-1:1);
      var q=RI(2,9);
      return { t:((b+c)*q)+' ÷ ('+b+' + '+c+') =', a:q };
    }
    if(shape==='twoproducts'){
      a=RI(2,9); b=RI(2,9); c=RI(2,9); d=RI(2,9);
      return { t:a+' × '+b+' + '+c+' × '+d+' =', a:a*b+c*d };
    }
    if(shape==='bracketsq'){
      a=RI(4,12); b=RI(1,a-2);
      return { t:'('+a+' − '+b+')² =', a:(a-b)*(a-b) };
    }
    if(shape==='bracketdiv'){
      c=pick([2,3,4,5]); d=RI(2,9); a=RI(2,20);
      return { t:'('+(c*d)+' ÷ '+c+') + '+a+' =', a:d+a };
    }
    if(shape==='addmul'){ a=RI(2,20); b=RI(2,9); c=RI(2,9); return { t:a+' + '+b+' × '+c+' =', a:a+b*c }; }
    if(shape==='submul'){ b=RI(2,8); c=RI(2,8); a=b*c+RI(1,20); return { t:a+' − '+b+' × '+c+' =', a:a-b*c }; }
    if(shape==='adddiv'){ c=pick([2,3,4,5]); d=RI(2,9); b=c*d; a=RI(2,25);
      if(Math.random()<0.5) return { t:a+' + '+b+' ÷ '+c+' =', a:a+d };
      a=d+RI(1,20); return { t:a+' − '+b+' ÷ '+c+' =', a:a-d }; }
    if(shape==='bracket'){ a=RI(2,15); b=RI(1,a-1>0?a-1:1); c=RI(2,9);
      if(Math.random()<0.5) return { t:'('+a+' + '+b+') × '+c+' =', a:(a+b)*c };
      return { t:'('+a+' − '+b+') × '+c+' =', a:(a-b)*c }; }
    b=RI(2,9); a=RI(2,25);
    if(Math.random()<0.5) return { t:a+' + '+b+'² =', a:a+b*b };
    a=b*b+RI(1,20); return { t:a+' − '+b+'² =', a:a-b*b };
  }

  /* ---- Rounding and place value ---- */
  function qRounding(){
    var shape=weighted([['ten',3],['hundred',3],['thousand',2],['dp1',3],['whole',2]]);
    var n;
    if(shape==='ten'){ n=RI(11,999); return { t:'Round '+n+' to the nearest 10', a:Math.round(n/10)*10, list:true }; }
    if(shape==='hundred'){ n=RI(120,9999); return { t:'Round '+n.toLocaleString('en-GB')+' to the nearest 100', a:Math.round(n/100)*100, list:true }; }
    if(shape==='thousand'){ n=RI(1200,89999); return { t:'Round '+n.toLocaleString('en-GB')+' to the nearest 1,000', a:Math.round(n/1000)*1000, list:true }; }
    if(shape==='dp1'){
      n=round(RI(105,9995)/100,2);
      return { t:'Round '+nstr(n)+' to 1 d.p.', a:round(Math.round(n*10)/10,1), list:true };
    }
    n=round(RI(105,4995)/100,2);
    return { t:'Round '+nstr(n)+' to the nearest whole number', a:Math.round(n), list:true };
  }

  /* ---- Calendar and dates: month lengths, spans and leap years ---- */
  var MONTHS=[
    ['January',31],['February',28],['March',31],['April',30],['May',31],['June',30],
    ['July',31],['August',31],['September',30],['October',31],['November',30],['December',31]
  ];
  var WEEKDAYS=['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];
  function ord(n){
    if(n>=11 && n<=13) return n+'th';
    var last=n%10;
    return n + (last===1?'st':last===2?'nd':last===3?'rd':'th');
  }
  /* February is asked on its own, because "how many days" needs the leap year said out loud */
  function monthIdx(){ var i=RI(0,11); return i===1 ? RI(2,11) : i; }
  function mName(i){ return MONTHS[((i%12)+12)%12][0]; }
  function mLen(i){ return MONTHS[((i%12)+12)%12][1]; }
  function qCalendar(){
    var shape=weighted([['days',4],['feb',2],['pair',2],['num',2],['fact',2],['span',3],['cross',3],['weekday',3],['left',2],['leap',2],['weeks',2],
                        ['fwd',3],['back',3],['long',3],['crossweek',3],['febspan',2]]);
    var i, m, len, d1, d2, y, n;
    if(shape==='days'){
      i=monthIdx(); m=MONTHS[i];
      return { t:'How many days are there in '+m[0]+'?', a:m[1], list:true };
    }
    if(shape==='feb'){
      if(Math.random()<0.5) return { t:'How many days are there in February in a leap year?', a:29, list:true };
      return { t:'How many days are there in February in a normal year?', a:28, list:true };
    }
    if(shape==='pair'){
      i=RI(2,10); /* consecutive pair that never touches February */
      return { t:'How many days are there in '+MONTHS[i][0]+' and '+MONTHS[i+1][0]+' altogether?', a:MONTHS[i][1]+MONTHS[i+1][1], list:true };
    }
    if(shape==='num'){
      i=RI(0,11);
      return { t:'Which number month of the year is '+MONTHS[i][0]+'?', a:i+1, list:true };
    }
    if(shape==='fact'){
      n=RI(2,9);
      return pick([
        { t:'How many days are there in a normal year?', a:365, list:true },
        { t:'How many days are there in a leap year?', a:366, list:true },
        { t:'How many whole weeks are there in a year?', a:52, list:true },
        { t:'How many months of the year have 31 days?', a:7, list:true },
        { t:'How many months are there in '+n+' years?', a:n*12, list:true }
      ]);
    }
    if(shape==='span'){
      i=monthIdx(); len=MONTHS[i][1];
      d1=RI(1,len-9); d2=RI(d1+4,len);
      return { t:'From '+d1+' to '+d2+' '+MONTHS[i][0]+' is how many days?', a:d2-d1, list:true };
    }
    if(shape==='cross'){
      i=monthIdx(); len=MONTHS[i][1];
      d1=RI(len-6,len-1); d2=RI(2,9);
      return { t:'From '+d1+' '+MONTHS[i][0]+' to '+d2+' '+MONTHS[(i+1)%12][0]+' is how many days?', a:(len-d1)+d2, list:true };
    }
    if(shape==='weekday'){
      i=monthIdx(); len=MONTHS[i][1];
      var day=pick(WEEKDAYS);
      if(Math.random()<0.5){
        d1=RI(1,len-7);
        return { t:'The '+ord(d1)+' of '+MONTHS[i][0]+' is a '+day+'. What is the date of the next '+day+'?', a:d1+7, list:true };
      }
      d1=RI(8,len);
      return { t:'The '+ord(d1)+' of '+MONTHS[i][0]+' is a '+day+'. What was the date of the '+day+' before?', a:d1-7, list:true };
    }
    if(shape==='left'){
      i=monthIdx(); len=MONTHS[i][1]; d1=RI(4,len-2);
      return { t:'How many days of '+MONTHS[i][0]+' are left after the '+ord(d1)+'?', a:len-d1, list:true };
    }
    /* Counting on past the end of a month: the answer is a date in the next one,
       so the month length has to be recalled and subtracted, not just added to. */
    if(shape==='fwd'){
      i=monthIdx(); len=MONTHS[i][1];
      d1=RI(len-9,len-1);
      n=RI(len-d1+1, len-d1+16);
      return { t:n+' days after the '+ord(d1)+' of '+mName(i)+' lands in '+mName(i+1)+'. What is the date?', a:d1+n-len, list:true };
    }
    /* Counting back before the start of a month. February is kept out of the
       previous slot so the leap year never changes the answer. */
    if(shape==='back'){
      i=monthIdx(); if(i===2) i=RI(3,11);
      var prevLen=mLen(i-1);
      d1=RI(1,9);
      n=RI(d1+1, d1+16);
      return { t:n+' days before the '+ord(d1)+' of '+mName(i)+' lands in '+mName(i-1)+'. What is the date?', a:prevLen-(n-d1), list:true };
    }
    /* A span across two month ends. March to October only, so the middle month
       is never February. */
    if(shape==='long'){
      i=RI(2,9); len=MONTHS[i][1];
      d1=RI(len-14,len-2); d2=RI(2,12);
      return { t:'From the '+ord(d1)+' of '+mName(i)+' to the '+ord(d2)+' of '+mName(i+2)+' is how many days?', a:(len-d1)+MONTHS[i+1][1]+d2, list:true };
    }
    /* Same weekday, but the week runs over the month end or back over the start. */
    if(shape==='crossweek'){
      var wday=pick(WEEKDAYS);
      if(Math.random()<0.5){
        i=monthIdx(); len=MONTHS[i][1]; d1=RI(len-6,len);
        return { t:'The '+ord(d1)+' of '+mName(i)+' is a '+wday+'. The next '+wday+' is in '+mName(i+1)+'. What is the date?', a:d1+7-len, list:true };
      }
      i=monthIdx(); if(i===2) i=RI(3,11);
      d1=RI(1,7);
      return { t:'The '+ord(d1)+' of '+mName(i)+' is a '+wday+'. The '+wday+' before was in '+mName(i-1)+'. What is the date?', a:mLen(i-1)+d1-7, list:true };
    }
    /* The one span where the leap year decides the answer. */
    if(shape==='febspan'){
      var leap = Math.random()<0.5;
      d1=RI(17,27); d2=RI(2,11);
      return { t:'It is a '+(leap?'leap':'normal')+' year. From the '+ord(d1)+' of February to the '+ord(d2)+' of March is how many days?', a:((leap?29:28)-d1)+d2, list:true };
    }
    if(shape==='leap'){
      y=2000+4*RI(1,20);
      return { t:'What is the next leap year after '+(y-RI(1,3))+'?', a:y, list:true };
    }
    n=RI(3,12);
    if(Math.random()<0.5) return { t:'How many days are there in '+n+' weeks?', a:n*7, list:true };
    return { t:'How many weeks are there in '+(n*7)+' days?', a:n, list:true };
  }

  /* ---- 24-hour clock: answers are typed as HH:MM, the colon appears on its own ---- */
  function mstr(mins){ mins=((mins%1440)+1440)%1440; return pad2(Math.floor(mins/60))+':'+pad2(mins%60); }
  function durTxt(mins){
    var h=Math.floor(mins/60), m=mins%60;
    if(h && m) return h+' h '+m+' min';
    if(h)      return h+(h===1?' hour':' hours');
    return m+' minutes';
  }
  /* [thing, verb it starts with, base end verb, past end verb, base start verb] */
  var TIME_CTX=[
    ['A film','starts at','end','ended at','start'],
    ['A train journey','begins at','end','ended at','begin'],
    ['A lesson','starts at','end','ended at','start'],
    ['A football match','kicks off at','finish','finished at','kick off'],
    ['A flight','takes off at','land','landed at','take off'],
    ['A coach trip','leaves at','arrive','arrived at','leave']
  ];
  function qTime(){
    var shape=weighted([['end',5],['start',4],['convert',4],['later',3],['earlier',2],['gap',3]]);
    var dur, st, ctx, h, m, ap;
    if(shape==='end'){
      dur=60*RI(0,3)+5*RI(0,11); if(dur<20) dur=45;
      st=5*RI(Math.ceil(360/5), Math.floor((1435-dur)/5));
      ctx=pick(TIME_CTX);
      return { t:ctx[0]+' '+ctx[1]+' '+mstr(st)+' and lasts '+durTxt(dur)+'. What time does it '+ctx[2]+'?',
               a:mstr(st+dur), time:true, list:true };
    }
    if(shape==='start'){
      dur=60*RI(0,3)+5*RI(0,11); if(dur<20) dur=50;
      var en=5*RI(Math.ceil((420+dur)/5), Math.floor(1435/5));
      ctx=pick(TIME_CTX);
      return { t:ctx[0]+' '+ctx[3]+' '+mstr(en)+' after '+durTxt(dur)+'. What time did it '+ctx[4]+'?',
               a:mstr(en-dur), time:true, list:true };
    }
    if(shape==='convert'){
      h=RI(1,11); m=5*RI(0,11); ap=pick(['am','pm']);
      return { t:'Write '+h+':'+pad2(m)+' '+ap+' as a 24-hour time',
               a:mstr((ap==='pm'?h+12:h)*60+m), time:true, list:true };
    }
    if(shape==='later'){
      st=5*RI(72, 260); dur=5*RI(3,27);
      return { t:'What time is '+durTxt(dur)+' after '+mstr(st)+'?', a:mstr(st+dur), time:true, list:true };
    }
    if(shape==='earlier'){
      st=5*RI(120, 283); dur=5*RI(3,27);
      return { t:'What time is '+durTxt(dur)+' before '+mstr(st)+'?', a:mstr(st-dur), time:true, list:true };
    }
    st=5*RI(84, 260); dur=5*RI(2,24);
    return { t:'How many minutes are there from '+mstr(st)+' to '+mstr(st+dur)+'?', a:dur, list:true };
  }

  /* ---- Units and measures ---- */
  function qUnits(){
    var shape=weighted([['len',4],['mass',3],['cap',3],['time',3],
                        ['money',3],['mixed',3],['fit',3],['week',2]]);
    var v, w, p;
    if(shape==='money'){
      if(Math.random()<0.5){ v=round(RI(11,995)/100,2); return { t:'£'+v.toFixed(2)+' = □ p', a:Math.round(v*100), list:true }; }
      v=RI(11,995); return { t:v+' p = £□', a:round(v/100,2), list:true };
    }
    /* two units in one measurement, which is where the conversion gets missed */
    if(shape==='mixed'){
      /* the smaller unit must stay under one of the larger one, or "8 m 110 cm"
         is not a measurement anybody would write */
      return pick([
        function(){ w=RI(1,9); p=RI(1,9)*10;  return { t:w+' m '+p+' cm = □ cm', a:w*100+p, list:true }; },
        function(){ w=RI(1,9); p=RI(1,9)*100; return { t:w+' kg '+p+' g = □ g',  a:w*1000+p, list:true }; },
        function(){ w=RI(1,9); p=RI(1,9)*100; return { t:w+' litres '+p+' ml = □ ml', a:w*1000+p, list:true }; },
        function(){ w=RI(1,9); p=RI(1,9);     return { t:w+' cm '+p+' mm = □ mm', a:w*10+p, list:true }; }
      ])();
    }
    if(shape==='fit'){
      return pick([
        function(){ p=pick([100,200,250,500]); w=RI(2,9); return { t:'How many '+p+' ml glasses fill '+w+' litres?', a:w*1000/p, list:true }; },
        function(){ p=pick([10,20,25,50]);     w=RI(2,9); return { t:'How many '+p+' cm lengths fit in '+w+' m?', a:w*100/p, list:true }; },
        function(){ p=pick([100,200,250,500]); w=RI(2,9); return { t:'How many '+p+' g bags fill '+w+' kg?', a:w*1000/p, list:true }; }
      ])();
    }
    if(shape==='week'){
      return pick([
        function(){ w=RI(2,12); return { t:w+' weeks = □ days', a:w*7, list:true }; },
        function(){ w=RI(2,12); return { t:(w*7)+' days = □ weeks', a:w, list:true }; },
        function(){ w=RI(2,9);  return { t:w+' years = □ months', a:w*12, list:true }; },
        function(){ w=RI(2,9);  return { t:w+' days = □ hours', a:w*24, list:true }; }
      ])();
    }
    if(shape==='len'){
      return pick([
        function(){ v=round(RI(11,95)/10,1); return { t:nstr(v)+' km = □ m',  a:round(v*1000,1) }; },
        function(){ v=RI(11,95)*100;         return { t:v.toLocaleString('en-GB')+' m = □ km', a:round(v/1000,2) }; },
        function(){ v=round(RI(11,95)/10,1); return { t:nstr(v)+' m = □ cm',  a:round(v*100,1) }; },
        function(){ v=RI(11,95)*10;          return { t:v+' cm = □ m',        a:round(v/100,2) }; },
        function(){ v=round(RI(15,95)/10,1); return { t:nstr(v)+' cm = □ mm', a:round(v*10,1) }; },
        function(){ v=RI(15,95)*10;          return { t:v+' mm = □ cm',       a:round(v/10,2) }; }
      ])();
    }
    if(shape==='mass'){
      return pick([
        function(){ v=round(RI(11,95)/10,1); return { t:nstr(v)+' kg = □ g',  a:round(v*1000,1) }; },
        function(){ v=RI(11,95)*100;         return { t:v.toLocaleString('en-GB')+' g = □ kg', a:round(v/1000,2) }; },
        function(){ v=RI(2,9);               return { t:v+' tonnes = □ kg',   a:v*1000 }; },
        function(){ v=RI(11,95)*10;          return { t:v.toLocaleString('en-GB')+' g = □ kg', a:round(v/1000,2) }; }
      ])();
    }
    if(shape==='cap'){
      return pick([
        function(){ v=round(RI(11,95)/10,1); return { t:nstr(v)+' litres = □ ml', a:round(v*1000,1) }; },
        function(){ v=RI(11,95)*100;         return { t:v.toLocaleString('en-GB')+' ml = □ litres', a:round(v/1000,2) }; },
        function(){ v=RI(11,95)*10;          return { t:v.toLocaleString('en-GB')+' ml = □ litres', a:round(v/1000,2) }; },
        function(){ v=RI(2,9);               return { t:v+' litres = □ ml',      a:v*1000 }; }
      ])();
    }
    return pick([
      function(){ v=RI(2,9);               return { t:v+' hours = □ minutes',   a:v*60 }; },
      function(){ v=RI(2,9);               return { t:v+' minutes = □ seconds', a:v*60 }; },
      function(){ v=RI(2,9);               return { t:v+' days = □ hours',      a:v*24 }; },
      function(){ v=round(RI(3,15)/2,1);   return { t:nstr(v)+' hours = □ minutes', a:v*60 }; },
      function(){ v=RI(2,9)*60;            return { t:v+' minutes = □ hours',   a:v/60 }; }
    ])();
  }

  /* ---- Factors, multiples and primes ---- */
  function isPrime(n){
    if(n<2) return false;
    if(n<4) return true;
    if(n%2===0) return false;
    for(var i=3;i*i<=n;i+=2){ if(n%i===0) return false; }
    return true;
  }
  function factorCount(n){ var c=0; for(var i=1;i<=n;i++){ if(n%i===0) c++; } return c; }
  function qFactors(){
    var shape=weighted([['hcf',4],['lcm',4],['count',3],['mult',3],['next',3],['largest',2],
                        ['isprime',3],['smallpf',3],['whichfactor',3],['countprimes',2],['countmult',2]]);
    var a,b,g,guard=0,n,i,c;
    /* prime or not, pressed as 1 or 2: the fact test rather than the recall */
    if(shape==='isprime'){
      n = Math.random()<0.5 ? pick([2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97])
                            : pick([21,27,33,39,49,51,57,63,69,77,81,87,91,93,99,111,117,119,121,143]);
      return { t:'Is '+n+' a prime number?', a:isPrime(n)?1:2, choices:['Yes','No'], list:true };
    }
    if(shape==='smallpf'){
      n=pick([21,33,35,39,49,51,55,57,63,65,69,77,85,87,91,93,95,99,115,119,121,133,143]);
      for(i=2;i<=n;i++){ if(n%i===0) break; }
      return { t:'What is the smallest prime factor of '+n+'?', a:i, list:true };
    }
    if(shape==='whichfactor'){          /* one of three divides it: press 1, 2 or 3 */
      n=pick([24,30,36,40,42,45,48,54,56,60,63,64,70,72,80,84,90,96]);
      var good=[], bad=[];
      for(i=3;i<=9;i++){ (n%i===0 ? good : bad).push(i); }
      if(!good.length || bad.length<2) return { t:'What is the largest prime number below 30?', a:29, list:true };
      var right=pick(good), opts=[right, bad[0], bad[1]];
      opts=shuffle(opts);
      return { t:'Which of these is a factor of '+n+'?', a:opts.indexOf(right)+1, choices:opts.map(String), list:true };
    }
    if(shape==='countprimes'){
      var lo=pick([1,10,20,30,40,50]), hi=lo+pick([10,20]);
      c=0; for(i=lo;i<=hi;i++){ if(isPrime(i)) c++; }
      return { t:'How many prime numbers are there from '+lo+' to '+hi+'?', a:c, list:true };
    }
    if(shape==='countmult'){
      a=pick([3,4,5,6,7,8,9,11]);
      b=pick([30,40,50,60,100]);
      return { t:'How many multiples of '+a+' are there from 1 to '+b+'?', a:Math.floor(b/a), list:true };
    }
    if(shape==='hcf'){
      g=pick([2,3,4,5,6,8,9,12]);
      do { a=RI(2,9); b=RI(2,9); guard++; } while((a===b || gcd(a,b)!==1) && guard<40);
      if(gcd(a,b)!==1){ a=2; b=3; }
      return { t:'What is the HCF of '+(g*a)+' and '+(g*b)+'?', a:g, list:true };
    }
    if(shape==='lcm'){
      do { a=RI(2,12); b=RI(2,12); guard++; } while(a===b && guard<20);
      return { t:'What is the LCM of '+a+' and '+b+'?', a:a*b/gcd(a,b), list:true };
    }
    if(shape==='count'){
      n=RI(12,60);
      return { t:'How many factors does '+n+' have?', a:factorCount(n), list:true };
    }
    if(shape==='mult'){
      a=RI(3,12); b=RI(3,9);
      return { t:'What is the '+b+'th multiple of '+a+'?', a:a*b, list:true };
    }
    if(shape==='next'){
      n=RI(10,70);
      i=n+1; while(!isPrime(i)) i++;
      return { t:'What is the next prime number after '+n+'?', a:i, list:true };
    }
    n=pick([20,30,40,50,60,70,80,90,100]);
    i=n-1; while(!isPrime(i)) i--;
    return { t:'What is the largest prime number below '+n+'?', a:i, list:true };
  }

  /* ---- Area and perimeter: small numbers, one step, no diagram needed ---- */
  function qShapes(){
    var shape=weighted([['rarea',4],['rperim',4],['sqperim',3],['sqarea',2],['tri',3],['miss',3],['sqfrom',2],
                        ['regular',3],['para',2],['permiss',3],['trimiss',2],['cutout',2],['sqparea',2],['metres',2]]);
    var a,b,n;
    /* a regular polygon: one side and a side count, no diagram needed */
    if(shape==='regular'){
      var POLY=[['pentagon',5],['hexagon',6],['heptagon',7],['octagon',8],['nonagon',9],['decagon',10]];
      var p=pick(POLY); a=RI(3,12);
      return { t:'Perimeter of a regular '+p[0]+' with sides of '+a+' cm', a:p[1]*a, list:true };
    }
    if(shape==='para'){
      a=RI(3,12); b=RI(2,10);
      return { t:'Area of a parallelogram, base '+a+' cm and height '+b+' cm', a:a*b, list:true };
    }
    /* backwards from the perimeter, which needs the halving step first */
    if(shape==='permiss'){
      a=RI(2,12); b=RI(2,12);
      return { t:'A rectangle has a perimeter of '+(2*(a+b))+' cm and one side of '+a+' cm. How long is the other side?', a:b, list:true };
    }
    if(shape==='trimiss'){
      a=2*RI(2,8); b=RI(2,10);
      return { t:'A triangle has an area of '+(a*b/2)+' cm² and a height of '+b+' cm. How long is the base?', a:a, list:true };
    }
    if(shape==='cutout'){
      a=RI(6,12); b=RI(4,9);
      var ca=RI(2,3), cb=RI(2,3);
      return { t:'A '+a+' cm by '+b+' cm rectangle has a '+ca+' cm by '+cb+' cm corner cut out. What area is left?', a:a*b-ca*cb, list:true };
    }
    if(shape==='sqparea'){
      a=RI(2,12);
      return { t:'A square has a perimeter of '+(4*a)+' cm. What is its area?', a:a*a, list:true };
    }
    if(shape==='metres'){
      a=RI(2,12); b=RI(2,12);
      if(Math.random()<0.5) return { t:'Area of a rectangle '+a+' m by '+b+' m, in m²', a:a*b, list:true };
      return { t:'Perimeter of a rectangle '+a+' m by '+b+' m, in m', a:2*(a+b), list:true };
    }
    if(shape==='rarea'){ a=RI(2,12); b=RI(2,12); return { t:'Area of a rectangle '+a+' cm by '+b+' cm', a:a*b, list:true }; }
    if(shape==='rperim'){ a=RI(2,14); b=RI(2,14); return { t:'Perimeter of a rectangle '+a+' cm by '+b+' cm', a:2*(a+b), list:true }; }
    if(shape==='sqperim'){ a=RI(2,12); return { t:'Perimeter of a square with sides of '+a+' cm', a:4*a, list:true }; }
    if(shape==='sqarea'){ a=RI(2,12); return { t:'Area of a square with sides of '+a+' cm', a:a*a, list:true }; }
    if(shape==='tri'){
      a=2*RI(2,8); b=RI(2,10);
      return { t:'Area of a triangle, base '+a+' cm and height '+b+' cm', a:a*b/2, list:true };
    }
    if(shape==='miss'){
      a=RI(2,10); b=RI(2,10);
      return { t:'A rectangle has an area of '+(a*b)+' cm² and one side of '+a+' cm. How long is the other side?', a:b, list:true };
    }
    a=RI(2,10);
    return { t:'A square has an area of '+(a*a)+' cm². What is its perimeter?', a:4*a, list:true };
  }

  /* ---- Function machines: one or two steps, forwards or backwards ---- */
  function fmStep(inVal){
    var op=weighted([['+',3],['−',2],['×',3],['÷',2]]), n, divs, i;
    if(op==='÷'){
      /* only divide when it goes exactly, so the machine never makes a decimal */
      divs=[];
      for(i=2;i<=6;i++){ if(inVal%i===0 && inVal/i>=1) divs.push(i); }
      if(divs.length){ n=pick(divs); return { txt:'÷ '+n, out:inVal/n }; }
      op='×';                                  /* nothing divides it, so multiply instead */
    }
    if(op==='−' && inVal<3) op='+';            /* nothing left to take away */
    if(op==='+'){ n=RI(2,20); return { txt:'+ '+n, out:inVal+n }; }
    if(op==='−'){
      n=RI(1, Math.min(15, inVal-1));
      return { txt:'− '+n, out:inVal-n };
    }
    /* the multiplier shrinks as the running total grows, so a second × cannot
       turn the machine into 36 × 7 while every other topic stays mental */
    n = inVal>40 ? RI(2,3) : inVal>20 ? RI(2,5) : RI(2,9);
    return { txt:'× '+n, out:inVal*n };
  }
  function qFunctionMachine(){
    var steps = Math.random()<0.42 ? 1 : 2, tries=0, start, cur, txts, i, s;
    /* × 5 then ÷ 5 is not a question, so a step that undoes the one before is rejected */
    var undoes=function(p,q){
      var a=p.split(' '), b=q.split(' ');
      if(a[1]!==b[1]) return false;
      return (a[0]==='+'&&b[0]==='−')||(a[0]==='−'&&b[0]==='+')||(a[0]==='×'&&b[0]==='÷')||(a[0]==='÷'&&b[0]==='×');
    };
    do {
      start=RI(2,20); cur=start; txts=[];
      for(i=0;i<steps;i++){ s=fmStep(cur); txts.push(s.txt); cur=s.out; }
      tries++;
    } while((cur<1 || cur>999 || (steps===2 && undoes(txts[0],txts[1]))) && tries<30);
    var backwards = Math.random()<0.45;
    var chain=txts.map(function(x){ return '<span class="qm-fm-op">'+x+'</span>'; }).join('<span class="qm-fm-arw">&rarr;</span>');
    var box=function(lbl,val){ return '<span class="qm-fm-end"><span class="qm-fm-lbl">'+lbl+'</span>'+val+'</span>'; };
    var t='<span class="qm-fm">'+box('in', backwards?'?':start)
        + '<span class="qm-fm-arw">&rarr;</span>'+chain+'<span class="qm-fm-arw">&rarr;</span>'
        + box('out', backwards?cur:'?')+'</span>';
    /* the end-of-run review is a tight row, so it gets a one-line version */
    var plain='IN '+(backwards?'□':start)+' → '+txts.join(' → ')+' → OUT '+(backwards?cur:'□');
    return { t:t, a: backwards?start:cur, html:true, plain:plain };
  }

  /* ---- Sequences: finish the run or fill the gap, no nth term ----
     Shapes follow the Sequences lesson: linear up and down, a blank in any
     position, geometric, and changing-difference runs. Terms stay positive
     because the minus key is off unless Negative Numbers is picked. */
  function seqBlank(terms, at){
    var out=terms.slice();
    var ans=out[at];
    out[at]='□';
    return { t:out.join(', '), a:ans, list:true };
  }
  function qSequences(){
    var shape=weighted([['up',5],['down',4],['gap',4],['first',3],['times',4],['halve',2],['grow',3],['square',2],['triangle',2],
                        ['fib',2],['rule',3],['nth',2],['belowzero',2]]);
    var a,d,r,i,terms=[];
    /* add the two before it: the pattern that is not a fixed step */
    if(shape==='fib'){
      a=RI(1,6); d=RI(2,9);
      terms=[a,d];
      for(i=2;i<6;i++) terms.push(terms[i-1]+terms[i-2]);
      return seqBlank(terms,5);
    }
    /* name the step rather than the next term */
    if(shape==='rule'){
      d=RI(2,12); a=RI(1,20);
      for(i=0;i<4;i++) terms.push(a+i*d);
      if(Math.random()<0.5) return { t:terms.join(', ')+', … What is added each time?', a:d, list:true };
      a=d*RI(6,12); terms=[];
      for(i=0;i<4;i++) terms.push(a-i*d);
      return { t:terms.join(', ')+', … What is taken away each time?', a:d, list:true };
    }
    /* jump ahead instead of stepping one on */
    if(shape==='nth'){
      d=RI(2,9); a=RI(1,12);
      for(i=0;i<4;i++) terms.push(a+i*d);
      var want=pick([6,7,8,10]);
      return { t:terms.join(', ')+', … What is term '+want+'?', a:a+(want-1)*d, list:true };
    }
    /* a run that carries on past zero */
    if(shape==='belowzero'){
      d=RI(3,9); a=d*RI(2,3)+RI(0,d-1);
      for(i=0;i<5;i++) terms.push(a-i*d);
      return seqBlank(terms,4);
    }
    if(shape==='up'){
      d=RI(2,12); a=RI(1,14);
      for(i=0;i<5;i++) terms.push(a+i*d);
      return seqBlank(terms,4);
    }
    if(shape==='down'){
      d=RI(2,12); a=d*RI(5,9)+RI(0,d-1);
      for(i=0;i<5;i++) terms.push(a-i*d);
      return seqBlank(terms,4);
    }
    if(shape==='gap'){
      d=RI(2,11); a=RI(1,14);
      for(i=0;i<5;i++) terms.push(a+i*d);
      return seqBlank(terms, RI(1,3));
    }
    if(shape==='first'){
      d=RI(2,11); a=d+RI(1,14);
      for(i=0;i<5;i++) terms.push(a+i*d);
      if(Math.random()<0.5){ terms=terms.map(function(v,j){ return a+4*d-j*d; }); }
      return seqBlank(terms,0);
    }
    if(shape==='times'){
      r=pick([2,2,3,3,4,5,10]); a=RI(1,5);
      for(i=0;i<5;i++) terms.push(a*Math.pow(r,i));
      if(terms[4]>100000){ terms=terms.slice(0,4); return seqBlank(terms,3); }
      return seqBlank(terms, Math.random()<0.25 ? RI(1,3) : 4);
    }
    if(shape==='halve'){
      a=16*RI(3,20);
      terms=[a,a/2,a/4,a/8,a/16];
      return seqBlank(terms,4);
    }
    if(shape==='grow'){
      /* gaps that grow by a fixed step: 1, 2, 4, 7, 11 ... */
      a=RI(1,6); var g=RI(1,5), step=RI(1,4);
      terms=[a];
      for(i=1;i<6;i++){ terms.push(terms[i-1]+g); g+=step; }
      return seqBlank(terms,5);
    }
    if(shape==='square'){
      i=RI(1,6); terms=[];
      for(var s=i;s<i+5;s++) terms.push(s*s);
      return seqBlank(terms,4);
    }
    var TRI=[1,3,6,10,15,21,28,36,45,55,66,78];
    i=RI(0,6);
    return seqBlank(TRI.slice(i,i+5),4);
  }

  /* ---- Roman numerals ---- */
  var RN=[[1000,'M'],[900,'CM'],[500,'D'],[400,'CD'],[100,'C'],[90,'XC'],[50,'L'],[40,'XL'],[10,'X'],[9,'IX'],[5,'V'],[4,'IV'],[1,'I']];
  function toRoman(n){
    var s='';
    for(var i=0;i<RN.length;i++){ while(n>=RN[i][0]){ s+=RN[i][1]; n-=RN[i][0]; } }
    return s;
  }
  function qRoman(){
    var shape=weighted([['read',6],['add',3],['sub',2],['bigger',2],['year',2]]);
    var n=weighted([[RI(1,39),3],[RI(40,99),4],[RI(100,499),4],[RI(500,999),3],[RI(1000,2026),3]]);
    if(shape==='read') return { t:toRoman(n)+' = □', a:n };
    /* arithmetic in numerals: read both, then work in figures */
    if(shape==='add'){
      var a1=RI(2,20), b1=RI(2,20);
      return { t:toRoman(a1)+' + '+toRoman(b1)+' = □', a:a1+b1 };
    }
    if(shape==='sub'){
      var a2=RI(6,20), b2=RI(2,a2-1);
      return { t:toRoman(a2)+' − '+toRoman(b2)+' = □', a:a2-b2 };
    }
    if(shape==='bigger'){                 /* press 1 or 2 */
      var x=RI(4,99), y=RI(4,99);
      while(y===x) y=RI(4,99);
      return { t:'Which is bigger?', a:(x>y?1:2), choices:[toRoman(x), toRoman(y)], list:true };
    }
    var yr=RI(1500,2026);
    return { t:'Which year is '+toRoman(yr)+'?', a:yr, list:true };
  }

  /* ---- Ratio: equivalent and simplifying only, the two ratios stacked ---- */
  function ratioStack(topL, topR, botL, botR){
    return '<span class="qm-ratio">'
         + '<span class="l">'+topL+'</span><span class="c">:</span><span class="r">'+topR+'</span>'
         + '<span class="l">'+botL+'</span><span class="c">:</span><span class="r">'+botR+'</span>'
         + '</span>';
  }
  function qRatio(){
    var a,b,k,guard=0;
    do { a=RI(1,9); b=RI(1,9); guard++; } while((a===b || gcd(a,b)!==1) && guard<40);
    if(a===b || gcd(a,b)!==1){ a=3; b=5; }
    k=RI(2,9);
    var shape=weighted([['scale',6],['words',3],['three',2],['unit',3]]);
    /* the same scaling dressed as a recipe or a mix, where 11+ papers put it */
    if(shape==='words'){
      var CTX=pick([
        ['red beads','blue beads'], ['boys','girls'], ['cats','dogs'],
        ['apples','pears'], ['blue counters','yellow counters'], ['red cars','white cars']
      ]);
      return { t:'For every '+a+' '+CTX[0]+' there are '+b+' '+CTX[1]+'. How many '+CTX[1]+' go with '+(a*k)+' '+CTX[0]+'?',
               a:b*k, list:true };
    }
    if(shape==='three'){
      var c=RI(1,9);
      return { t:a+' : '+b+' : '+c+' = '+(a*k)+' : □ : '+(c*k)+'. What is the missing number?', a:b*k, list:true };
    }
    /* direct proportion: find one, then scale it. No sharing, per the ratio lesson */
    if(shape==='unit'){
      var ITEM=pick(['pencils','rubbers','stickers','pens','badges']);
      var per=pick([3,4,5,6]), each=pick([2,3,4,5,6,9,12]), want=RI(2,9);
      if(want===per) want = per+RI(1,4);
      return { t:per+' '+ITEM+' cost '+(per*each)+'p. How much do '+want+' cost, in pence?', a:want*each, list:true };
    }
    var out=function(tl,tr,bl,br,ans){
      return { t:ratioStack(tl,tr,bl,br), a:ans, html:true,
               plain:tl+' : '+tr+' = '+bl+' : '+br };
    };
    if(Math.random()<0.5){
      /* scale up: the top ratio is simplest, the bottom one has a gap */
      if(Math.random()<0.5) return out(a,b,a*k,'□',b*k);
      return out(a,b,'□',b*k,a*k);
    }
    /* simplify: the top ratio is the big one */
    if(Math.random()<0.5) return out(a*k,b*k,a,'□',b);
    return out(a*k,b*k,'□',b,a);
  }

  /* ---- Angles: straight lines, right angles, triangles, and naming one ---- */
  var POLY_NAME={3:'triangle',4:'quadrilateral',5:'pentagon',6:'hexagon',7:'heptagon',8:'octagon',9:'nonagon',10:'decagon',12:'dodecagon'};
  /* nobody says "a regular triangle" or "a regular quadrilateral" */
  function regularName(n){
    if(n===3) return 'an equilateral triangle';
    if(n===4) return 'a square';
    return 'a regular '+POLY_NAME[n];
  }
  function qAngles(){
    var shape=weighted([['line',4],['right',3],['tri',4],['rtri',3],['fact',2],['name',5],
                        ['point',4],['quad',3],['isos',3],['vert',2],['exterior',2],['interior',2],['clock',2]]);
    var a,b,c;
    if(shape==='point'){
      a=RI(60,150); b=RI(60, 300-a);
      return { t:'Angles at a point: '+a+'°, '+b+'° and x°. What is x?', a:360-a-b, list:true };
    }
    if(shape==='quad'){
      a=RI(50,120); b=RI(50,120); c=RI(40, 350-a-b);
      return { t:'Three angles in a quadrilateral are '+a+'°, '+b+'° and '+c+'°. What is the fourth?', a:360-a-b-c, list:true };
    }
    if(shape==='isos'){
      if(Math.random()<0.5){
        a=2*RI(10,44);                          /* apex angle, base angles come out whole */
        return { t:'An isosceles triangle has a top angle of '+a+'°. What is each base angle?', a:(180-a)/2, list:true };
      }
      a=RI(25,80);
      return { t:'An isosceles triangle has two base angles of '+a+'°. What is the top angle?', a:180-2*a, list:true };
    }
    if(shape==='vert'){
      a=RI(25,155);
      return { t:'Two straight lines cross. One angle is '+a+'°. What is the angle opposite it?', a:a, list:true };
    }
    if(shape==='exterior'){
      var nE=pick([3,4,5,6,8,9,10,12]);
      return { t:'What is the exterior angle of '+regularName(nE)+'?', a:360/nE, list:true };
    }
    if(shape==='interior'){
      if(Math.random()<0.55){
        var nS=pick([3,4,5,6,7,8,9,10,12]);
        return { t:'What do the angles in a '+POLY_NAME[nS]+' add up to?', a:(nS-2)*180, list:true };
      }
      /* only the polygons whose interior angle is a whole number of degrees */
      var nE2=pick([3,4,5,6,8,9,10,12]);
      return { t:'What is each angle in '+regularName(nE2)+'?', a:(nE2-2)*180/nE2, list:true };
    }
    if(shape==='clock'){
      var h=pick([1,2,3,4,5,9,10,11]);
      var deg=Math.abs(h*30);
      if(deg>180) deg=360-deg;
      return { t:'What is the angle between the hands of a clock at '+h+' o’clock?', a:deg, list:true };
    }
    if(shape==='line'){
      a=RI(15,165);
      return { t:'Angles on a straight line: '+a+'° and x°. What is x?', a:180-a, list:true };
    }
    if(shape==='right'){
      a=RI(10,80);
      return { t:'A right angle is split into '+a+'° and x°. What is x?', a:90-a, list:true };
    }
    if(shape==='tri'){
      a=RI(25,110); b=RI(25, 155-a);
      return { t:'Two angles in a triangle are '+a+'° and '+b+'°. What is the third?', a:180-a-b, list:true };
    }
    if(shape==='rtri'){
      a=RI(15,75);
      return { t:'A right-angled triangle has an angle of '+a+'°. What is the third angle?', a:90-a, list:true };
    }
    if(shape==='fact'){
      return pick([
        { t:'How many degrees are there in a right angle?', a:90, list:true },
        { t:'How many degrees are there on a straight line?', a:180, list:true },
        { t:'How many degrees are there in a full turn?', a:360, list:true },
        { t:'How many degrees do the angles in a triangle add up to?', a:180, list:true }
      ]);
    }
    /* name the angle: press 1, 2 or 3 */
    var kind=RI(1,3);
    if(kind===1) a=RI(5,89);          /* acute  */
    else if(kind===2) a=RI(91,179);   /* obtuse */
    else a=RI(181,359);               /* reflex */
    return { t:'Is an angle of '+a+'° acute, obtuse or reflex?', a:kind, choices:['Acute','Obtuse','Reflex'], list:true };
  }

  /* ---- Shape facts: recall only, nothing to work out ----
     Curved solids are left out of faces, edges and vertices on purpose, because
     a cylinder's count is argued over and a wrong mark there teaches nothing. */
  var SOLIDS=[
    ['cube',6,12,8], ['cuboid',6,12,8], ['triangular prism',5,9,6],
    ['square-based pyramid',5,8,5], ['triangular-based pyramid',4,6,4],
    ['pentagonal prism',7,15,10], ['hexagonal prism',8,18,12], ['octagonal prism',10,24,16],
    ['pentagonal pyramid',6,10,6], ['hexagonal pyramid',7,12,7]
  ];
  var POLYGONS=[['triangle',3],['quadrilateral',4],['pentagon',5],['hexagon',6],['heptagon',7],['octagon',8],['nonagon',9],['decagon',10],['dodecagon',12]];
  /* [name, lines of symmetry, order of rotational symmetry] */
  var SYMS=[
    ['square',4,4], ['rectangle',2,2], ['equilateral triangle',3,3], ['isosceles triangle',1,1],
    ['scalene triangle',0,1], ['regular pentagon',5,5], ['regular hexagon',6,6], ['regular heptagon',7,7],
    ['regular octagon',8,8], ['regular decagon',10,10],
    ['parallelogram',0,2], ['rhombus',2,2], ['kite',1,1], ['isosceles trapezium',1,1]
  ];
  var PARALLEL=[['square',2],['rectangle',2],['parallelogram',2],['rhombus',2],['trapezium',1],['kite',0]];
  /* "an octagon", not "a octagon" */
  function an(name){ return ('aeiou'.indexOf(name.charAt(0))>-1 ? 'an ' : 'a ') + name; }
  /* Any prism or pyramid on an n-sided base, built from the rule rather than a
     list, so the pool is not eleven solids repeated all run. */
  var BASE_ADJ={3:'triangular',4:'square',5:'pentagonal',6:'hexagonal',7:'heptagonal',8:'octagonal',9:'nonagonal',10:'decagonal',12:'dodecagonal'};
  function solidFrom(n, kind){
    var name=BASE_ADJ[n]+(kind==='prism' ? ' prism' : ' pyramid');
    if(n===4 && kind==='pyramid') name='square-based pyramid';
    if(n===3 && kind==='pyramid') name='triangular-based pyramid';
    if(n===4 && kind==='prism') name='cuboid';
    return kind==='prism'
      ? [name, n+2, 3*n, 2*n]
      : [name, n+1, 2*n, n+1];
  }
  function qShapeFacts(){
    var shape=weighted([['fev',4],['sides',2],['lines',3],['rot',3],['para',2],['name',3],
                        ['fevgen',5],['diag',3],['euler',3],['prop',3]]);
    var s, p;
    if(shape==='fev'){
      s=pick(SOLIDS);
      var part=weighted([['faces',3],['edges',3],['vertices',3]]);
      var idx = part==='faces' ? 1 : part==='edges' ? 2 : 3;
      return { t:'How many '+part+' does '+an(s[0])+' have?', a:s[idx], list:true };
    }
    if(shape==='fevgen'){
      s=solidFrom(pick([3,4,5,6,7,8,9,10,12]), Math.random()<0.5 ? 'prism' : 'pyramid');
      var part2=weighted([['faces',3],['edges',3],['vertices',3]]);
      var idx2 = part2==='faces' ? 1 : part2==='edges' ? 2 : 3;
      return { t:'How many '+part2+' does '+an(s[0])+' have?', a:s[idx2], list:true };
    }
    if(shape==='diag'){
      var nD=pick([4,5,6,7,8,9,10]);
      return { t:'How many diagonals can be drawn in '+an(POLY_NAME[nD])+'?', a:nD*(nD-3)/2, list:true };
    }
    if(shape==='euler'){
      var nu=pick([3,4,5,6,8,10]), kind=Math.random()<0.5 ? 'prism' : 'pyramid';
      s=solidFrom(nu, kind);
      return { t:an(s[0]).charAt(0).toUpperCase()+an(s[0]).slice(1)+' has '+s[1]+' faces and '+s[3]+' vertices. How many edges?', a:s[2], list:true };
    }
    if(shape==='prop'){                    /* true of which shape: press 1, 2 or 3 */
      var q=pick([
        ['Which shape has four equal sides and four right angles?', ['Rectangle','Square','Rhombus'], 2],
        ['Which shape has two pairs of equal sides and no right angles?', ['Parallelogram','Square','Rectangle'], 1],
        ['Which triangle has one angle of 90°?', ['Equilateral','Right-angled','Isosceles'], 2],
        ['Which shape has exactly one pair of parallel sides?', ['Trapezium','Parallelogram','Rhombus'], 1],
        ['Which shape has no lines of symmetry?', ['Parallelogram','Rhombus','Kite'], 1],
        ['Which solid has 12 equal edges?', ['Cube','Cuboid','Triangular prism'], 1],
        ['Which solid has one curved face and two flat ones?', ['Cone','Sphere','Cylinder'], 3],
        ['Which shape is a regular quadrilateral?', ['Rectangle','Square','Kite'], 2],
        ['How many right angles are there in a rectangle?', ['2','4','6'], 2],
        ['Which of these always has equal diagonals?', ['Kite','Rectangle','Parallelogram'], 2]
      ]);
      return { t:q[0], a:q[2], choices:q[1], list:true };
    }
    if(shape==='sides'){
      p=pick(POLYGONS);
      return { t:'How many sides does '+an(p[0])+' have?', a:p[1], list:true };
    }
    if(shape==='lines'){
      s=pick(SYMS);
      return { t:'How many lines of symmetry does '+an(s[0])+' have?', a:s[1], list:true };
    }
    if(shape==='rot'){
      s=pick(SYMS);
      return { t:'What is the order of rotational symmetry of '+an(s[0])+'?', a:s[2], list:true };
    }
    if(shape==='para'){
      p=pick(PARALLEL);
      return { t:'How many pairs of parallel sides does '+an(p[0])+' have?', a:p[1], list:true };
    }
    /* name it: press 1, 2 or 3 */
    var mcq=pick([
      ['A triangle with all three sides equal is:', ['Scalene','Isosceles','Equilateral'], 3],
      ['A triangle with two equal sides is:', ['Scalene','Isosceles','Equilateral'], 2],
      ['A triangle with no equal sides is:', ['Scalene','Isosceles','Equilateral'], 1],
      ['A quadrilateral with exactly one pair of parallel sides is:', ['Trapezium','Rhombus','Kite'], 1],
      ['A quadrilateral with four equal sides but no right angles is:', ['Trapezium','Rhombus','Kite'], 2],
      ['A solid with 5 faces, 9 edges and 6 vertices is:', ['Cube','Triangular prism','Square-based pyramid'], 2],
      ['A solid with 5 faces, 8 edges and 5 vertices is:', ['Cube','Triangular prism','Square-based pyramid'], 3],
      ['A solid with 6 square faces is:', ['Cube','Triangular prism','Square-based pyramid'], 1],
      ['A ten-sided shape is called a:', ['Octagon','Nonagon','Decagon'], 3],
      ['An eight-sided shape is called a:', ['Octagon','Nonagon','Decagon'], 1],
      ['A nine-sided shape is called a:', ['Octagon','Nonagon','Decagon'], 2]
    ]);
    return { t:mcq[0], a:mcq[2], choices:mcq[1], list:true };
  }

  /* ---- Place value ---- */
  var W_ONES=['zero','one','two','three','four','five','six','seven','eight','nine','ten','eleven','twelve','thirteen','fourteen','fifteen','sixteen','seventeen','eighteen','nineteen'];
  var W_TENS=['','','twenty','thirty','forty','fifty','sixty','seventy','eighty','ninety'];
  function words3(n){
    var s='';
    if(n>=100){ s+=W_ONES[Math.floor(n/100)]+' hundred'; n%=100; if(n) s+=' and '; }
    if(n>=20){ s+=W_TENS[Math.floor(n/10)]; if(n%10) s+='-'+W_ONES[n%10]; }
    else if(n>0) s+=W_ONES[n];
    return s;
  }
  function numWords(n){
    if(n<1000) return words3(n);
    var th=Math.floor(n/1000), r=n%1000;
    var s=words3(th)+' thousand';
    if(r) s += (r<100 ? ' and ' : ' ') + words3(r);
    return s;
  }
  var COLS=[['units',1],['tens',10],['hundreds',100],['thousands',1000],['ten thousands',10000]];
  function qPlaceValue(){
    var shape=weighted([['value',5],['howmany',3],['words',3],['step',4],['column',3],['partition',2]]);
    var n, digits, pos, d, guard=0, col, step;
    if(shape==='value'){
      do {
        n=RI(1000,99999); digits=String(n);
        pos=RI(0,digits.length-1); d=+digits.charAt(pos);
        guard++;
      } while((d===0 || digits.split(d).length-1 !== 1) && guard<60);
      if(d===0) { n=4732; digits='4732'; pos=1; d=7; }
      var place=Math.pow(10, digits.length-1-pos);
      return { t:'What is the value of the '+d+' in '+n.toLocaleString('en-GB')+'?', a:d*place, list:true };
    }
    if(shape==='howmany'){
      col=pick([['tens',10],['hundreds',100],['thousands',1000]]);
      n=RI(11,99)*col[1];
      return { t:'How many '+col[0]+' are there in '+n.toLocaleString('en-GB')+'?', a:n/col[1], list:true };
    }
    if(shape==='words'){
      n=RI(1005,99999);
      if(n%100>0 && n%100<10 && Math.random()<0.5) n=n-n%10;
      return { t:'Write '+numWords(n)+' in figures', a:n, list:true };
    }
    if(shape==='step'){
      step=pick([10,100,1000,10000]);
      n=RI(step+1200, 89999);
      if(Math.random()<0.5) return { t:'What is '+step.toLocaleString('en-GB')+' more than '+n.toLocaleString('en-GB')+'?', a:n+step, list:true };
      return { t:'What is '+step.toLocaleString('en-GB')+' less than '+n.toLocaleString('en-GB')+'?', a:n-step, list:true };
    }
    if(shape==='column'){
      n=RI(10000,99999); digits=String(n);
      col=COLS[RI(0,digits.length-1)];
      d=+digits.charAt(digits.length-1-COLS.indexOf(col));
      return { t:'Which digit is in the '+col[0]+' column of '+n.toLocaleString('en-GB')+'?', a:d, list:true };
    }
    var th=RI(1,9)*1000, hu=RI(1,9)*100, te=RI(1,9)*10, un=RI(1,9);
    return { t:th.toLocaleString('en-GB')+' + '+hu+' + '+te+' + '+un+' = □', a:th+hu+te+un, list:true };
  }

  var MODES = [
    { k:'pos', sym:'+ −',  name:'Add &amp; Subtract', ex:'100 − 63',            c:'#5BAFD6', gen:qPositives },
    { k:'tab', sym:'× ÷', name:'Times &amp; Divide', ex:'7 × 8',      c:'#5B8DEF', gen:qTables },
    { k:'pow', sym:'x²',   name:'Powers &amp; Roots', ex:'14² · ∛216', c:'#A78BFA', gen:qPowers },
    { k:'neg', sym:'−5',   name:'Negative Numbers',   ex:'−7 + 12',         c:'#FF6B6B', gen:qNegatives },
    { k:'pct', sym:'%',         name:'Percentages',        ex:'Increase 80 by 10%',   c:'#F472B6', gen:qPercentages },
    { k:'p10', sym:'×10',  name:'Powers of 10',       ex:'3.5 × 100',      c:'#FF8054', gen:qPowers10 },
    { k:'dec', sym:'0.5',       name:'Decimals',           ex:'0.4 × 6',              c:'#3DD68C', gen:qDecimals },
    { k:'fra', sym:'½',    name:'Fractions',          ex:'¾ as a %',       c:'#FBBF24', gen:qFractions },
    { k:'alg', sym:'x',         name:'Algebra',            ex:'If x = 4, 3x + 2',     c:'#818CF8', gen:qAlgebra },
    { k:'avg', sym:'x̄',   name:'Averages',           ex:'Median of 4 values', c:'#A3E635', gen:qAverages },
    { k:'bid', sym:'( )',       name:'BIDMAS',             ex:'4 + 3 × 2',            c:'#22D3EE', gen:qBidmas },
    { k:'rnd', sym:'≈',    name:'Rounding',           ex:'Round 3,847 to 100', c:'#E879A0', gen:qRounding },
    { k:'pla', sym:'PV',   name:'Place Value',        ex:'Value of the 7 in 4,732', c:'#93C5FD', gen:qPlaceValue },
    { k:'cal', sym:'31',   name:'Days &amp; Dates',   ex:'Days in April',        c:'#7DD3FC', gen:qCalendar },
    { k:'tim', sym:'24h',  name:'24-hour Clock',      ex:'18:40 + 2 h 35 min',   c:'#2DD4BF', gen:qTime },
    { k:'uni', sym:'km',   name:'Units &amp; Measures', ex:'3.5 km = □ m',       c:'#F0ABFC', gen:qUnits },
    { k:'fac', sym:'HCF',  name:'Factors &amp; Primes', ex:'HCF of 24 and 36',   c:'#F97316', gen:qFactors },
    { k:'seq', sym:'⋯',    name:'Sequences',          ex:'3, 7, 11, 15, □',      c:'#C084FC', gen:qSequences },
    { k:'fnm', sym:'→',    name:'Function Machines',  ex:'IN 7 → × 3 → − 4 → □', c:'#60A5FA', gen:qFunctionMachine },
    { k:'ang', sym:'∠',    name:'Angles',             ex:'Two angles in a triangle', c:'#38BDF8', gen:qAngles },
    { k:'rat', sym:'a:b',  name:'Ratio',              ex:'3 : 5 = 12 : □',       c:'#FB7185', gen:qRatio },
    { k:'ape', sym:'▭',    name:'Area &amp; Perimeter', ex:'Area of 7 cm by 4 cm', c:'#34D399', gen:qShapes },
    { k:'shf', sym:'3D',   name:'Shape Facts',        ex:'Edges on a cuboid',    c:'#F4A261', gen:qShapeFacts },
    { k:'rom', sym:'IX',   name:'Roman Numerals',     ex:'XLII = □',             c:'#D4A373', gen:qRoman }
  ];

  var MODE_BY_K = {};
  MODES.forEach(function(m){ MODE_BY_K[m.k]=m; });
  function modeName(k){ return MODE_BY_K[k].name.replace(/&amp;/g,'&'); }

  /* ---------------------------------------------------------
     State
     --------------------------------------------------------- */
  var LS_RUNS='qm_runs_v3', LS_BEST='qm_best_v3', LS_SOUND='qm_sound_v2', LS_CFG='qm_cfg_v3';
  /* questions to practise: kept between visits, replayed exactly, ten at a time,
     and practice only unlocks once ten are saved */
  var LS_TRICKY='qm_tricky_v1', TRICKY_MAX=40, TRICKY_ROUND=10, TRICKY_UNLOCK=10;

  var S = {
    gameMode:'clock', timeLimit:90, raceLen:25, modes:['pos'],
    running:false, locked:false, paused:false,
    q:null, index:0, entry:'', wrongThisQ:false,
    correct:0, firstTry:0, streak:0, bestStreak:0,
    log:[], secs:0, elapsed:0, tick:null, cd:null,
    qMs:0, qMark:null
  };

  /* Per-question stopwatch. The mark is null whenever the clock should not be
     running (the pre-start countdown, the pause sheet, the between-question
     lock), so those never count against a question. */
  function qFreeze(){ if(S.qMark){ S.qMs += Date.now()-S.qMark; S.qMark=null; } }
  /* tenths, not whole seconds: a 1.2s answer and a 1.9s answer are different
     answers, and on the quick topics most of a run sits under three seconds */
  function qElapsedSec(){
    var ms = S.qMs + (S.qMark ? Date.now()-S.qMark : 0);
    return Math.max(0.5, Math.round(ms/100)/10);
  }

  var elPlay=$('qmPlay'), elIntro=$('qmIntro'), elResult=$('qmResult');
  var elShell=$('qmShell'), elShellScroll=$('qmShellScroll'), elLauncher=$('qmLauncher');
  var elQuestion=$('qmQuestion'), elEntry=$('qmEntry'), elFeedback=$('qmFeedback');
  var elChip=$('qmChip'), elClock=$('qmClock'), elFill=$('qmTimerFill');
  var elMiniScore=$('qmMiniScore').querySelector('strong');
  var elMiniStreakBox=$('qmMiniStreak'), elMiniStreak=$('qmMiniStreak').querySelector('strong');
  var elSetting=$('qmSetting'), elSettingLabel=$('qmSettingLabel');
  var elGrid=$('qmModeGrid'), elBestLine=$('qmBestLine');
  var elKeyMinus=$('qmKeyMinus'), elKeyDot=$('qmKeyDot');
  var elCountdown=$('qmCountdown'), elPad=$('qmPad');
  var elSheet=$('qmPauseSheet'), elAnnounce=$('qmAnnounce');

  /* ---------------------------------------------------------
     Sound: SHLC sound kit v2, shared by the SHLC games (readable
     source shared/shlc-sounds.js). Quick Maths plays in C: every key
     has its own note, right answers climb with the streak, and the
     phone buzz below is unchanged.
     --------------------------------------------------------- */
/* SHLC sound kit v2, source: shared/shlc-sounds.js */
var SHLCSounds = (function(){
var PENTA = [0, 2, 4, 7, 9];
function mtof(m){ return 440 * Math.pow(2, (m - 69) / 12); }
function rnd(a, b){ return a + Math.random() * (b - a); }
function build(a){
var comp = a.createDynamicsCompressor();
comp.threshold.value = -14; comp.knee.value = 10; comp.ratio.value = 4;
comp.attack.value = 0.003; comp.release.value = 0.18;
var out = a.createGain(); out.gain.value = 1;
out.connect(comp); comp.connect(a.destination);
var len = Math.floor(a.sampleRate), nb = a.createBuffer(1, len, a.sampleRate), d = nb.getChannelData(0);
for (var i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
var room = null;
try {
var rl = Math.floor(a.sampleRate * 1.1), ir = a.createBuffer(2, rl, a.sampleRate);
for (var c = 0; c < 2; c++){
var ch = ir.getChannelData(c);
for (var j = 0; j < rl; j++) ch[j] = (Math.random() * 2 - 1) * Math.pow(1 - j / rl, 3.2);
}
var conv = a.createConvolver(); conv.buffer = ir;
var wet = a.createGain(); wet.gain.value = 0.5;
room = a.createGain(); room.gain.value = 1;
room.connect(conv); conv.connect(wet); wet.connect(out);
} catch (e) { room = null; }
return { a: a, out: out, room: room, noise: nb };
}
function shared(){
var w = window;
if (w.__shlcAudio) return w.__shlcAudio;
var AC = w.AudioContext || w.webkitAudioContext;
if (!AC) return null;
w.__shlcAudio = build(new AC());
return w.__shlcAudio;
}
function unlockOnce(isOn){
var w = window;
(w.__shlcAudioOn = w.__shlcAudioOn || []).push(isOn);
if (w.__shlcAudioUnlock) return;
w.__shlcAudioUnlock = true;
var wake = function(){
w.__shlcAudioTapped = true;
try {
var want = false;
for (var i = 0; i < w.__shlcAudioOn.length; i++) if (w.__shlcAudioOn[i]()) want = true;
if (!want) return;
var S = shared();
if (S && S.a.state === 'suspended' && S.a.resume) S.a.resume();
} catch (e) {}
};
['pointerdown', 'keydown', 'touchend'].forEach(function(ev){ document.addEventListener(ev, wake, true); });
}
return function(cfg){
cfg = cfg || {};
var S = null, bus = null, wet = null, baseT = 0;
var root = cfg.root || 60;
var level = cfg.volume == null ? 0.6 : cfg.volume;
var free = !!cfg.ctx;
var last = {}, recent = {}, lastPick = {}, streak = 0, tock = false;
function on(){ try { return cfg.on ? !!cfg.on() : true; } catch (e) { return false; } }
if (!free) unlockOnce(on);
function tapped(){
try { if (navigator.userActivation) return navigator.userActivation.hasBeenActive; } catch (e) {}
return !!window.__shlcAudioTapped;
}
function A(){
if (!on()) return null;
if (!free && (document.hidden || !tapped())) return null;
try {
if (!S){
S = free ? build(cfg.ctx) : shared();
if (!S) return null;
busses();
}
if (S.a.state === 'suspended' && S.a.resume && !free) S.a.resume();
return S.a;
} catch (e) { return null; }
}
function busses(){
bus = S.a.createGain(); bus.gain.value = level; bus.connect(S.out);
wet = null;
if (S.room){ wet = S.a.createGain(); wet.gain.value = 1; wet.connect(S.room); }
}
function log(n, arg, v, f){
try { var L = window.__sfxLog; if (L && L.push) L.push({ n: n, a: arg, v: v, f: f ? Math.round(f) : 0, t: Date.now() }); } catch (e) {}
}
function gate(name, gap){
if (!on()) return false;
if (free) return true;
var now = Date.now();
if (last[name] && now - last[name] < (gap || 35)) return false;
last[name] = now;
var r = recent[name];
recent[name] = (r && now - r.t < 1400) ? { t: now, c: Math.min(r.c + 1, 6) } : { t: now, c: 0 };
return true;
}
function tired(name){ var r = recent[name]; return r ? Math.max(0.5, 1 - r.c * 0.1) : 1; }
function pick(name, count){
if (cfg.variant != null) return cfg.variant % count;
var p = lastPick[name], v = Math.floor(Math.random() * count);
if (count > 1 && v === p) v = (p + 1 + Math.floor(Math.random() * (count - 1))) % count;
lastPick[name] = v;
return v;
}
function vary(f, cents){ return f * Math.pow(2, rnd(-cents, cents) / 1200); }
function N(i, base){
var o = Math.floor(i / 5), r = ((i % 5) + 5) % 5;
return mtof((base == null ? root : base) + 12 * o + PENTA[r]);
}
function panOf(i){ return i == null ? 0 : Math.max(-0.4, Math.min(0.4, -0.4 + (i % 5) * 0.2)); }
function tone(o){
var a = A(); if (!a) return;
try {
var t = a.currentTime + 0.006 + baseT + (o.t || 0), dur = o.dur || 0.15, f = o.f, f1 = o.f1;
if (!o.raw) while (f > 4800){ f /= 2; if (f1) f1 /= 2; }
var osc = a.createOscillator(), g = a.createGain(), node = osc;
osc.type = o.type || 'sine';
osc.frequency.setValueAtTime(f, t);
if (f1) osc.frequency.exponentialRampToValueAtTime(f1, t + (o.glide || dur * 0.6));
if (o.lp){
var lp = a.createBiquadFilter(); lp.type = 'lowpass'; lp.Q.value = o.q || 0.7;
lp.frequency.setValueAtTime(o.lp, t);
if (o.lp1) lp.frequency.exponentialRampToValueAtTime(o.lp1, t + dur);
node.connect(lp); node = lp;
}
g.gain.setValueAtTime(0.0001, t);
g.gain.exponentialRampToValueAtTime(Math.max(0.0002, o.vol || 0.1), t + (o.att || 0.005));
g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
node.connect(g);
var dest = g;
if (o.pan && a.createStereoPanner){ var p = a.createStereoPanner(); p.pan.value = Math.max(-1, Math.min(1, o.pan)); g.connect(p); dest = p; }
dest.connect(bus);
if (o.room && wet){ var sg = a.createGain(); sg.gain.value = o.room * level; dest.connect(sg); sg.connect(wet); }
if (o.wob){
var l = a.createOscillator(), lg = a.createGain();
l.frequency.setValueAtTime(o.wob, t);
lg.gain.setValueAtTime(f * (o.wobd || 0.16), t);
lg.gain.exponentialRampToValueAtTime(0.5, t + dur);
l.connect(lg); lg.connect(osc.frequency); l.start(t); l.stop(t + dur + 0.05);
}
osc.start(t); osc.stop(t + dur + 0.05);
} catch (e) {}
}
function noise(o){
var a = A(); if (!a) return;
try {
var t = a.currentTime + 0.006 + baseT + (o.t || 0), dur = o.dur || 0.1;
var s = a.createBufferSource(), fl = a.createBiquadFilter(), g = a.createGain();
s.buffer = S.noise;
fl.type = o.kind || 'bandpass'; fl.Q.value = o.q || 1;
fl.frequency.setValueAtTime(o.f || 1000, t);
if (o.f1) fl.frequency.exponentialRampToValueAtTime(o.f1, t + dur);
g.gain.setValueAtTime(0.0001, t);
g.gain.exponentialRampToValueAtTime(Math.max(0.0002, o.vol || 0.05), t + (o.att || 0.004));
g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
s.connect(fl); fl.connect(g);
var dest = g;
if (o.pan && a.createStereoPanner){ var p = a.createStereoPanner(); p.pan.value = Math.max(-1, Math.min(1, o.pan)); g.connect(p); dest = p; }
dest.connect(bus);
s.start(t, Math.random() * Math.max(0, 0.95 - dur)); s.stop(t + dur + 0.03);
} catch (e) {}
}
function marimba(f, o){ o = o || {}; var v = o.vol || 0.1;
tone({ f: f, dur: o.dur || 0.26, vol: v, att: 0.003, t: o.t, pan: o.pan, room: o.room });
if (f * 4 < 11000) tone({ f: f * 4, dur: 0.045, vol: v * 0.3, att: 0.002, t: o.t, pan: o.pan, raw: true });
noise({ f: Math.min(f * 3, 9000), q: 2.5, dur: 0.02, vol: v * 0.6, t: o.t, pan: o.pan });
}
function glass(f, o){ o = o || {}; var v = o.vol || 0.09;
tone({ f: f, dur: o.dur || 0.6, vol: v, att: 0.002, t: o.t, pan: o.pan, room: o.room == null ? 0.25 : o.room });
if (f * 2.76 < 11000) tone({ f: f * 2.76, dur: 0.22, vol: v * 0.28, att: 0.002, t: o.t, pan: o.pan, raw: true });
if (f * 5.4 < 11000) tone({ f: f * 5.4, dur: 0.08, vol: v * 0.12, att: 0.002, t: o.t, pan: o.pan, raw: true });
}
function bubble(f, o){ o = o || {}; var v = o.vol || 0.1;
tone({ f: f * 0.55, f1: f, glide: 0.05, dur: o.dur || 0.14, vol: v, att: 0.004, t: o.t, pan: o.pan });
}
function arcade(f, o){ o = o || {}; var v = o.vol || 0.06;
tone({ f: f, dur: o.dur || 0.09, vol: v, type: 'square', lp: 2600, att: 0.002, t: o.t, pan: o.pan });
tone({ f: f * 2, dur: 0.04, vol: v * 0.4, type: 'square', lp: 3000, att: 0.002, t: (o.t || 0) + 0.045, pan: o.pan });
}
function wood(f, o){ o = o || {}; var v = o.vol || 0.08;
tone({ f: f * 1.5, f1: f, glide: 0.012, dur: 0.06, vol: v, att: 0.001, t: o.t, pan: o.pan });
noise({ f: Math.min(f * 2.2, 9000), q: 4, dur: 0.025, vol: v * 1.5, t: o.t, pan: o.pan });
}
function pluck(f, o){ o = o || {}; var v = o.vol || 0.09;
tone({ f: f, dur: o.dur || 0.32, vol: v, type: 'triangle', lp: f * 6, lp1: f * 1.2, att: 0.002, t: o.t, pan: o.pan, room: o.room });
if (f * 3 < 11000) tone({ f: f * 3, dur: 0.05, vol: v * 0.2, att: 0.001, t: o.t, pan: o.pan, raw: true });
}
var INST = { marimba: marimba, glass: glass, bubble: bubble, arcade: arcade, wood: wood, pluck: pluck };
function thud(){ tone({ f: 150, f1: 80, glide: 0.07, dur: 0.1, vol: 0.12, att: 0.003, lp: 600 }); }
function sparkle(t, count){
for (var j = 0; j < count; j++){
tone({ f: N(10 + Math.floor(Math.random() * 6), root + 12), dur: 0.09, vol: 0.03, att: 0.002, t: t + j * rnd(0.035, 0.06), pan: rnd(-0.6, 0.6), room: 0.3 });
}
}
function key(k){
if (!gate('key:' + k, 25)) return;
var s = String(k).toLowerCase(), d = parseInt(s, 10), b = root + 12;
if (/^[0-9]$/.test(s)){
var i = d === 0 ? -1 : d - 1, f = vary(N(i, b), 5);
var pan = d === 0 ? 0 : [-0.28, 0, 0.28][(d - 1) % 3];
(INST[cfg.keys] || marimba)(f, { vol: 0.09 * Math.pow(0.975, i) * tired('key:' + k), pan: pan });
log('key', d, 0, f);
return;
}
switch (s){
case 'del': case 'back': case 'backspace': case 'delete': case 'erase':
tone({ f: vary(N(5, b), 10), f1: N(0, b), glide: 0.07, dur: 0.1, vol: 0.08, att: 0.003 });
noise({ f: 2800, q: 1.5, dur: 0.025, vol: 0.06 });
s = 'del'; break;
case 'clear': case 'c':
marimba(N(4, b), { vol: 0.04 }); marimba(N(1, b), { vol: 0.035, t: 0.06 }); marimba(N(-2, b), { vol: 0.03, t: 0.12 });
s = 'clear'; break;
case '-': case 'minus': case '−':
wood(N(-3, b), { vol: 0.14 }); s = '-'; break;
case '.': case 'point':
wood(N(12, b), { vol: 0.09 }); s = '.'; break;
case 'enter': case 'ok': case 'go':
marimba(N(0, b), { vol: 0.035 }); marimba(N(4, b), { vol: 0.04, t: 0.05 }); s = 'enter'; break;
default:
thud(); s = 'full';
}
log('key', s);
}
function combo(tier){
var steps = Math.min(3 + tier, 7), b = root + 12;
for (var j = 0; j < steps; j++) glass(N(j * 2, b), { vol: 0.07 + j * 0.006, t: j * 0.055, pan: -0.3 + j * (0.6 / steps), room: 0.2 });
sparkle(steps * 0.055, 4 + tier);
}
function right(n){
if (!gate('right', 60)) return;
streak = n == null ? streak + 1 : n;
if (cfg.combo !== false && streak > 0 && streak % 5 === 0){ combo(streak / 5); log('right', streak, 'combo', N(0, root + 12)); return; }
var i = streak <= 10 ? Math.max(0, streak - 1) : 7 + (streak % 3);
var v = pick('right', 3), f = vary(N(i, root + 12), 4), pan = rnd(-0.12, 0.12);
if (v === 0){ glass(f, { vol: 0.095, pan: pan }); glass(f * 1.5, { vol: 0.04, t: 0.07, pan: pan, room: 0.15 }); }
else if (v === 1){ marimba(f, { vol: 0.095, pan: pan }); glass(N(i + 2, root + 12), { vol: 0.064, t: 0.075, pan: pan }); }
else { bubble(f, { vol: 0.1, pan: pan }); glass(N(i + 5, root + 12), { vol: 0.06, t: 0.06, pan: pan }); }
log('right', streak, v, f);
}
function ok(){
if (!gate('ok', 120)) return;
glass(N(2, root + 12), { vol: 0.03 }); glass(N(4, root + 12), { vol: 0.033, t: 0.09 });
log('ok');
}
function wrong(){
if (!gate('wrong', 120)) return;
streak = 0;
var v = pick('wrong', 3), k = tired('wrong');
if (v === 0){
tone({ f: vary(mtof(root + 7), 6), dur: 0.13, vol: 0.052 * k, type: 'triangle', lp: 1500, att: 0.01 });
tone({ f: vary(mtof(root + 4), 6), f1: mtof(root + 4) * 0.96, glide: 0.2, dur: 0.24, vol: 0.052 * k, type: 'triangle', lp: 1100, att: 0.01, t: 0.13 });
} else if (v === 1){
tone({ f: vary(mtof(root + 4), 8), f1: mtof(root - 3), glide: 0.09, dur: 0.2, vol: 0.13 * k, lp: 900, wob: 22, wobd: 0.05, att: 0.004 });
} else {
tone({ f: vary(mtof(root), 6), dur: 0.1, vol: 0.041 * k, type: 'square', lp: 700, att: 0.01 });
tone({ f: vary(mtof(root - 3), 6), f1: mtof(root - 3) * 0.97, glide: 0.15, dur: 0.2, vol: 0.041 * k, type: 'square', lp: 600, att: 0.01, t: 0.11 });
}
log('wrong', null, v);
}
function almost(){
if (!gate('almost', 150)) return;
tone({ f: N(1, root + 12), dur: 0.1, vol: 0.07, type: 'triangle', att: 0.004 });
tone({ f: N(2, root + 12), f1: N(2, root + 12) * 1.02, dur: 0.2, vol: 0.07, type: 'triangle', att: 0.004, t: 0.1 });
log('almost');
}
function reveal(){
if (!gate('reveal', 150)) return;
glass(N(4, root + 12), { vol: 0.043 }); glass(N(2, root + 12), { vol: 0.036, t: 0.12 });
log('reveal');
}
function finish(pct, pass){
if (!on()) return;
log('finish', pct == null ? null : Math.round(pct * 100), pass);
if (pct == null) win(0);
else if (pass != null && pct < pass) done();
else if (pct >= 1) win(2);
else if (pct >= Math.max(0.8, pass || 0)) win(1);
else if (pct >= 0.5 || pass != null) win(0);
else done();
}
function done(){
if (!gate('done', 400)) return;
var b = root + 12;
marimba(N(2, b), { vol: 0.044 }); marimba(N(1, b), { vol: 0.041, t: 0.12 }); marimba(N(3, b), { vol: 0.047, t: 0.24, dur: 0.4 });
glass(N(5, b), { vol: 0.017, t: 0.26 });
log('done');
}
function tick(left){
if (!gate('tick', 150)) return;
tock = !tock;
var urgent = left != null && left <= 3, f = (tock ? 1850 : 1400) * (urgent ? 1.26 : 1);
noise({ f: f, q: 6, dur: 0.028, vol: urgent ? 0.4 : 0.3 });
tone({ f: f / 2, dur: 0.03, vol: urgent ? 0.12 : 0.08, att: 0.001 });
log('tick', left, tock ? 1 : 0, f);
}
function timeUp(){
if (!gate('timeup', 400)) return;
tone({ f: 1050, f1: 330, glide: 0.42, dur: 0.48, vol: 0.057, wob: 9, wobd: 0.03, att: 0.01 });
tone({ f: 110, f1: 70, glide: 0.1, dur: 0.18, vol: 0.09, t: 0.44, att: 0.004 });
log('timeup');
}
function count(n){
if (!gate('count' + n, 200)) return;
var i = n >= 3 ? 0 : n === 2 ? 2 : 4, f = N(i, root + 12);
wood(f, { vol: 0.085 }); marimba(f, { vol: 0.14 });
log('count', n, 0, f);
}
function go(){
if (!gate('go', 200)) return;
[0, 4, 7, 12].forEach(function(s, j){ tone({ f: mtof(root + 12 + s), dur: 0.42, vol: 0.06, type: 'triangle', att: 0.004, t: j * 0.012, room: 0.2 }); });
noise({ kind: 'bandpass', f: 500, f1: 4200, dur: 0.3, vol: 0.12, q: 0.8 });
log('go', null, 0, mtof(root + 12));
}
var MOTIFS = [[0, 2, 4, 5], [2, 4, 2, 5], [0, 3, 4, 7], [4, 3, 4, 6], [0, 1, 2, 5]];
function win(tier){
if (!gate('win', 600)) return;
tier = tier || 0;
var v = pick('win', MOTIFS.length), m = MOTIFS[v], b = root + 12, step = 0.105;
m.forEach(function(i, j){ marimba(N(i, b), { vol: 0.12, t: j * step, pan: -0.2 + j * 0.13 }); });
var tc = m.length * step + 0.02, top = m[m.length - 1];
[top - 5, top - 3, top - 1, top].forEach(function(i){
tone({ f: vary(N(i, b), 6), dur: 0.8 + tier * 0.4, vol: 0.05, type: 'triangle', att: 0.01, t: tc, room: 0.25 });
});
glass(N(top + 5, b), { vol: 0.06, t: tc + 0.02 });
if (tier > 0){
for (var j = 0; j < 8; j++) glass(N(top + j, b), { vol: 0.035, t: tc + 0.12 + j * 0.045, pan: rnd(-0.5, 0.5), room: 0.3 });
tone({ f: N(top - 10, b), dur: 1.0, vol: 0.08, type: 'triangle', t: tc, att: 0.01 });
}
for (var c = 0; c < 6 + tier * 4; c++) noise({ kind: 'highpass', f: rnd(2000, 5200), dur: 0.045, vol: 0.12, t: tc + 0.18 + c * rnd(0.06, 0.1), pan: rnd(-0.7, 0.7) });
log('win', tier, v);
}
function medal(t){
if (!gate('medal', 300)) return;
t = Math.max(1, Math.min(3, t || 1));
for (var j = 0; j <= t; j++) glass(N(j * 2, root + 12), { vol: 0.08, t: j * 0.09, room: 0.25 });
if (t >= 3) sparkle((t + 1) * 0.09 + 0.05, 8);
log('medal', t);
}
function star(i){
if (!gate('star' + i, 80)) return;
glass(N(5 + (i || 0) * 2, root + 12), { vol: 0.08, room: 0.25 });
noise({ kind: 'highpass', f: 5000, dur: 0.06, vol: 0.08, t: 0.02 });
log('star', i);
}
function best(){
if (!gate('best', 400)) return;
[5, 7, 10].forEach(function(i, j){ glass(N(i, root + 12), { vol: 0.09, t: j * 0.1 }); });
sparkle(0.32, 7);
log('best');
}
function tally(i){
if (!gate('tally', 45)) return;
wood(N((i || 0) % 12, root + 12), { vol: 0.07 * tired('tally') });
log('tally', i);
}
function ui(kind, i){
if (!gate('ui:' + kind + (i == null ? '' : ':' + i), 40)) return;
var b = root + 12, v, hz = 0;
switch (kind){
case 'play':
bubble(N(0, b), { vol: 0.045 }); bubble(N(2, b), { vol: 0.045, t: 0.07 }); bubble(N(5, b), { vol: 0.055, t: 0.14, dur: 0.2 });
noise({ kind: 'bandpass', f: 600, f1: 3200, dur: 0.22, vol: 0.04, q: 0.9, t: 0.06 }); break;
case 'next':
marimba(N(2, b), { vol: 0.045 }); marimba(N(5, b), { vol: 0.05, t: 0.08 }); break;
case 'open':
noise({ kind: 'bandpass', f: 500, f1: 2600, dur: 0.16, vol: 0.1, q: 1.1 }); wood(N(7, b), { vol: 0.045, t: 0.08 }); break;
case 'close':
noise({ kind: 'bandpass', f: 2400, f1: 450, dur: 0.16, vol: 0.1, q: 1.1 }); wood(N(0, b), { vol: 0.045, t: 0.08 }); break;
case 'back':
wood(N(5, b), { vol: 0.07 }); wood(N(2, b), { vol: 0.06, t: 0.07 });
noise({ kind: 'bandpass', f: 1800, f1: 700, dur: 0.08, vol: 0.06, q: 1.2 }); break;
case 'help':
tone({ f: N(0, b), dur: 0.09, vol: 0.045, type: 'triangle', att: 0.004 });
tone({ f: N(3, b), f1: N(3, b) * 1.03, dur: 0.16, vol: 0.045, type: 'triangle', att: 0.004, t: 0.09 }); break;
case 'on':
wood(N(4, b), { vol: 0.06 }); tone({ f: N(5, b), f1: N(7, b), glide: 0.04, dur: 0.08, vol: 0.07, t: 0.03 }); break;
case 'off':
wood(N(2, b), { vol: 0.06 }); tone({ f: N(4, b), f1: N(1, b), glide: 0.05, dur: 0.09, vol: 0.06, t: 0.03 }); break;
case 'select':
hz = N(i == null ? Math.floor(Math.random() * 5) : i % 10, b);
pluck(hz, { vol: 0.08, pan: panOf(i) }); break;
case 'tab':
hz = N(((i || 0) % 8) + 2, b);
wood(hz, { vol: 0.1 }); break;
case 'level':
hz = N(((i || 1) - 1) % 10, b);
pluck(hz, { vol: 0.08 }); break;
case 'slide':
hz = N(Math.round((i || 0) * 10), b);
wood(hz, { vol: 0.06 }); break;
case 'pause':
tone({ f: N(4, b), dur: 0.08, vol: 0.052, type: 'triangle', lp: 2000 });
tone({ f: N(1, b), dur: 0.14, vol: 0.052, type: 'triangle', lp: 1400, t: 0.08 }); break;
case 'resume':
tone({ f: N(1, b), dur: 0.08, vol: 0.052, type: 'triangle', lp: 2000 });
tone({ f: N(4, b), dur: 0.14, vol: 0.052, type: 'triangle', lp: 2400, t: 0.08 }); break;
case 'restart':
tone({ f: 900, f1: 180, glide: 0.24, dur: 0.26, vol: 0.05, type: 'sawtooth', lp: 1600, lp1: 500, wob: 28, wobd: 0.08 });
wood(N(0, b), { vol: 0.06, t: 0.25 }); break;
case 'undo':
tone({ f: N(5, b), f1: N(1, b), glide: 0.07, dur: 0.11, vol: 0.1, att: 0.003 }); break;
case 'hint':
noise({ kind: 'bandpass', f: 700, f1: 5200, dur: 0.35, vol: 0.06, q: 0.8 });
for (var j = 0; j < 3; j++) glass(N(7 + j * 2 + Math.min(i || 0, 4), b), { vol: 0.028, t: 0.05 + j * 0.07, room: 0.3 }); break;
case 'skip':
noise({ kind: 'bandpass', f: 1200, f1: 3800, dur: 0.09, vol: 0.28, q: 1.4 }); break;
case 'denied':
thud(); break;
case 'ask':
wood(N(-2, b), { vol: 0.07 });
tone({ f: N(1, b), f1: N(2, b) * 1.02, glide: 0.12, dur: 0.18, vol: 0.05, type: 'triangle', att: 0.006, t: 0.08 }); break;
case 'start':
var up = i == null ? 5 : 3 + ((i * 3) % 7);
noise({ kind: 'bandpass', f: 400, f1: 2600, dur: 0.28, vol: 0.08, q: 0.9 });
tone({ f: N(0, root), f1: N(up, root), glide: 0.18, dur: 0.22, vol: 0.05 }); break;
default:
v = pick('tap', 3);
wood([N(9, b), N(10, b), N(8, b)][v], { vol: 0.07 });
kind = 'tap';
}
log('ui', kind, i, hz);
}
function cell(i){
if (!gate('cell', 30)) return;
var f = N(((i || 0) % 10) + 3, root + 12);
var k = tired('cell');
tone({ f: f, dur: 0.05, vol: 0.075 * k, att: 0.002, type: 'triangle' });
noise({ f: Math.min(f * 2, 8000), q: 5, dur: 0.018, vol: 0.11 });
log('cell', i, 0, f);
}
function place(p, pan){
if (!gate('place', 30)) return;
var i = p == null ? Math.floor(Math.random() * 8) : Math.round(Math.max(0, Math.min(1, p)) * 9);
var f = vary(N(i, root + 12), 5);
(INST[cfg.place] || bubble)(f, { vol: 0.11, pan: pan });
noise({ f: 2400, q: 3, dur: 0.03, vol: 0.08 });
log('place', p, 0, f);
}
function remove(p){
if (!gate('remove', 40)) return;
var f = N(p == null ? 5 : Math.round(p * 9) + 2, root + 12);
tone({ f: f, f1: f * 0.4, glide: 0.13, dur: 0.15, vol: 0.09 });
log('remove', p, 0, f);
}
function land(){
if (!gate('land', 60)) return;
var v = pick('land', 3), f0 = [190, 220, 170][v];
tone({ f: f0, f1: f0 * 2.9, glide: 0.06, dur: 0.36, vol: 0.095, type: 'triangle', wob: 16 + v * 2, wobd: 0.16, t: 0.04 });
log('land', null, v);
}
function lift(){
if (!gate('lift', 60)) return;
tone({ f: N(2, root + 12), f1: N(4, root + 12), glide: 0.05, dur: 0.07, vol: 0.08 });
log('lift');
}
function drag(i, fits){
if (!gate('drag', 55)) return;
wood(N((i || 0) % 15, root + 12), { vol: 0.05 * tired('drag') });
if (fits) glass(N(((i || 0) % 10) + 5, root + 12), { vol: 0.03, dur: 0.25, room: 0.15 });
log('drag', i, fits ? 1 : 0);
}
function group(kind, count, idx){
if (!gate('group', 120)) return;
var s = ((kind || 0) % 3) * 2 + ((idx || 0) % 2), n = 2 + Math.max(1, Math.min(3, count || 1));
for (var j = 0; j < n; j++) glass(N(5 + s + j, root), { vol: 0.045 + j * 0.004, t: j * 0.06, pan: -0.2 + j * 0.1 });
if (n >= 5) sparkle(n * 0.06, 4);
log('group', kind, count || 1);
}
function pencil(){
if (!gate('pencil', 30)) return;
noise({ kind: 'highpass', f: rnd(3800, 5200), dur: rnd(0.035, 0.06), vol: 0.11 });
noise({ kind: 'bandpass', f: rnd(2500, 3200), q: 3, dur: 0.03, vol: 0.065, t: 0.035 });
log('pencil');
}
function scribble(){
if (!gate('scribble', 120)) return;
for (var j = 0; j < 4; j++) noise({ kind: 'bandpass', f: rnd(1800, 3400), q: 1.8, dur: 0.05, vol: 0.16, t: j * 0.055 });
log('scribble');
}
function sign(op){
if (!gate('sign', 30)) return;
var b = root + 12, o = String(op);
if (o === '+'){ pluck(N(2, b), { vol: 0.056 }); pluck(N(4, b), { vol: 0.042, t: 0.045 }); }
else if (o === '-' || o === '−'){ pluck(N(4, b), { vol: 0.056 }); pluck(N(2, b), { vol: 0.042, t: 0.045 }); }
else if (o === '*' || o === 'x' || o === '×'){ glass(N(5, b), { vol: 0.038, dur: 0.3 }); glass(N(7, b), { vol: 0.03, t: 0.035, dur: 0.3 }); }
else { pluck(N(1, b), { vol: 0.052, pan: -0.25 }); pluck(N(6, b), { vol: 0.045, t: 0.06, pan: 0.25 }); }
log('sign', o);
}
function card(i){
if (!gate('card', 40)) return;
var j = i == null ? Math.floor(Math.random() * 10) : i;
var k = tired('card');
noise({ kind: 'bandpass', f: rnd(2200, 3200), q: 1.2, dur: 0.05, vol: 0.2 * k, pan: rnd(-0.2, 0.2) });
noise({ kind: 'lowpass', f: 420, q: 0.8, dur: 0.05, vol: 0.2, t: 0.02 });
var f = N(j % 10, root + 12);
tone({ f: f, dur: 0.07, vol: 0.025, att: 0.002, t: 0.015 });
log('card', i, 0, f);
}
function flip(i){
if (!gate('flip', 40)) return;
noise({ kind: 'bandpass', f: 1500, f1: 4200, dur: 0.08, vol: 0.19 * tired('flip'), q: 1.4 });
var f = N(((i || 0) % 10) + 2, root + 12);
pluck(f, { vol: 0.028, t: 0.05 });
log('flip', i, 0, f);
}
function letter(i, vowel){
if (!gate('letter', 30)) return;
var f = N((i || 0) % 10, root + 12);
if (vowel) glass(f * 2, { vol: 0.07, dur: 0.35 }); else marimba(f, { vol: 0.1 });
log('letter', i, vowel ? 1 : 0, f);
}
function type(ch){
if (!gate('type', 20)) return;
var c = String(ch == null ? ' ' : ch).charCodeAt(0) || 0;
noise({ kind: 'bandpass', f: 2200 + (c % 7) * 260, q: 2.2, dur: 0.018, vol: 0.35 });
tone({ f: 180 + (c % 5) * 22, dur: 0.02, vol: 0.09, att: 0.001 });
log('type', ch);
}
function option(i){
if (!gate('opt:' + i, 30)) return;
pluck(N((i || 0) * 2, root + 12), { vol: 0.08, pan: panOf(i) });
log('option', i, 0, N((i || 0) * 2, root + 12));
}
function swish(dir){
if (!gate('swish', 50)) return;
var up = dir !== 'down' && dir !== -1;
noise({ kind: 'bandpass', f: up ? 600 : 3000, f1: up ? 3000 : 600, dur: 0.14, vol: 0.55, q: 1.3 });
log('swish', dir);
}
function fold(dir){
if (!gate('fold', 60)) return;
var open = dir === 'open' || dir === -1;
for (var j = 0; j < 3; j++) noise({ kind: 'bandpass', f: rnd(1500, 3500), q: 2, dur: 0.025, vol: 0.12, t: j * rnd(0.02, 0.04) });
tone({ f: open ? 160 : 240, f1: open ? 250 : 160, glide: 0.06, dur: 0.08, vol: 0.05, t: 0.07 });
if (open) noise({ kind: 'bandpass', f: 900, f1: 2600, dur: 0.12, vol: 0.12, q: 1.2, t: 0.03 });
log('fold', open ? 'open' : dir);
}
function shuffle(){
if (!gate('shuffle', 150)) return;
var b = root + 12;
for (var j = 0; j < 5; j++) wood(N(Math.floor(Math.random() * 10), b), { vol: 0.05, t: j * 0.045, pan: rnd(-0.4, 0.4) });
bubble(N(5, b), { vol: 0.06, t: 0.25 });
log('shuffle');
}
function nitro(){
if (!gate('nitro', 200)) return;
tone({ f: 110, f1: 520, glide: 0.45, dur: 0.55, vol: 0.13, type: 'sawtooth', lp: 500, lp1: 3000 });
noise({ kind: 'bandpass', f: 400, f1: 3600, dur: 0.5, vol: 0.2, q: 0.7 });
log('nitro');
}
function skid(){
if (!gate('skid', 150)) return;
noise({ kind: 'bandpass', f: 2600, f1: 900, dur: 0.32, vol: 0.18, q: 3 });
tone({ f: 420, f1: 300, glide: 0.3, dur: 0.3, vol: 0.02, type: 'sawtooth', lp: 1200, wob: 30, wobd: 0.04 });
log('skid');
}
function lap(n, final){
if (!gate('lap', 300)) return;
var b = root + 12, i = (n || 1) * 2;
glass(N(i, b), { vol: 0.07 }); glass(N(i + 2, b), { vol: 0.075, t: 0.1 });
if (final){ glass(N(i + 4, b), { vol: 0.08, t: 0.2 }); sparkle(0.3, 5); }
log('lap', n, final ? 1 : 0);
}
function whoosh(dir){
if (!gate('whoosh', 120)) return;
var down = dir === 'down' || dir === -1;
noise({ kind: 'bandpass', f: down ? 3000 : 600, f1: down ? 450 : 3400, dur: 0.3, vol: down ? 0.12 : 0.15, q: 1.1 });
tone({ f: down ? 640 : 420, f1: down ? 360 : 720, glide: 0.25, dur: 0.28, vol: 0.045 });
log('whoosh', down ? 'down' : dir);
}
var timers = [];
function after(ms, fn){
var id = setTimeout(function(){ timers = timers.filter(function(x){ return x !== id; }); try { fn(); } catch (e) {} }, ms);
timers.push(id);
return id;
}
function hush(){
timers.forEach(clearTimeout); timers = [];
if (!S || !bus || free) return;
try {
var now = S.a.currentTime, old = [bus, wet];
old.forEach(function(g){ if (!g) return; g.gain.cancelScheduledValues(now); g.gain.setValueAtTime(g.gain.value, now); g.gain.linearRampToValueAtTime(0.0001, now + 0.06); });
setTimeout(function(){ old.forEach(function(g){ try { if (g) g.disconnect(); } catch (e) {} }); }, 250);
busses();
} catch (e) {}
}
function bind(el, map){
if (!el || !el.addEventListener) return;
el.addEventListener('click', function(e){
var tg = e.target && e.target.closest ? e.target : (e.target && e.target.parentElement);
if (!tg) return;
for (var j = 0; j < map.length; j++){
var hit = tg.closest(map[j][0]);
if (hit && el.contains(hit)){
var s = map[j][1];
if (typeof s === 'function') s(hit, e);
else ui(s, typeof map[j][2] === 'function' ? map[j][2](hit) : map[j][2]);
return;
}
}
}, true);
}
return {
key: key, right: right, ok: ok, wrong: wrong, almost: almost, reveal: reveal,
combo: function(t){ if (gate('combo', 200)){ combo(t || 1); log('combo', t); } },
tick: tick, timeUp: timeUp, count: count, go: go,
win: win, medal: medal, star: star, best: best, tally: tally,
ui: ui, cell: cell, place: place, remove: remove, land: land, lift: lift, drag: drag, group: group,
pencil: pencil, scribble: scribble, sign: sign, card: card, flip: flip,
letter: letter, type: type, option: option, swish: swish, fold: fold, shuffle: shuffle, nitro: nitro, whoosh: whoosh,
finish: finish, done: done, skid: skid, lap: lap,
bind: bind, note: N, after: after, hush: hush,
streak: function(n){ if (n != null) streak = n; return streak; },
at: function(sec){ baseT = sec || 0; }
};
};
})();
  var soundOn=true;
  try { soundOn = localStorage.getItem(LS_SOUND)!=='0'; } catch(e){}
  var SFX = SHLCSounds({ on: function(){ return soundOn; }, root: 60, keys: 'marimba' });
  function buzz(ms){ if(navigator.vibrate){ try { navigator.vibrate(ms); } catch(e){} } }

  function syncSound(){
    $('qmSoundBtn').classList.toggle('is-muted', !soundOn);
    $('qmSheetSound').setAttribute('aria-checked', soundOn ? 'true' : 'false');
    try { localStorage.setItem(LS_SOUND, soundOn?'1':'0'); } catch(e){}
  }
  /* turning on sets the flag then plays on; turning off plays off then clears it */
  function toggleSound(){
    if(soundOn){ SFX.ui('off'); soundOn=false; }
    else { soundOn=true; SFX.ui('on'); }
    syncSound();
  }
  $('qmSoundBtn').addEventListener('click', toggleSound);
  $('qmSheetSound').addEventListener('click', toggleSound);
  syncSound();

  /* ---------------------------------------------------------
     Intro: mode tiles
     --------------------------------------------------------- */
  MODES.forEach(function(m, mi){
    var b=document.createElement('button');
    var st=window.QM_STK||{};
    b.type='button'; b.className='qm-tile';
    b.setAttribute('data-k', m.k);
    b.setAttribute('aria-pressed','false');
    b.setAttribute('title', m.ex.replace(/&amp;/g,'&'));
    b.style.setProperty('--c', m.c);
    b.innerHTML = '<span class="qm-tile-tick" aria-hidden="true">'+(st.tick||'')+'</span>'
                + '<span class="qm-tile-stk" aria-hidden="true">'+(st['t-'+m.k]||'<span class="qm-tile-sym">'+m.sym+'</span>')+'</span>'
                + '<span class="qm-tile-name">'+m.name+'</span>';
    b.addEventListener('click', function(){ toggleMode(m.k, mi); });
    elGrid.appendChild(b);
  });

  /* Whole-group shortcuts. Every topic sits in exactly one group, so tapping
     two groups is the fast way to build a mixed session. */
  var GROUPS = [
    { n:'Number',      ks:['pos','tab','pow','neg','p10','bid','rnd','pla','fac','avg','rom'] },
    { n:'Fractions &amp; ratio', ks:['fra','dec','pct','rat'] },
    { n:'Algebra',     ks:['alg','seq','fnm'] },
    { n:'Shape',       ks:['ang','ape','shf'] },
    { n:'Measures',    ks:['tim','cal','uni'] }
  ];
  var elGroups=$('qmGroups');
  GROUPS.forEach(function(g, gi){
    var b=document.createElement('button');
    b.type='button'; b.className='qm-group';
    b.setAttribute('aria-pressed','false');
    b.innerHTML=g.n;
    b.addEventListener('click', function(){ toggleGroup(g, gi); });
    elGroups.appendChild(b);
  });
  function groupOn(g){
    for(var i=0;i<g.ks.length;i++){ if(S.modes.indexOf(g.ks[i])===-1) return false; }
    return true;
  }
  function toggleGroup(g, at){
    if(groupOn(g)){
      var left=S.modes.filter(function(k){ return g.ks.indexOf(k)===-1; });
      if(!left.length){ SFX.ui('denied'); return; }                 /* never leave the run with no topics */
      S.modes=left;
    } else {
      g.ks.forEach(function(k){ if(S.modes.indexOf(k)===-1) S.modes.push(k); });
    }
    SFX.ui('select', at);
    syncModes(); saveCfg(); showBest();
  }

  function toggleMode(k, at){
    var i=S.modes.indexOf(k);
    if(i>-1){ if(S.modes.length===1){ SFX.ui('denied'); return; } S.modes.splice(i,1); }
    else S.modes.push(k);
    SFX.ui('select', at);
    syncModes(); saveCfg(); showBest();
  }
  function syncModes(){
    Array.prototype.forEach.call(elGrid.children, function(b){
      b.setAttribute('aria-pressed', S.modes.indexOf(b.getAttribute('data-k'))>-1 ? 'true' : 'false');
    });
    Array.prototype.forEach.call(elGroups.children, function(b,i){
      b.setAttribute('aria-pressed', groupOn(GROUPS[i]) ? 'true' : 'false');
    });
    $('qmSelectAll').textContent = (S.modes.length===MODES.length) ? 'Clear topics' : 'All topics';
    /* sequences can run past zero, so they need the minus key too */
    elKeyMinus.disabled = !( S.modes.indexOf('neg')>-1 || S.modes.indexOf('seq')>-1 );
    elKeyDot.disabled   = !( S.modes.indexOf('dec')>-1 || S.modes.indexOf('p10')>-1 || S.modes.indexOf('rnd')>-1 || S.modes.indexOf('uni')>-1 );
  }
  $('qmSelectAll').addEventListener('click', function(){
    S.modes = (S.modes.length===MODES.length) ? ['pos'] : MODES.map(function(m){ return m.k; });
    SFX.ui(S.modes.length===MODES.length ? 'on' : 'off');
    syncModes(); saveCfg(); showBest();
  });

  /* ---------------------------------------------------------
     Intro: game mode + length
     --------------------------------------------------------- */
  var CLOCK_OPTS = [[60,'1 min'],[90,'1½ min'],[120,'2 min'],[180,'3 min'],[300,'5 min']];
  var RACE_OPTS  = [[10,'10 questions'],[25,'25 questions'],[50,'50 questions']];

  function setGameMode(mode){
    S.gameMode=mode;
    $('qmModeClock').setAttribute('aria-pressed', mode==='clock' ? 'true' : 'false');
    $('qmModeRace').setAttribute('aria-pressed',  mode==='race'  ? 'true' : 'false');
    elSettingLabel.textContent = 'Round length';

    var opts = (mode==='clock') ? CLOCK_OPTS : RACE_OPTS;
    var valid = opts.map(function(o){ return o[0]; });
    var cur = (mode==='clock') ? S.timeLimit : S.raceLen;
    if(valid.indexOf(cur)===-1){ cur = (mode==='clock') ? 90 : 25; }
    if(mode==='clock') S.timeLimit=cur; else S.raceLen=cur;

    /* round length is a slider that snaps to the set choices; the labels under it can be tapped too */
    var idx=Math.max(0, valid.indexOf(cur)), long=lenLong(mode, cur);
    elSetting.innerHTML = '<div class="qm-slide" style="--n:'+opts.length+';--i:'+idx+'">'
      + '<div class="qm-slide-val" aria-hidden="true">'+long+'</div>'
      + '<div class="qm-slide-track"><span class="qm-slide-rail"></span><span class="qm-slide-fill"></span>'
      + opts.map(function(o, i){ return '<span class="qm-slide-tick" style="--t:'+i+'"></span>'; }).join('')
      + '<input type="range" class="qm-slide-input" min="0" max="'+(opts.length-1)+'" step="1" value="'+idx+'" aria-labelledby="qmSettingLabel" aria-valuetext="'+long+'"></div>'
      + '<div class="qm-stops">'+opts.map(function(o, i){ return '<button type="button" class="qm-stop" data-i="'+i+'" aria-pressed="'+(i===idx ? 'true' : 'false')+'">'+o[1]+'</button>'; }).join('')+'</div>'
      + '</div>';
    saveCfg(); showBest();
  }
  function setSetting(v){
    if(S.gameMode==='clock') S.timeLimit=v; else S.raceLen=v;
    var opts = (S.gameMode==='clock') ? CLOCK_OPTS : RACE_OPTS;
    var idx=Math.max(0, opts.map(function(o){ return o[0]; }).indexOf(v)), box=elSetting.querySelector('.qm-slide');
    if(box){
      var long=lenLong(S.gameMode, v), inp=box.querySelector('.qm-slide-input');
      box.style.setProperty('--i', idx);
      box.querySelector('.qm-slide-val').textContent=long;
      if(+inp.value!==idx) inp.value=idx;
      inp.setAttribute('aria-valuetext', long);
      Array.prototype.forEach.call(box.querySelectorAll('.qm-stop'), function(b, i){ b.setAttribute('aria-pressed', i===idx ? 'true' : 'false'); });
    }
    saveCfg(); showBest();
  }
  $('qmModeClock').addEventListener('click', function(){ SFX.ui('select', 0); setGameMode('clock'); });
  $('qmModeRace').addEventListener('click',  function(){ SFX.ui('select', 1); setGameMode('race');  });
  function lenLong(mode, v){ return mode==='clock' ? (START_LEN[v] || fmtTime(v)) : v+' questions'; }
  elSetting.addEventListener('input', function(e){
    var t=e.target;
    if(!t || !t.classList || !t.classList.contains('qm-slide-input')) return;
    var opts=(S.gameMode==='clock') ? CLOCK_OPTS : RACE_OPTS, o=opts[+t.value];
    if(o && o[0]!==setting()){ buzz(6); SFX.ui('slide', +t.value/(opts.length-1)); setSetting(o[0]); }
  });
  elSetting.addEventListener('click', function(e){
    var b=(e.target && e.target.closest) ? e.target.closest('.qm-stop') : null;
    if(!b) return;
    var i=+b.getAttribute('data-i'), o=((S.gameMode==='clock') ? CLOCK_OPTS : RACE_OPTS)[i];
    if(o){ SFX.ui('select', i); setSetting(o[0]); }
  });

  /* ---------------------------------------------------------
     Persistence
     --------------------------------------------------------- */
  function modeSig(){ return S.modes.slice().sort().join(','); }
  function setting(){ return S.gameMode==='clock' ? S.timeLimit : S.raceLen; }

  function saveCfg(){
    try { localStorage.setItem(LS_CFG, JSON.stringify({ g:S.gameMode, t:S.timeLimit, r:S.raceLen, m:S.modes })); } catch(e){}
  }
  function loadCfg(){
    try {
      var c=JSON.parse(localStorage.getItem(LS_CFG)||'null');
      if(!c) return;
      if(c.g==='race'||c.g==='clock') S.gameMode=c.g;
      if(c.t) S.timeLimit=c.t;
      if(c.r) S.raceLen=c.r;
      if(Object.prototype.toString.call(c.m)==='[object Array]'){
        var m=c.m.filter(function(k){ return !!MODE_BY_K[k]; });
        if(m.length) S.modes=m;
      }
    } catch(e){}
  }
  function getRuns(){ try { return JSON.parse(localStorage.getItem(LS_RUNS)||'[]'); } catch(e){ return []; } }
  /* a stored run was ended early if it says so (x:1) or, for races saved before
     that flag existed, if it answered fewer questions than the set length */
  function runStopped(r){ return r.x===1 || (r.g==='race' && typeof r.n==='number' && r.n < r.set); }
  /* a run only counts as comparable if mode, length AND topic selection match,
     and it ran to the end. Comparing a full run against an abandoned one gives
     a "faster than last time" that means nothing. */
  function lastComparable(){
    var runs=getRuns(), sig=modeSig(), st=setting();
    for(var i=0;i<runs.length;i++){
      if(runs[i].g===S.gameMode && runs[i].set===st && runs[i].m===sig && !runStopped(runs[i])) return runs[i];
    }
    return null;
  }

  function bestKey(){ return S.gameMode+':'+setting()+':'+modeSig(); }
  function getBest(){ try { return JSON.parse(localStorage.getItem(LS_BEST)||'{}'); } catch(e){ return {}; } }
  /* the start bar says what the run will be, and the best on exactly that setup */
  var START_LEN = {60:'1 minute', 90:'1½ minutes', 120:'2 minutes', 180:'3 minutes', 300:'5 minutes'};
  var START_BTN = {60:'1-minute', 90:'90-second', 120:'2-minute', 180:'3-minute', 300:'5-minute'};
  function showBest(){
    var n=S.modes.length, clock=S.gameMode==='clock';
    var lenTxt = clock ? (START_LEN[S.timeLimit] || fmtTime(S.timeLimit)) : S.raceLen+' questions';
    $('qmStartSum').textContent = (n===MODES.length ? 'All topics' : n+(n===1 ? ' topic' : ' topics'))+', '+lenTxt;
    $('qmStartLabel').textContent = clock ? 'Start '+(START_BTN[S.timeLimit] || '')+' round' : 'Start '+S.raceLen+'-question race';
    var b=getBest()[bestKey()];
    var span=elBestLine.querySelector('span');
    if(b===undefined || b===null){ elBestLine.classList.remove('is-on'); return; }
    elBestLine.classList.add('is-on');
    span.innerHTML = clock ? 'Best: <strong>'+b+' right</strong>' : 'Best: <strong>'+fmtTime(b)+'</strong>';
  }
  function saveBest(value){
    var all=getBest(), k=bestKey(), cur=all[k];
    var better = (cur===undefined || cur===null) || (S.gameMode==='clock' ? value>cur : value<cur);
    if(better){ all[k]=value; try { localStorage.setItem(LS_BEST, JSON.stringify(all)); } catch(e){} }
    return better;
  }

  /* ---------------------------------------------------------
     Question flow
     --------------------------------------------------------- */
  var lastModeK=null, recent=[], modeBag=[], runSeen={}, shapeSeen={};
  var RECENT_MAX=16;
  /* The sub-shape of a question, found by masking every number out of it: two
     "Mode of ..." or two "Round # to the nearest #" in one run read as the same
     question even though the digits differ. Each topic cycles through its own
     shapes and only starts them again once they have all been used. */
  function shapeSig(q){
    return (q.plain||q.t).replace(/<[^>]+>/g,'§').replace(/-?\d[\d,.]*/g,'#').replace(/\s+/g,' ').trim();
  }
  /* Topics are dealt from a shuffled bag rather than picked at random each time.
     Random picking clusters: with four topics chosen you could still get the same
     one three times in five questions. A bag deals every chosen topic once before
     any of them comes round again, and the reshuffle never repeats the topic that
     ended the last bag, so nothing lands back to back either. */
  function refillBag(){
    var b=S.modes.slice();
    for(var i=b.length-1;i>0;i--){
      var j=Math.floor(Math.random()*(i+1)), t=b[i]; b[i]=b[j]; b[j]=t;
    }
    if(b.length>1 && b[0]===lastModeK){ var s=b[0]; b[0]=b[1]; b[1]=s; }
    modeBag=b;
  }
  function nextMode(){
    /* drop anything deselected since the bag was filled */
    modeBag = modeBag.filter(function(k){ return S.modes.indexOf(k)>-1; });
    if(!modeBag.length) refillBag();
    return modeBag.shift();
  }
  function newQuestion(){
    if(S.practice){ practiceQuestion(); return; }
    var k=nextMode(), m=MODE_BY_K[k], q, guard=0;
    /* Multiple-choice stems are all identical ("Which is bigger?"), so the key
       carries the options too or every one after the first reads as a repeat. */
    var key=function(x){ return x.t + (x.choices ? '|'+x.choices.join(',') : ''); };
    if(!shapeSeen[k]) shapeSeen[k]={};
    /* Three things are rejected, in order of how much they matter:
       the exact same question twice in a run, the same question in the last
       sixteen, and the same sub-shape before the topic's others have had a turn.
       Small topics would never satisfy all three, so the shape rule is dropped
       after fifteen tries and the topic's shape list starts a fresh cycle. */
    var sig, ok;
    do {
      q=m.gen(); guard++;
      sig=shapeSig(q);
      ok = !runSeen[key(q)] && recent.indexOf(key(q))===-1;
      if(ok && guard<15) ok = !shapeSeen[k][sig];
      if(!ok && guard===15) shapeSeen[k]={};
    } while(!ok && guard<40);
    runSeen[key(q)]=1;
    shapeSeen[k][sig]=1;
    recent.push(key(q));
    if(recent.length>RECENT_MAX) recent.shift();
    lastModeK=k;
    showQuestion(q, k);
  }
  function snapQ(){
    try { var c=JSON.parse(JSON.stringify(S.q)); delete c.mode; return c; } catch(e){ return null; }
  }
  /* a practice round replays saved questions exactly, in the order dealt at the start */
  function practiceQuestion(){
    var it=S.practice[S.index], q;
    if(!it) return;
    try { q=JSON.parse(JSON.stringify(it.q)); } catch(e){ return; }
    showQuestion(q, it.m);
  }
  function showQuestion(q, k){
    var m=MODE_BY_K[k];
    q.mode=k;
    S.q=q; S.entry=''; S.wrongThisQ=false;
    S.qMs=0; S.qMark = S.running ? Date.now() : null;

    elPlay.style.setProperty('--qcol', m.c);
    elPlay.style.setProperty('--qcol-soft', rgba(m.c,0.16));
    elPlay.style.setProperty('--qcol-line', rgba(m.c,0.55));
    elChip.classList.remove('is-off');
    elChip.querySelector('.qm-chip-name').textContent = modeName(k);
    elChip.querySelector('.qm-chip-stk').innerHTML = stkHtml('t-'+k);
    elQuestion.classList.toggle('is-list', !!q.list);
    if(q.choices){
      /* the options are numbered, so the answer is whichever key they press */
      elQuestion.innerHTML = escapeHtml(q.t) + '<span class="qm-opts">'
        + q.choices.map(function(c,i){ return '<span class="qm-opt"><b>'+(i+1)+'</b>'+escapeHtml(c)+'</span>'; }).join('')
        + '</span>';
    }
    else if(q.html) elQuestion.innerHTML=q.t;
    else elQuestion.textContent=q.t;
    setFeedback('', null);
    renderEntry();
    renderHud();
  }

  /* On a clock question the entry holds bare digits and the colon is drawn in,
     so a child types 2 1 1 5 and sees 21:15 without hunting for a colon key. */
  function isTimeQ(){ return !!(S.q && S.q.time); }
  function timeMask(d){ return d.length<=2 ? d : d.slice(0,2)+':'+d.slice(2); }
  function renderEntry(){
    elEntry.classList.remove('is-ok','is-bad');
    if(S.entry===''){
      elEntry.textContent = isTimeQ() ? '--:--' : '?';
      elEntry.classList.add('is-empty');
      return;
    }
    elEntry.classList.remove('is-empty');
    elEntry.textContent = isTimeQ() ? timeMask(S.entry) : S.entry.replace('-','−');
  }

  function setFeedback(text, kind){
    elFeedback.className='qm-feedback' + (kind ? ' is-'+kind : '');
    if(!text){ elFeedback.innerHTML='<span></span>'; return; }
    var st = kind ? stkHtml(kind==='ok' ? 'tick' : 'cross') : '';
    var ico = !kind ? '' : (st ? '<span class="qm-fb-stk" aria-hidden="true">'+st+'</span>' : (kind==='ok' ? ICON.tick : (kind==='bad' ? ICON.cross : '')));
    elFeedback.innerHTML = ico + '<span>' + text + '</span>';
    elAnnounce.textContent = text;
  }

  function renderHud(){
    elMiniScore.textContent = (S.gameMode==='clock')
      ? String(S.correct)
      : (S.correct + '/' + S.raceLen);
    elMiniStreak.textContent=String(S.streak);
    elMiniStreakBox.classList.toggle('is-hot', S.streak>=3);
    if(S.gameMode==='race'){
      /* in Race the bar shows how far through the set they are */
      elFill.style.transform='scaleX('+Math.min(1, S.index/S.raceLen)+')';
    }
  }

  function press(k){
    if(!S.running || S.locked || S.paused) return;
    if(k==='skip'){ SFX.ui('skip'); buzz(18); onSkip(); return; }
    if(k==='del'){
      if(!S.entry) return;
      S.entry=S.entry.slice(0,-1);
    } else if(k==='-'){
      if(isTimeQ() || elKeyMinus.disabled) return;
      S.entry = (S.entry.charAt(0)==='-') ? S.entry.slice(1) : '-'+S.entry;
    } else if(k==='.'){
      if(isTimeQ() || elKeyDot.disabled || S.entry.indexOf('.')>-1) return;
      S.entry = (S.entry===''||S.entry==='-') ? S.entry+'0.' : S.entry+'.';
    } else if(isTimeQ()){
      if(S.entry.length>=4) return;      /* four digits, leading zeros kept: 08:05 */
      S.entry+=k;
    } else if(S.q && S.q.choices){
      /* only a listed option counts, so a stray key is not marked wrong */
      if(+k < 1 || +k > S.q.choices.length) return;
      S.entry=k;
    } else {
      if(S.entry.replace(/[-.]/g,'').length>=8) return;
      if(S.entry==='0') S.entry='';
      else if(S.entry==='-0') S.entry='-';
      S.entry+=k;
    }
    SFX.key(k); buzz(7);
    renderEntry();
    check();
  }

  function check(){
    var e=S.entry;
    if(isTimeQ()){
      if(e.length<4) return;
      if(timeMask(e)===S.q.a) onCorrect(); else onWrong();
      return;
    }
    if(e==='' || e==='-' || e.charAt(e.length-1)==='.') return;
    var v=parseFloat(e);
    if(!isFinite(v)) return;
    if(Math.abs(v - S.q.a) < 1e-9){ onCorrect(); return; }
    if(e.length >= String(round(S.q.a,4)).length) onWrong();
  }

  function onCorrect(){
    S.locked=true;
    S.correct++;
    if(!S.wrongThisQ) S.firstTry++;
    S.streak++;
    if(S.streak>S.bestStreak) S.bestStreak=S.streak;
    qFreeze();
    S.log.push({ m:S.q.mode, t:S.q.t, p:S.q.plain, html:!!S.q.html, a:(S.q.choices ? S.q.choices[S.q.a-1] : S.q.a), ok:true, first:!S.wrongThisQ, s:qElapsedSec(), q:snapQ() });
    elEntry.classList.remove('is-bad'); elEntry.classList.add('is-ok');
    setFeedback(S.wrongThisQ ? 'Got there' : (S.streak>=5 ? 'On fire' : 'Correct'), 'ok');
    /* the last key's note first, then the right answer, climbing with the streak */
    var n=S.streak;
    SFX.after(90, function(){ SFX.right(n); });
    buzz(14);
    S.index++;
    renderHud();
    setTimeout(function(){
      S.locked=false;
      if(S.gameMode==='race' && S.index>=S.raceLen){ finish(false); return; }
      newQuestion();
    }, reduceMotion ? 120 : 270);
  }

  function onWrong(){
    var wasFirst = !S.wrongThisQ;
    S.wrongThisQ=true;
    S.streak=0;
    elEntry.classList.remove('is-ok'); elEntry.classList.add('is-bad');
    setFeedback(wasFirst ? 'Not quite. Try again.' : 'Still not right. Try again.', 'bad');
    SFX.after(90, function(){ SFX.wrong(); });
    buzz(38);
    renderHud();
    S.locked=true;
    setTimeout(function(){
      S.locked=false;
      S.entry='';
      renderEntry();
    }, reduceMotion ? 140 : 320);
  }

  function onSkip(){
    qFreeze();
    S.log.push({ m:S.q.mode, t:S.q.t, p:S.q.plain, html:!!S.q.html, a:(S.q.choices ? S.q.choices[S.q.a-1] : S.q.a), ok:false, first:false, s:qElapsedSec(), q:snapQ() });
    S.streak=0;
    S.index++;
    if(S.gameMode==='race' && S.index>=S.raceLen){ finish(false); return; }
    newQuestion();
  }

  /* ---------------------------------------------------------
     Keypad + physical keyboard
     --------------------------------------------------------- */
  function closestKey(node){
    while(node && node!==elPad){
      if(node.classList && node.classList.contains('qm-key')) return node;
      node=node.parentNode;
    }
    return null;
  }
  elPad.addEventListener('click', function(e){
    var b=closestKey(e.target);
    if(!b || b.disabled) return;
    flashKey(b); press(b.getAttribute('data-k'));
  });
  function flashKey(b){
    b.classList.add('is-down');
    setTimeout(function(){ b.classList.remove('is-down'); }, 110);
  }
  function keyEl(k){ return elPad.querySelector('.qm-key[data-k="'+k+'"]'); }

  document.addEventListener('keydown', function(e){
    if($('qmSaved').classList.contains('is-on')){
      if(e.key==='Escape') closeSaved();
      return;
    }
    if($('qmHistory').classList.contains('is-on')){
      if(e.key==='Escape') closeHistory();
      return;
    }
    if(!elPlay.classList.contains('is-on')){
      /* full screen, but not mid-run: Escape backs out to the page */
      if(e.key==='Escape' && elShell.classList.contains('is-on')){ e.preventDefault(); closeApp(); }
      return;
    }
    if(e.key==='Escape'){ e.preventDefault(); S.paused ? resume() : pause(); return; }
    if(!S.running || S.paused) return;
    var k=e.key, mapped=null;
    if(k>='0' && k<='9') mapped=k;
    else if(k==='.' || k===',') mapped='.';
    else if(k==='-' || k==='_') mapped='-';
    else if(k==='Backspace' || k==='Delete') mapped='del';
    else if(k==='Enter') mapped='skip';
    if(!mapped) return;
    e.preventDefault();
    var b=keyEl(mapped);
    if(b && b.disabled) return;
    if(b) flashKey(b);
    press(mapped);
  });

  /* ---------------------------------------------------------
     Start / countdown / timer / pause / finish
     --------------------------------------------------------- */
  /* The whole tool runs full screen: settings, the run and the results. It boots
     closed, on a launcher card, so anyone landing here can read the page and
     reach the rest of the site before the app takes over the screen. */
  /* Scroll lock that actually holds. body{overflow:hidden} is ignored by iOS
     Safari and still lets the page behind drift, so the body is pinned at its
     current offset and put back exactly where it was on the way out. */
  var lockY=0, isLocked=false;
  function syncLock(){
    var want = elShell.classList.contains('is-on') || elPlay.classList.contains('is-on');
    if(want===isLocked) return;
    isLocked=want;
    var b=document.body, h=document.documentElement;
    if(want){
      lockY = window.pageYOffset || h.scrollTop || 0;
      b.classList.add('qm-lock');
      b.style.position='fixed'; b.style.top=(-lockY)+'px';
      b.style.left='0'; b.style.right='0'; b.style.width='100%';
      h.style.overflow='hidden';
    } else {
      b.classList.remove('qm-lock');
      b.style.position=''; b.style.top=''; b.style.left=''; b.style.right=''; b.style.width='';
      h.style.overflow='';
      /* the document has not finished re-expanding yet, so the first scroll can
         clamp to 0. Re-apply once the layout has settled. */
      window.scrollTo(0, lockY);
      (function(y){ setTimeout(function(){ window.scrollTo(0, y); }, 0); })(lockY);
    }
  }
  function openStage(){ elPlay.classList.add('is-on'); syncLock(); }
  function closeStage(){
    elPlay.classList.remove('is-on','is-low','is-prestart');
    elCountdown.classList.remove('is-on');
    elSheet.classList.remove('is-on');
    syncLock();
  }
  function showScreen(which, boot){
    var inShell = (which==='intro' || which==='result');
    elIntro.classList.toggle('is-on', which==='intro');
    elResult.classList.toggle('is-on', which==='result');
    elShell.classList.toggle('is-on', inShell);
    elLauncher.classList.toggle('is-on', which==='closed');
    syncLock();
    if(inShell) elShellScroll.scrollTop=0;
    /* not on the first paint: the browser is still restoring its own scroll
       position, and yanking it to the top fights a back button or an anchor */
    if(which==='closed' && !boot) window.scrollTo(0,0);
    if(which==='closed') showLaunchBest();
    if(which==='intro') restoreSavedSettings();
    if(which==='closed' || which==='intro'){ renderLast(); renderTricky(); }
  }
  function closeApp(){ SFX.hush(); SFX.ui('close'); showScreen('closed'); $('qmOpen').focus(); }
  $('qmOpen').addEventListener('click', function(){ SFX.ui('open'); showScreen('intro'); });

  /* ---------------------------------------------------------
     Launcher quick starts. Both skip the settings screen.
     - "Start a 60-second round": Beat the Clock 1:00 on the topics
       saved from the settings screen, or a small mix on a first visit.
     - A topic wall tile: 1:00 on just that topic, as a one-off, so the
       saved topics are left as they were.
     --------------------------------------------------------- */
  var QUICK_MIX = ['pos','tab','fra','pct'];
  function savedModes(){
    try {
      var c=JSON.parse(localStorage.getItem(LS_CFG)||'null');
      if(c && Object.prototype.toString.call(c.m)==='[object Array]'){
        var m=c.m.filter(function(k){ return !!MODE_BY_K[k]; });
        if(m.length) return m;
      }
    } catch(e){}
    return QUICK_MIX.slice();
  }
  /* snd, at: the starting button's sound and its index, passed on to start() */
  function quickStart(modes, oneOff, mode, len, snd, at){
    var before=null;
    try { before=localStorage.getItem(LS_CFG); } catch(e){}
    S.modes=modes.slice();
    syncModes();
    setGameMode(mode || 'clock');
    setSetting(len || 60);
    if(oneOff){
      oneOffLive=true;
      try { if(before===null) localStorage.removeItem(LS_CFG); else localStorage.setItem(LS_CFG, before); } catch(e){}
    }
    start(snd, at);
  }
  function showLaunchBest(){
    var box=$('qmLaunchBest');
    if(!box) return;
    var b=getBest()['clock:60:'+savedModes().sort().join(',')];
    if(b===undefined || b===null){ box.hidden=true; return; }
    $('qmLaunchBestN').textContent=b;
    box.hidden=false;
  }
  $('qmQuick').addEventListener('click', function(){ quickStart(savedModes(), false, null, null, 'play'); });

  /* ---------------------------------------------------------
     Last practice: replays the newest saved run exactly, the same
     mode, length and topics, even on a later visit. It runs as a
     one-off like a topic tile, so saved settings stay as they were.
     --------------------------------------------------------- */
  var LAST_LEN = {60:'1 minute', 90:'1½ minutes', 120:'2 minutes', 180:'3 minutes', 300:'5 minutes'};
  var MODE_ORDER = {};
  MODES.forEach(function(m, i){ MODE_ORDER[m.k]=i; });
  /* the newest run whose whole setup can still be replayed exactly; a run with an
     unknown or repeated topic, or a length the game no longer offers, is skipped */
  function lastRun(){
    var runs=getRuns();
    for(var i=0;i<runs.length;i++){
      var r=runs[i];
      if(!r || typeof r.m!=='string' || (r.g!=='clock' && r.g!=='race')) continue;
      var m=r.m.split(','), seen={}, ok=m.length>0;
      m.forEach(function(k){ if(!MODE_BY_K[k] || seen[k]) ok=false; seen[k]=1; });
      var set=Number(r.set), opts=(r.g==='clock') ? CLOCK_OPTS : RACE_OPTS;
      if(!ok || !opts.some(function(o){ return o[0]===set; })) continue;
      m.sort(function(x, y){ return MODE_ORDER[x]-MODE_ORDER[y]; });
      return { g:r.g, set:set, m:m, stopped:runStopped(r), d:r.d };
    }
    return null;
  }
  function lastLabel(r){
    var len=(r.g==='race') ? r.set+' questions' : LAST_LEN[r.set];
    var tp=(r.m.length===MODES.length) ? 'all topics'
         : (r.m.length===1) ? modeName(r.m[0])
         : (r.m.length===2) ? modeName(r.m[0])+' and '+modeName(r.m[1])
         : r.m.length+' topics';
    return len+', '+tp;
  }
  function lastHeading(r){
    if(r.stopped) return 'Last practice, stopped early';
    var t=new Date(r.d);
    if(isNaN(t.getTime())) return 'Last practice';
    var day=function(x){ return new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime(); };
    var ago=Math.round((day(new Date())-day(t))/86400000);
    return 'Last practice, '+(ago<=0 ? 'today' : ago===1 ? 'yesterday' : t.toLocaleDateString('en-GB', {day:'numeric', month:'short'}));
  }
  function lastStickers(r){
    var icons=window.QM_STK||{}, html='';
    r.m.slice(0,3).forEach(function(k){ if(icons['t-'+k]) html+=icons['t-'+k]; });
    if(r.m.length>3) html+='<b>+'+(r.m.length-3)+'</b>';
    return html;
  }
  function renderLast(){
    var r=lastRun();
    [['qmLast','qmLastD','qmLastStk','qmLastH','qmLastGo'], ['qmLastBar','qmLastBarD','qmLastBarStk','qmLastBarH','qmLastBar']].forEach(function(ids){
      var box=$(ids[0]);
      if(!box) return;
      if(!r){ box.hidden=true; return; }
      var label=lastLabel(r);
      $(ids[1]).textContent=label;
      $(ids[2]).innerHTML=lastStickers(r);
      $(ids[3]).textContent=lastHeading(r);
      $(ids[4]).setAttribute('aria-label', 'Play your last practice again: '+label);
      box.hidden=false;
    });
  }
  /* a one-off (a replay or a topic tile) changes the live settings but not the saved
     ones, so the settings screen puts the saved choices back before it shows */
  var oneOffLive=false;
  function restoreSavedSettings(){
    if(!oneOffLive) return;
    oneOffLive=false;
    var before=null;
    try { before=localStorage.getItem(LS_CFG); } catch(e){}
    S.gameMode='clock'; S.timeLimit=90; S.raceLen=25; S.modes=['pos'];
    loadCfg();
    setGameMode(S.gameMode);
    syncModes();
    showBest();
    if(before===null){ try { localStorage.removeItem(LS_CFG); } catch(e){} }
  }
  window.addEventListener('storage', function(e){ if(e.key===LS_RUNS || e.key===null) renderLast(); });
  function playLast(){
    var r=lastRun();
    if(r) quickStart(r.m, true, r.g, r.set, 'play');
  }
  $('qmLastGo').addEventListener('click', playLast);
  $('qmLastBar').addEventListener('click', playLast);

  /* ---------------------------------------------------------
     Tricky ones: a question that was skipped, needed a second
     try, or took far longer than usual is saved (the exact
     question, between visits). A practice round replays up to
     ten of them inside the app; one answered right first time
     comes off the list.
     --------------------------------------------------------- */
  var practiceNext=null, againPractice=false;
  /* the answer and format are part of the identity, so two questions that read alike never merge */
  function trickyKey(m, q){ return m+'|'+JSON.stringify([q.plain||q.t, q.choices||0, q.a, q.time ? 1 : 0]); }
  function getTricky(){
    try {
      var l=JSON.parse(localStorage.getItem(LS_TRICKY)||'[]');
      if(Object.prototype.toString.call(l)!=='[object Array]') return [];
      return l.filter(function(it){ return it && MODE_BY_K[it.m] && it.q && typeof it.q.t==='string'; })
              .map(function(it){ it.k=trickyKey(it.m, it.q); return it; });
    } catch(e){ return []; }
  }
  function saveTricky(l){ try { localStorage.setItem(LS_TRICKY, JSON.stringify(l.slice(0, TRICKY_MAX))); return true; } catch(e){ return false; } }
  function trickyQHtml(q){ return q.plain ? escapeHtml(q.plain) : (q.html ? q.t : escapeHtml(q.t)); }
  function updateTricky(slowFlags){
    var list=getTricky(), byKey={}, fresh=[], seen={}, now=new Date().toISOString();
    var res={ added:0, cleared:0, stronger:0, show:null, before:list.length };
    list.forEach(function(it){ byKey[it.k]=it; });
    /* slow is judged against the child's own pace in this round: at least four answers right
       first time, with skips left out of the baseline */
    var base=[];
    S.log.forEach(function(r){ if(r.ok && r.first && typeof r.s==='number') base.push(r.s); });
    var slowAt = base.length>=4 ? Math.max(median(base)*3, 8) : Infinity;
    S.log.forEach(function(r){
      if(!r.q || typeof r.q.t!=='string') return;
      var k=trickyKey(r.m, r.q);
      if(seen[k]) return;
      seen[k]=1;
      var have=byKey[k];
      /* in a practice round every question is already a tricky one, so speed does not count */
      var clean = r.ok && r.first && (S.practice || !(typeof r.s==='number' && r.s>slowAt));
      if(clean){
        if(!have) return;
        /* right first time in two different rounds clears it; one lucky answer does not */
        have.good=(have.good||0)+1;
        if(have.good>=2){ delete byKey[k]; res.cleared++; } else res.stronger++;
        return;
      }
      var why = !r.ok ? 'skip' : (!r.first ? 'second' : 'slow');
      if(have){ delete byKey[k]; have.miss=(have.miss||1)+1; have.good=0; have.d=now; have.why=why; fresh.push(have); }
      else fresh.push({ k:k, m:r.m, q:r.q, miss:1, good:0, d:now, why:why });
      if(!S.practice){
        res.added++;
        if(!res.show || (r.s||0) > (res.show.s||0)) res.show=r;
      }
    });
    /* newest first: the last question of the round goes to the front, so the cap drops the oldest */
    var out=fresh.reverse().concat(list.filter(function(it){ return byKey[it.k]===it; })).slice(0, TRICKY_MAX);
    res.saveFailed=!saveTricky(out);
    res.left=out.length;
    return res;
  }
  /* below ten: a bar fills towards ten so the child can see practice coming */
  function unlockHtml(n, again){
    var shown=Math.min(n, TRICKY_UNLOCK), need=TRICKY_UNLOCK-shown, pct=Math.round(shown/TRICKY_UNLOCK*100);
    return '<span class="qm-pr-unlock"><span class="qm-pr-bar" role="progressbar" aria-label="Practice questions ready" aria-valuemin="0" aria-valuemax="'+TRICKY_UNLOCK+'" aria-valuenow="'+shown+'"><i style="width:'+pct+'%"></i></span>'
      + '<span class="qm-pr-lock">'+shown+' of '+TRICKY_UNLOCK+' ready. '+need+' more to '+(again ? 'practise again.' : 'start practice.')+'</span></span>';
  }
  function prCard(stk, head, main, sub){
    return '<span class="qm-pr-stk" aria-hidden="true">'+stkHtml(stk)+'</span>'
      + '<span class="qm-pr-txt"><span class="h">'+head+'</span><b>'+main+'</b><span>'+sub+'</span></span>';
  }
  function qCount(n){ return n+(n===1 ? ' question' : ' questions'); }
  function renderPractiseCard(trk){
    var pr=$('qmPractise'), open=trk.left>=TRICKY_UNLOCK;
    var warn = trk.saveFailed ? '<span class="qm-pr-warn">Practice list is not being saved on this device.</span>' : '';
    pr.hidden=true; pr.innerHTML='';
    againPractice=false;
    $('qmAgainLabel').textContent='Play again';
    $('qmAgain').classList.remove('is-quiet');
    if(S.practice){
      var done=[];
      if(trk.cleared) done.push(trk.cleared+' cleared');
      if(trk.stronger) done.push(trk.stronger+' getting stronger');
      if(open){ againPractice=true; $('qmAgainLabel').textContent='Practise next 10'; }
      else if(trk.left) $('qmAgainLabel').textContent='Play a normal round';
      pr.innerHTML = prCard(trk.left ? 'topics' : 'trophy', trk.left ? 'Your tricky ones' : 'Practice list cleared',
          done.length ? done.join(', ') : 'None cleared this time',
          trk.left ? qCount(trk.left)+' still to practise' : 'Nothing left to practise.')
        + (trk.stronger ? '<span class="qm-pr-note">Right again next time clears them.</span>' : '')
        + (trk.left && !open ? unlockHtml(trk.left, true) : '') + (trk.left ? SAVED_LINK : '') + warn;
      pr.hidden=false;
      return;
    }
    if(!trk.added && !trk.cleared && !trk.stronger){
      if(warn){ pr.innerHTML=warn; pr.hidden=false; }
      return;
    }
    var html;
    if(open && trk.before<TRICKY_UNLOCK){
      html = prCard('tick', 'Practice ready', trk.left+' questions ready', '10 at a time');
    } else if(!trk.added){
      html = prCard('tick', 'Practice questions', trk.cleared ? qCount(trk.cleared)+' cleared' : qCount(trk.stronger)+' getting stronger', 'Right first time');
    } else {
      var r=trk.show;
      html = prCard('t-'+r.m, trk.added===1 ? 'Saved to practise' : trk.added+' questions saved to practise', trickyQHtml(r.q),
        !r.ok ? 'You skipped this one' : (!r.first ? 'Right on the second try' : 'Right, but it took '+secWords(r.s)));
    }
    if(open){
      html += '<button type="button" class="qm-practise-go is-main" id="qmPractiseGo"><span class="qm-stk" aria-hidden="true">'+stkHtml('play')+'</span><span>Practise 10 questions</span></button>';
      /* once practice is ready it is the main action on this screen */
      $('qmAgain').classList.add('is-quiet');
    } else if(trk.left){
      html += unlockHtml(trk.left, false);
    }
    pr.innerHTML = html + (trk.left ? SAVED_LINK : '') + warn;
    pr.hidden=false;
  }
  function renderTricky(){
    var l=getTricky(), n=l.length, ms=[];
    renderSavedEntry(n);
    l.forEach(function(it){ if(ms.indexOf(it.m)===-1) ms.push(it.m); });
    var st=ms.slice(0,3).map(function(k){ return stkHtml('t-'+k); }).join('') + (ms.length>3 ? '<b>+'+(ms.length-3)+'</b>' : '');
    var d=n+(n===1 ? ' question' : ' questions')+' saved on this device';
    [['qmTricky','qmTrickyStk','qmTrickyD','qmTrickyGo'], ['qmTrickyBar','qmTrickyBarStk','qmTrickyBarD','qmTrickyBar']].forEach(function(ids){
      var box=$(ids[0]);
      if(!box) return;
      if(n<TRICKY_UNLOCK){ box.hidden=true; return; }
      $(ids[1]).innerHTML=st;
      $(ids[2]).textContent=d;
      $(ids[3]).setAttribute('aria-label', 'Practise your tricky ones: '+d);
      box.hidden=false;
    });
  }
  function startTricky(snd){
    var all=getTricky();
    if(all.length<TRICKY_UNLOCK) return;
    /* questions not yet answered right in practice come first, newest first within each group */
    var deal=all.filter(function(it){ return !it.good; }).concat(all.filter(function(it){ return it.good; })).slice(0, TRICKY_ROUND);
    for(var i=deal.length-1;i>0;i--){ var j=Math.floor(Math.random()*(i+1)), t=deal[i]; deal[i]=deal[j]; deal[j]=t; }
    var before=null, ms=[];
    try { before=localStorage.getItem(LS_CFG); } catch(e){}
    deal.forEach(function(it){ if(ms.indexOf(it.m)===-1) ms.push(it.m); });
    S.modes=ms;
    syncModes();
    setGameMode('race');
    S.raceLen=deal.length;
    oneOffLive=true;
    try { if(before===null) localStorage.removeItem(LS_CFG); else localStorage.setItem(LS_CFG, before); } catch(e){}
    practiceNext=deal;
    start(snd);
  }
  $('qmTrickyGo').addEventListener('click', function(){ startTricky('play'); });
  $('qmTrickyBar').addEventListener('click', function(){ startTricky('play'); });

  /* ---------------------------------------------------------
     Saved questions: the parent view. Every saved question by
     topic, why it was saved, answers behind a switch so a child
     does not read them first, remove one or clear the list.
     --------------------------------------------------------- */
  var SAVED_LINK='<button type="button" class="qm-pr-link" id="qmSavedFromCard">See saved questions</button>';
  var savedAnswers=false, savedReturn=null;
  function whenTxt(iso){
    var t=new Date(iso);
    if(isNaN(t.getTime())) return '';
    var day=function(x){ return new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime(); };
    var ago=Math.round((day(new Date())-day(t))/86400000);
    return ago<=0 ? 'Today' : (ago===1 ? 'Yesterday' : t.toLocaleDateString('en-GB', {day:'numeric', month:'short'}));
  }
  function savedAnswer(q){
    if(q.choices) return escapeHtml(String(q.choices[q.a-1]));
    return escapeHtml(String(q.a)).replace(/^-/, '−');
  }
  function renderSavedEntry(n){
    $('qmSavedOpen').hidden=!n;
    $('qmSavedOpenD').textContent=n+(n===1 ? ' question' : ' questions')+' to practise';
    $('qmSavedLink').hidden=!n;
    if($('qmSaved').classList.contains('is-on')) renderSaved();
  }
  function renderSaved(){
    var l=getTricky(), n=l.length, stronger=l.filter(function(it){ return it.good; }).length;
    $('qmSavedSum').innerHTML = '<span class="qm-sv-count"><b>'+n+'</b><span>'+(n===1 ? 'question saved' : 'questions saved')+'</span></span>'
      + '<span class="qm-sv-status"><b>'+(n>=TRICKY_UNLOCK ? 'Practice is ready' : n+' of '+TRICKY_UNLOCK+'. Practice starts at '+TRICKY_UNLOCK+'.')+'</b>'
      + (stronger ? '<span>'+stronger+' getting stronger</span>' : '')+'</span>'
      + (n>=TRICKY_UNLOCK ? '<button type="button" class="qm-btn qm-btn--cta" id="qmSavedGo"><span class="qm-stk" aria-hidden="true">'+stkHtml('play')+'</span><span>Practise 10 now</span></button>' : '');
    var host=$('qmSavedList');
    host.classList.toggle('show-answers', savedAnswers);
    $('qmSavedAnswers').setAttribute('aria-checked', savedAnswers ? 'true' : 'false');
    $('qmSavedAnswers').hidden=!n;
    $('qmSavedConfirm').hidden=true;
    $('qmSavedClear').hidden=!n;
    if(!n){
      host.innerHTML='<div class="qm-runs-empty"><span class="qm-runs-empty-stk" aria-hidden="true">'+stkHtml('tick')+'</span>'
        + '<b>Nothing saved</b><span>Skipped and tricky questions will show here.</span></div>';
      return;
    }
    var by={}, html='';
    l.forEach(function(it){ (by[it.m]=by[it.m]||[]).push(it); });
    MODES.forEach(function(m){
      var g=by[m.k];
      if(!g) return;
      html += '<h3 class="qm-sv-topic"><span class="stk" aria-hidden="true">'+stkHtml('t-'+m.k)+'</span><span>'+m.name+'</span><em>'+g.length+'</em></h3>';
      g.forEach(function(it){
        var tags=[], why={ skip:'Skipped', second:'Second try', slow:'Slow' }[it.why], w=whenTxt(it.d);
        if(why) tags.push('<span class="tag">'+why+'</span>');
        if((it.miss||1)>=2) tags.push('<span class="tag">Missed '+it.miss+' times</span>');
        if(it.good) tags.push('<span class="tag str">Getting stronger</span>');
        if(w) tags.push('<span>'+w+'</span>');
        html += '<div class="qm-sv-row" data-k="'+escapeHtml(it.k)+'">'
          + '<div class="qm-sv-q">'+trickyQHtml(it.q)
          + (it.q.choices ? '<span class="qm-sv-ch">'+it.q.choices.map(function(c){ return escapeHtml(String(c)); }).join(' or ')+'</span>' : '')+'</div>'
          + '<div class="qm-sv-meta">'+tags.join('')+'</div>'
          + '<div class="qm-sv-a">Answer: <b>'+savedAnswer(it.q)+'</b></div>'
          + '<button type="button" class="qm-iconbtn qm-sv-x" aria-label="Remove this question">&times;</button>'
          + '</div>';
      });
    });
    host.innerHTML=html;
  }
  /* focus goes back to whatever opened the list, even when a tap did not focus it */
  function openSaved(from){
    SFX.ui('open');
    savedReturn=(from && from.nodeType===1) ? from : document.activeElement;
    renderSaved();
    $('qmSaved').classList.add('is-on');
    $('qmSavedClose').focus();
  }
  function closeSaved(quiet){
    if(!quiet && $('qmSaved').classList.contains('is-on')) SFX.ui('close');
    $('qmSaved').classList.remove('is-on');
    if(savedReturn && savedReturn.focus && document.body.contains(savedReturn)){ try { savedReturn.focus(); } catch(e){} }
    savedReturn=null;
  }
  $('qmSavedOpen').addEventListener('click', function(){ openSaved(this); });
  $('qmSavedLink').addEventListener('click', function(){ openSaved(this); });
  /* wrapped: closeSaved(quiet) and closeHistory(quiet) must not receive the click event */
  $('qmSavedClose').addEventListener('click', function(){ closeSaved(); });
  $('qmPractise').addEventListener('click', function(e){
    var lk=(e.target && e.target.closest) ? e.target.closest('#qmSavedFromCard') : null;
    if(lk) openSaved(lk);
  });
  $('qmSaved').addEventListener('click', function(e){
    var t=e.target;
    if(t===$('qmSaved')){ closeSaved(); return; }
    if(!t || !t.closest) return;
    var x=t.closest('.qm-sv-x');
    if(x){
      SFX.ui('select', 1);
      var k=x.closest('.qm-sv-row').getAttribute('data-k');
      saveTricky(getTricky().filter(function(it){ return it.k!==k; }));
      renderSaved(); renderTricky();
      $('qmSavedClose').focus();
      return;
    }
    if(t.closest('#qmSavedGo')){ closeSaved(true); closeHistory(true); startTricky('play'); return; }
    if(t.closest('#qmSavedAnswers')){ savedAnswers=!savedAnswers; SFX.ui(savedAnswers ? 'on' : 'off'); renderSaved(); return; }
    if(t.closest('#qmSavedClearBtn')){ SFX.ui('ask'); $('qmSavedClear').hidden=true; $('qmSavedConfirm').hidden=false; $('qmSavedKeep').focus(); return; }
    if(t.closest('#qmSavedKeep')){ SFX.ui('select', 3); $('qmSavedConfirm').hidden=true; $('qmSavedClear').hidden=false; $('qmSavedClearBtn').focus(); return; }
    if(t.closest('#qmSavedClearYes')){ SFX.ui('select', 4); saveTricky([]); renderSaved(); renderTricky(); $('qmSavedClose').focus(); return; }
  });
  $('qmPractise').addEventListener('click', function(e){
    if(e.target && e.target.closest && e.target.closest('#qmPractiseGo')) startTricky('play');
  });
  window.addEventListener('storage', function(e){ if(e.key===LS_TRICKY || e.key===null) renderTricky(); });
  elLauncher.addEventListener('click', function(e){
    var t=(e.target && e.target.closest) ? e.target.closest('[data-qm-topic]') : null;
    if(!t) return;
    var k=t.getAttribute('data-qm-topic');
    /* each topic its own note: its place on the wall (the looping copies share it) */
    var all=elLauncher.querySelectorAll('[data-qm-topic]:not([aria-hidden])'), at=0;
    for(var j=0;j<all.length;j++){ if(all[j].getAttribute('data-qm-topic')===k){ at=j; break; } }
    if(MODE_BY_K[k]) quickStart([k], true, null, null, 'level', at+1);
  });
  $('qmCloseApp').addEventListener('click', closeApp);
  $('qmCloseApp2').addEventListener('click', closeApp);

  /* snd: the sound of the button that started the run (play, level, restart), at: its index.
     A new run first hushes the last one's sounds, still waiting or still ringing. */
  function start(snd, at){
    SFX.hush();
    if(snd) SFX.ui(snd, at);
    clearInterval(S.tick); clearInterval(S.cd);
    S.running=false; S.locked=true; S.paused=false;
    S.index=0; S.correct=0; S.firstTry=0; S.streak=0; S.bestStreak=0;
    S.log=[]; S.entry=''; S.elapsed=0;
    S.secs = (S.gameMode==='clock') ? S.timeLimit : 0;
    lastModeK=null; recent=[]; modeBag=[]; runSeen={}; shapeSeen={};
    S.practice=practiceNext; practiceNext=null;

    showScreen(null);
    openStage();
    elPlay.classList.add('is-prestart');
    elSheet.classList.remove('is-on');
    elPlay.classList.remove('is-low');
    elFill.style.transition='none';
    elFill.style.opacity='1';
    elFill.style.transform = (S.gameMode==='clock') ? 'scaleX(1)' : 'scaleX(0)';
    elClock.textContent = (S.gameMode==='clock') ? mss(S.timeLimit) : '0:00';
    newQuestion();
    renderHud();

    var n=3;
    elCountdown.classList.add('is-on');
    elCountdown.innerHTML='<span>'+n+'</span>';
    /* after a button's sound the 3 waits a moment instead of landing on top of it */
    if(snd) SFX.after(120, function(){ SFX.count(3); }); else SFX.count(3);
    S.cd=setInterval(function(){
      n--;
      if(n>0){ elCountdown.innerHTML='<span>'+n+'</span>'; SFX.count(n); return; }
      clearInterval(S.cd);
      elCountdown.innerHTML='<span>Go</span>'; SFX.go();
      setTimeout(function(){
        elCountdown.classList.remove('is-on');
        elPlay.classList.remove('is-prestart');
        beginRun();
      }, 430);
    }, 700);
  }

  function startTicking(){
    clearInterval(S.tick);
    elFill.style.transition = (S.gameMode==='clock') ? 'transform 1s linear' : 'transform .3s ease';
    S.tick=setInterval(function(){
      if(S.paused) return;
      if(S.gameMode==='clock'){
        S.secs--; S.elapsed++;
        elClock.textContent=mss(Math.max(0,S.secs));
        elFill.style.transform='scaleX('+Math.max(0, S.secs/S.timeLimit)+')';
        elPlay.classList.toggle('is-low', S.secs<=10);
        /* ticks only in the last five seconds, never through the whole round */
        if(S.secs>0 && S.secs<=5) SFX.tick(S.secs);
        if(S.secs<=0) finish(true);
      } else {
        S.elapsed++;
        elClock.textContent=mss(S.elapsed);
      }
    }, 1000);
  }

  function beginRun(){
    if(!elPlay.classList.contains('is-on')) return;
    S.running=true; S.locked=false; S.paused=false;
    S.qMs=0; S.qMark=Date.now();
    startTicking();
  }

  function pause(){
    if(!S.running || S.paused) return;
    SFX.ui('pause');
    S.paused=true;
    qFreeze();
    clearInterval(S.tick);
    $('qmPauseTitle').textContent='Paused';
    $('qmEndRun').textContent = S.practice ? 'End practice' : 'End run';
    showEndConfirm(false);
    elSheet.classList.add('is-on');
    $('qmResume').focus();
  }
  function resume(){
    if(!S.paused) return;
    SFX.ui('resume');
    S.paused=false;
    if(S.running && S.q) S.qMark=Date.now();
    elSheet.classList.remove('is-on');
    startTicking();
  }
  $('qmPause').addEventListener('click', pause);
  $('qmResume').addEventListener('click', resume);
  /* End run asks first: one stray tap on a phone should not throw a round away */
  function showEndConfirm(on){
    $('qmPauseMain').hidden=on;
    $('qmEndConfirm').hidden=!on;
    if(on){
      $('qmEndSub').textContent = S.practice
        ? (S.log.length ? 'Answers so far are checked. The rest stay saved.' : 'Your saved questions stay for later.')
        : (S.log.length ? 'It will be saved as stopped.' : 'Nothing is saved yet.');
      $('qmEndTitle').textContent = S.practice ? 'End this practice?' : 'End this run?';
      $('qmKeepPlaying').lastChild.textContent = S.practice ? 'Keep practising' : 'Keep playing';
      $('qmEndConfirmBtn').textContent = S.practice ? 'End practice' : 'End run';
      $('qmKeepPlaying').focus();
    }
  }
  function endRunNow(){
    SFX.ui('close');
    showEndConfirm(false);
    S.paused=false;
    if(S.log.length) finish(false, true);
    else quitToIntro();
  }
  $('qmEndRun').addEventListener('click', function(){ SFX.ui('ask'); showEndConfirm(true); });
  $('qmKeepPlaying').addEventListener('click', resume);
  $('qmEndConfirmBtn').addEventListener('click', endRunNow);

  function quitToIntro(){
    clearInterval(S.tick); clearInterval(S.cd);
    S.running=false; S.locked=false; S.paused=false;
    closeStage();
    showScreen('intro');
  }

  function finish(timeUp, stopped){
    clearInterval(S.tick); clearInterval(S.cd);
    S.running=false; S.locked=false; S.paused=false;
    closeStage();
    /* record the day first: the first finished run of the day plays the streak
       moment over the results, and confetti waits until it has gone */
    var answered=S.log.length;
    var award=skRecord(!stopped, answered, S.firstTry===answered);
    skHoldConfetti = !!(award && award.moment);
    var isBest=renderResult(timeUp, !!stopped);
    skUnlocks(award);
    showScreen('result');
    /* the chart needs the card's real width, which only exists once the
       result screen is displayed */
    setTimeout(drawTimeChart, 0);
    if(award && award.moment) skMoment(award.moment);
    endSounds(timeUp, !!stopped, answered, isBest, award);
  }
  /* the end of a round, one sound after another instead of all at once: time up, the round scaled to
     the share right (nothing when nothing was answered), a new best, the streak moment as its number
     lands, then each new icon. A new run or closing the game hushes whatever is still to come. */
  function endSounds(timeUp, stopped, answered, isBest, award){
    var at=120;
    function next(gap, fn){ SFX.after(at, fn); at+=gap; }
    if(timeUp){ SFX.timeUp(); at=650; }
    if(answered){
      var pct=S.correct/answered;
      /* a run ended early with End run never earns the big fanfare: under five answers a kind
         done, otherwise the small win at most. Time up and a finished race keep the full scale. */
      if(stopped && answered<5) next(900, function(){ SFX.done(); });
      else next(900, function(){ SFX.finish(stopped ? Math.min(pct, 0.6) : pct); });
    }
    if(isBest) next(600, function(){ SFX.best(); });
    if(award && award.moment) next(600, function(){ SFX.medal(2); });
    if(award) award.newly.forEach(function(k, j){ next(180, function(){ SFX.star(j); }); });
  }

  /* ---------------------------------------------------------
     Results
     --------------------------------------------------------- */
  function escapeHtml(s){
    return String(s).replace(/[&<>"']/g, function(c){
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  /* ---------------------------------------------------------
     Time per question
     --------------------------------------------------------- */
  /* Which free practice page each topic points at. Anything unmapped falls
     back to the practice hub. */
  var PRACTICE_URL = {
    pos:'free-four-operations-practice', tab:'free-four-operations-practice',
    pow:'free-four-operations-practice', bid:'free-four-operations-practice',
    neg:'free-decimals-practice', dec:'free-decimals-practice',
    pct:'free-percentages-practice',
    p10:'free-place-value-practice', rnd:'free-place-value-practice', pla:'free-place-value-practice',
    cal:'free-measures-practice', tim:'free-measures-practice', uni:'free-measures-practice',
    fac:'free-factors-practice',
    seq:'free-algebra-practice', fnm:'free-algebra-practice', alg:'free-algebra-practice',
    ang:'free-angles-practice', shf:'free-angles-practice',
    rat:'free-ratio-practice', ape:'free-area-perimeter-practice',
    avg:'free-averages-practice', fra:'free-fractions-practice'
  };

  function median(a){
    var b=a.slice().sort(function(x,y){ return x-y; });
    var m=b.length>>1;
    return b.length%2 ? b[m] : (b[m-1]+b[m])/2;
  }
  function fmtSec(v){ return (v%1 ? Math.round(v*10)/10 : v)+'s'; }
  /* "Practise Roman numerals", not "Practise Roman Numerals"; acronyms and
     anything with two capitals in a row (BIDMAS, HCF) keep their case. */
  function practiseLabel(name){
    return name.split(' ').map(function(w){ return /[A-Z]{2}/.test(w) ? w : w.toLowerCase(); }).join(' ');
  }
  /* same rendering rule as the review rows: plain text when there is one,
     the question's own markup when it is rich (fractions, powers) */
  function qRich(r){ return r.p ? escapeHtml(r.p) : (r.html ? r.t : escapeHtml(r.t)); }

  var timeChartData=null, chartRetries=0, chartGeo=null, tipIdx=-1;
  function drawTimeChart(){
    var host=$('qmTimeChart');
    if(!timeChartData){ host.innerHTML='<span hidden></span>'; return; }
    var W=host.clientWidth;
    if(!W){
      /* not laid out yet (screen mid-transition, or a hidden tab): try again
         shortly, and the resize listener catches anything after that */
      if(chartRetries<10){ chartRetries++; setTimeout(drawTimeChart, 300); }
      return;
    }
    chartRetries=0;
    W=Math.max(280, W);
    var secs=timeChartData.secs, flags=timeChartData.flags, med=timeChartData.med, n=secs.length;
    var H=220, baseY=194, topPad=22, left=40, right=W-8, plotW=right-left;
    var maxV=Math.max.apply(null, secs.concat([med*3, 4]));
    var scale=(baseY-topPad-8)/maxV;
    function y(v){ return baseY - v*scale; }
    var steps=[1,2,5,10,15,20,30,60,120,300], step=steps[steps.length-1];
    for(var i=0;i<steps.length;i++){ if(maxV/steps[i]<=3.5){ step=steps[i]; break; } }
    var svg='<svg viewBox="0 0 '+W+' '+H+'" font-family="'+"'Inter', 'Lexend', system-ui, sans-serif"+'" role="img" aria-label="Time spent on each question">';
    svg+='<defs><clipPath id="qmPlotClip"><rect x="'+left+'" y="0" width="'+plotW+'" height="'+baseY+'"></rect></clipPath></defs>';
    for(var g=step; g<=maxV; g+=step){
      svg+='<line x1="'+left+'" y1="'+y(g).toFixed(1)+'" x2="'+right+'" y2="'+y(g).toFixed(1)+'" stroke="rgba(255,255,255,.07)"></line>';
      svg+='<text x="'+(left-4)+'" y="'+(y(g)+4).toFixed(1)+'" text-anchor="end" font-size="13" fill="#93A6C0" font-weight="600">'+g+'s</text>';
    }
    var stepX=plotW/n, barW=Math.min(18, Math.max(2.5, stepX*0.78));
    var rx=Math.min(3, barW/2);
    svg+='<g clip-path="url(#qmPlotClip)">';
    for(i=0;i<n;i++){
      var bx=left + i*stepX + (stepX-barW)/2;
      svg+='<rect class="qm-bar" x="'+bx.toFixed(1)+'" y="'+y(secs[i]).toFixed(1)+'" width="'+barW.toFixed(1)+'" height="'+(secs[i]*scale+6).toFixed(1)+'" rx="'+rx.toFixed(1)+'" fill="'+(flags[i]?'#FF8054':'#5BAFD6')+'"></rect>';
    }
    svg+='</g>';
    var yMed=y(med);
    svg+='<line x1="'+left+'" y1="'+yMed.toFixed(1)+'" x2="'+right+'" y2="'+yMed.toFixed(1)+'" stroke="#93A6C0" stroke-dasharray="4 4" opacity=".65"></line>';
    var order=[];
    for(i=0;i<n;i++){ if(flags[i]) order.push(i); }
    order.sort(function(a,b){ return secs[b]-secs[a]; });
    order.slice(0,3).forEach(function(ix){
      var cx=left + ix*stepX + stepX/2;
      cx=Math.max(left+10, Math.min(right-10, cx));
      svg+='<text x="'+cx.toFixed(1)+'" y="'+Math.max(9, y(secs[ix])-6).toFixed(1)+'" text-anchor="middle" font-size="14" fill="#FF8054" font-weight="800">'+fmtSec(secs[ix])+'</text>';
    });
    svg+='<line x1="'+left+'" y1="'+baseY+'" x2="'+right+'" y2="'+baseY+'" stroke="rgba(255,255,255,.14)"></line>';
    var tick = n<=12 ? 2 : (n<=30 ? 5 : 10);
    for(i=1;i<=n;i++){
      if(i!==1 && i!==n && i%tick!==0) continue;
      if(i!==1 && i!==n && (n-i)<tick*0.6) continue;
      var tx=left + (i-1)*stepX + stepX/2;
      svg+='<text x="'+tx.toFixed(1)+'" y="'+(baseY+19)+'" text-anchor="middle" font-size="13" fill="#93A6C0" font-weight="600">'+i+'</text>';
    }
    svg+='</svg>';
    host.innerHTML=svg;
    /* geometry the tip needs to map a cursor back to a bar */
    chartGeo={ left:left, stepX:stepX, n:n, W:W, y:y };
    host.insertAdjacentHTML('beforeend', '<div class="qm-chart-tip" hidden></div>');
    tipIdx=-1; host.classList.remove('is-tipping');
  }

  /* ---- hover (or tap) a bar to see which question it was ---- */
  function chartIndexAt(clientX){
    if(!timeChartData || !chartGeo) return -1;
    var svg=$('qmTimeChart').querySelector('svg');
    if(!svg) return -1;
    var r=svg.getBoundingClientRect();
    if(!r.width) return -1;
    var sx=r.width/chartGeo.W;                    /* the svg scales, its viewBox does not */
    var i=Math.floor(((clientX-r.left)/sx - chartGeo.left)/chartGeo.stepX);
    return (i>=0 && i<chartGeo.n) ? i : -1;
  }
  function hideChartTip(){
    var host=$('qmTimeChart'), tip=host.querySelector('.qm-chart-tip');
    tipIdx=-1;
    if(tip) tip.hidden=true;
    host.classList.remove('is-tipping');
    var bars=host.querySelectorAll('.qm-bar');
    for(var b=0;b<bars.length;b++) bars[b].classList.remove('is-on');
  }
  function showChartTip(i){
    if(i<0){ hideChartTip(); return; }
    var host=$('qmTimeChart'), tip=host.querySelector('.qm-chart-tip');
    if(!tip || !timeChartData || !chartGeo) return;
    if(i!==tipIdx){
      var row=(timeChartData.rows||[])[i]||{}, secs=timeChartData.secs[i];
      var state = row.ok ? (row.first ? 'right first time' : 'got it 2nd try') : 'skipped';
      tip.innerHTML = '<div class="h">Q'+(i+1)+(row.m ? ' &middot; '+escapeHtml(row.m) : '')+'</div>'
        + '<div class="q">'+(row.q||'')+'</div>'
        + '<div class="f"><b>'+fmtSec(secs)+'</b>&middot; '+state+'</div>';
      tip.classList.toggle('is-slow', !!timeChartData.flags[i]);
      tipIdx=i;
    }
    tip.hidden=false;
    host.classList.add('is-tipping');
    var bars=host.querySelectorAll('.qm-bar');
    for(var b=0;b<bars.length;b++) bars[b].classList.toggle('is-on', b===i);
    /* sit it above the bar, clamped inside the chart card */
    var svg=host.querySelector('svg'), r=svg.getBoundingClientRect(), hr=host.getBoundingClientRect();
    var sx=r.width/chartGeo.W;
    var cx=(r.left-hr.left) + (chartGeo.left + i*chartGeo.stepX + chartGeo.stepX/2)*sx;
    var top=(r.top-hr.top) + chartGeo.y(timeChartData.secs[i])*sx - tip.offsetHeight - 9;
    tip.style.left=Math.max(6, Math.min(hr.width-tip.offsetWidth-6, cx-tip.offsetWidth/2))+'px';
    tip.style.top=Math.max(4, top)+'px';
  }
  (function(){
    var host=$('qmTimeChart');
    host.addEventListener('pointermove', function(e){
      if(e.pointerType==='touch') return;            /* touch is handled on tap */
      showChartTip(chartIndexAt(e.clientX));
    });
    host.addEventListener('pointerleave', function(e){
      if(e.pointerType==='touch') return;
      hideChartTip();
    });
    host.addEventListener('pointerdown', function(e){
      if(e.pointerType==='mouse') return;
      var i=chartIndexAt(e.clientX);
      if(i===tipIdx) hideChartTip(); else showChartTip(i);
    });
    document.addEventListener('pointerdown', function(e){
      if(tipIdx>=0 && !host.contains(e.target)) hideChartTip();
    });
  })();

  window.addEventListener('resize', function(){
    if(elResult.classList.contains('is-on')) drawTimeChart();
  });

  var reviewShowLabel='Show all';
  $('qmReviewToggle').addEventListener('click', function(){
    var list=$('qmReview');
    var open=!list.classList.toggle('is-collapsed');
    SFX.ui(open ? 'open' : 'close');
    this.setAttribute('aria-expanded', open?'true':'false');
    this.querySelector('span').textContent = open ? 'Hide questions' : reviewShowLabel;
    this.querySelector('svg').style.transform = open ? 'rotate(180deg)' : '';
  });

  function secWords(t){ t=Math.round(t); return t===1 ? '1 second' : (t<60 ? t+' seconds' : fmtTime(t)); }
  function stkHtml(k){ return (window.QM_STK||{})[k] || ''; }

  function renderResult(timeUp, stopped){
    var answered=S.log.length;
    var acc = answered ? Math.round(S.firstTry/answered*100) : 0;
    var used = (S.gameMode==='clock') ? (S.timeLimit - Math.max(0,S.secs)) : S.elapsed;
    var left = (S.gameMode==='clock') ? Math.max(0,S.secs) : 0;
    /* a run only "counts" if it went the distance: the full race length, or the
       clock all the way down. Ending early is fine, it just must not be dressed
       up as a finished run. */
    var complete = !stopped;
    var isRecord=false;
    var prev = (complete && !S.practice) ? lastComparable() : null;
    var clock = S.gameMode==='clock';

    if(clock){
      $('qmStatScore').innerHTML='<b>'+S.correct+'</b><span>right</span>';
      if(complete && S.correct>0) isRecord=saveBest(S.correct);
    } else {
      $('qmStatScore').innerHTML='<b>'+(complete ? S.correct+'/'+S.raceLen : S.correct+'/'+answered)+'</b>';
      if(complete && !S.practice && S.correct===S.raceLen) isRecord=saveBest(S.elapsed);
    }
    $('qmStatAcc').textContent=acc+'%';
    $('qmStatStreak').textContent=String(S.bestStreak);

    /* per-question times: the usual (median) answer, and anything that took
       over three times that long, with an 8 second floor so a fast run does
       not flag ordinary answers */
    var secsAll = S.log.map(function(r){ return (typeof r.s==='number') ? r.s : 1; });
    var med = answered ? median(secsAll) : 0;
    var slowCut = Math.max(med*3, 8);
    var slowFlags = secsAll.map(function(v){ return v > slowCut; });
    var slowestIdx = -1;
    secsAll.forEach(function(v,i){ if(slowFlags[i] && (slowestIdx===-1 || v>secsAll[slowestIdx])) slowestIdx=i; });
    $('qmStatTypical').textContent = answered ? fmtSec(med) : '0s';
    var typSub=$('qmStatTypicalSub');
    typSub.textContent=''; typSub.className='';
    if(prev && typeof prev.md==='number' && answered>=4){
      var dm=Math.round((prev.md-med)*10)/10;
      if(Math.abs(dm)<0.05){ typSub.textContent='same as last time'; }
      else if(dm>0){ typSub.textContent=fmtSec(dm)+' quicker'; typSub.className='up'; }
      else { typSub.textContent=fmtSec(-dm)+' slower'; typSub.className='down'; }
    }

    /* one chart; the tricky questions go on the practice list, played in the app */
    var timeWrap=$('qmTimeWrap');
    timeChartData=null;
    if(answered>=4){
      timeWrap.hidden=false;
      $('qmLegendUsual').textContent='usual '+fmtSec(med);
      timeChartData={ secs:secsAll, flags:slowFlags, med:med,
        rows:S.log.map(function(r){ return { q:qRich(r), m:modeName(r.m), ok:!!r.ok, first:!!r.first }; }) };
    } else {
      timeWrap.hidden=true;
    }
    var trk=updateTricky(slowFlags);
    renderPractiseCard(trk);

    var title;
    if(answered===0) title='No answers yet';
    else if(!complete) title = (acc>=80 ? 'Good start' : 'Stopped early');
    else if(isRecord) title='New best';
    else if(acc===100) title='Flawless';
    else if(acc>=80) title='Strong run';
    else if(acc>=55) title='Good going';
    else title='Keep at it';
    if(S.practice && answered) title = !trk.left ? 'All cleared' : ((trk.cleared || trk.stronger) ? 'Nice practice' : 'Keep practising');
    var heroStk = isRecord ? 'trophy' : (complete && acc>=80 ? 'tick' : '');
    var hs=$('qmResultStk');
    hs.innerHTML = heroStk ? stkHtml(heroStk) : '';
    hs.classList.toggle('is-on', !!heroStk && !!hs.innerHTML);

    var sub;
    if(answered===0){
      sub = clock ? 'The clock ran out before your first answer.' : 'No answers that time.';
    } else if(clock){
      sub = complete ? 'In '+(LAST_LEN[S.timeLimit] || fmtTime(S.timeLimit))
                     : 'Stopped with '+fmtTime(left)+' left, '+answered+' answered';
    } else {
      sub = complete ? S.raceLen+' questions in '+secWords(S.elapsed)
                     : 'Stopped after '+answered+' of '+S.raceLen+' questions';
    }
    $('qmResultTitle').textContent=title;
    $('qmResultSub').textContent=sub;

    /* comparison against the last full run on identical settings */
    var dEl=$('qmDelta');
    dEl.className='qm-delta';
    dEl.innerHTML='<span></span>';
    if(prev && answered>0){
      var txt, dir;
      if(clock){
        var d=S.correct - prev.c;
        if(d>0){ dir='up'; txt=d+' more than your last full run'; }
        else if(d<0){ dir='down'; txt=Math.abs(d)+' fewer than your last full run'; }
        else { dir='same'; txt='Same as your last full run'; }
      } else {
        var dt=Math.round(prev.t - S.elapsed);
        if(dt>0){ dir='up'; txt=secWords(dt)+' faster than your last full run'; }
        else if(dt<0){ dir='down'; txt=secWords(-dt)+' slower than your last full run'; }
        else { dir='same'; txt='Same time as your last full run'; }
      }
      dEl.className='qm-delta is-on '+dir;
      dEl.innerHTML=(dir==='up'?ICON.up:dir==='down'?ICON.down:ICON.same)+'<span>'+txt+'</span>';
    }

    /* by topic */
    var byMode={}, order=[];
    S.log.forEach(function(r,i){
      if(!byMode[r.m]){ byMode[r.m]={ n:0, f:0, s:[] }; order.push(r.m); }
      byMode[r.m].n++; if(r.first) byMode[r.m].f++;
      byMode[r.m].s.push(secsAll[i]);
    });
    var tWrap=$('qmTopicWrap'), tHost=$('qmTopics');
    if(order.length){
      tWrap.hidden=false;
      tHost.innerHTML=order.map(function(k){
        var m=MODE_BY_K[k], d=byMode[k];
        var pv=Math.round(d.f/d.n*100);
        var tm=median(d.s), tSlow=(order.length>1 && d.n>=2 && med>0 && tm>Math.max(med*1.5, med+2));
        var tChip = (answered>=4) ? '<em class="'+(tSlow?'is-slow':'')+'" title="Usual speed">'+fmtSec(tm)+'</em>' : '';
        return '<div class="qm-topic-row" style="--c:'+m.c+'">'
             + '<span class="n"><span class="qm-topic-stk" aria-hidden="true">'+stkHtml('t-'+k)+'</span>'+m.name+'</span>'
             + '<span class="v">'+d.f+' of '+d.n+' first try'+tChip+'</span>'
             + '<span class="qm-topic-bar"><i style="width:'+pv+'%"></i></span>'
             + '</div>';
      }).join('');
    } else { tWrap.hidden=true; }

    /* every question, folded away until someone asks */
    var rWrap=$('qmReviewWrap'), rHost=$('qmReview');
    if(answered){
      rWrap.hidden=false;
      rHost.innerHTML=S.log.map(function(r,i){
        var qt  = r.p ? escapeHtml(r.p) : (r.html ? r.t : escapeHtml(r.t));
        var cls = (r.ok && r.first) ? 'ok' : 'bad';
        var ico = (r.ok && r.first) ? ICON.tick : ICON.cross;
        var chip='';
        if(typeof r.s==='number'){
          chip = slowFlags[i]
            ? '<span class="qm-row-t is-slow"><svg class="shlc-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>'+fmtSec(r.s)+'</span>'
            : '<span class="qm-row-t">'+fmtSec(r.s)+'</span>';
        }
        var note='';
        if(i===slowestIdx && med>0){
          var mult=Math.round(secsAll[i]/med);
          if(mult>=3) note='<span class="qm-row-note">Took '+mult+' times your usual speed</span>';
        }
        var ans;
        if(r.ok && r.first)      ans='<span class="qm-row-a">'+ansStr(r.a)+'</span>';
        else if(r.ok)            ans='<span class="qm-row-a"><em>2nd try</em>'+ansStr(r.a)+'</span>';
        else                     ans='<span class="qm-row-a"><em>skipped</em>'+ansStr(r.a)+'</span>';
        return '<div class="qm-row '+cls+'">'+ico+'<span class="qm-row-q">'+qt+'</span>'+chip+ans+note+'</div>';
      }).join('');
      reviewShowLabel='See all '+answered+(answered===1?' question':' questions');
      var tg=$('qmReviewToggle');
      rHost.classList.add('is-collapsed');
      tg.setAttribute('aria-expanded','false');
      tg.querySelector('span').textContent=reviewShowLabel;
      tg.querySelector('svg').style.transform='';
    } else { rWrap.hidden=true; }

    /* save this run */
    if(answered && !S.practice){
      var runs=getRuns();
      runs.unshift({
        d:new Date().toISOString(), g:S.gameMode, set:setting(), m:modeSig(),
        c:S.correct, n:answered, f:S.firstTry,
        t:(clock?used:S.elapsed),
        x:(complete?0:1),
        md:(answered>=4 ? Math.round(med*10)/10 : undefined)
      });
      try { localStorage.setItem(LS_RUNS, JSON.stringify(runs.slice(0,40))); } catch(e){}
    }

    if(!reduceMotion && complete && answered>=5 && acc>=85){ if(skHoldConfetti) skPendingConfetti=true; else confettiBurst(); }
    showBest();
    return isRecord;
  }

  /* ---------------------------------------------------------
     Your runs: a best-for-this-setup summary, then every saved
     run grouped by day, score first
     --------------------------------------------------------- */
  var runsFilter='all';
  function mss(t){ t=Math.max(0, Math.round(t)); return Math.floor(t/60)+':'+(t%60<10?'0':'')+(t%60); }
  function runTopicKeys(r){
    return String(r.m||'').split(',').filter(function(k){ return !!MODE_BY_K[k]; })
      .sort(function(x,y){ return MODE_ORDER[x]-MODE_ORDER[y]; });
  }
  function runStickers(keys, max){
    var html='';
    keys.slice(0,max).forEach(function(k){ html+=stkHtml('t-'+k); });
    if(keys.length>max) html+='<b>+'+(keys.length-max)+'</b>';
    return html;
  }
  function runTopicNames(keys){
    if(keys.length===MODES.length) return 'All topics';
    var names=keys.map(modeName);
    return names.length<=2 ? names.join(' and ') : names.slice(0,2).join(', ')+' +'+(names.length-2);
  }
  function runLen(g, set){ return g==='race' ? set+' questions' : (LAST_LEN[set] || fmtTime(set)); }
  function dayGroup(iso){
    var t=new Date(iso);
    if(isNaN(t.getTime())) return 'Earlier';
    var day=function(x){ return new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime(); };
    var ago=Math.round((day(new Date())-day(t))/86400000);
    return ago<=0 ? 'Today' : ago===1 ? 'Yesterday' : ago<7 ? 'This week' : 'Earlier';
  }
  function runRing(p){
    var dash=(Math.max(0, Math.min(100, p))/100*113.1).toFixed(1);
    return '<span class="qm-run-ring"><span class="rg"><svg viewBox="0 0 44 44" aria-hidden="true">'
      + '<circle cx="22" cy="22" r="18" fill="none" stroke="#0A1220" stroke-width="5"></circle>'
      + '<circle cx="22" cy="22" r="18" fill="none" stroke="#3DD68C" stroke-width="5" stroke-linecap="round" stroke-dasharray="'+dash+' 113.1" transform="rotate(-90 22 22)"></circle>'
      + '</svg><b>'+p+'%</b></span><span class="lb">first try</span></span>';
  }
  function runsSummary(all){
    var box=$('qmRunsSum');
    var best=getBest()[bestKey()];
    var same=all.filter(function(r){ return r.g===S.gameMode && Number(r.set)===setting() && r.m===modeSig() && !runStopped(r); });
    if(best===undefined || best===null || !same.length){ box.hidden=true; box.innerHTML=''; return; }
    var clock=S.gameMode==='clock';
    var keys=S.modes.slice().sort(function(x,y){ return MODE_ORDER[x]-MODE_ORDER[y]; });
    var bestHtml = clock ? '<b>'+best+'</b><span>correct</span>' : '<b>'+mss(best)+'</b><span>for '+S.raceLen+' questions</span>';
    var pts=same.slice(0,8).reverse().map(function(r){ return clock ? r.c : r.t; });
    var spark='';
    if(pts.length>=2){
      var lo=Math.min.apply(null, pts), hi=Math.max.apply(null, pts), range=(hi-lo)||1;
      var xy=pts.map(function(v,i){
        var norm=(v-lo)/range;
        if(!clock) norm=1-norm;              /* a faster race sits higher */
        return [6+i*(120/(pts.length-1)), 48-norm*40];
      });
      var end=xy[xy.length-1];
      spark='<span class="qm-rs-spark"><svg viewBox="0 0 132 56" aria-hidden="true"><polyline points="'
        + xy.map(function(p){ return p[0].toFixed(1)+','+p[1].toFixed(1); }).join(' ')
        + '" fill="none" stroke="#5BAFD6" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></polyline>'
        + '<circle cx="'+end[0].toFixed(1)+'" cy="'+end[1].toFixed(1)+'" r="5" fill="#FF8054" stroke="#0E1729" stroke-width="2"></circle></svg>'
        + '<span>Last '+pts.length+' runs</span></span>';
    }
    var trend='';
    if(same.length>=2){
      var a=same[0], b=same[1], dir, txt;
      if(clock){
        var d=a.c-b.c;
        dir = d>0 ? 'up' : d<0 ? 'down' : 'same';
        txt = d>0 ? d+' more than your last full run' : d<0 ? Math.abs(d)+' fewer than your last full run' : 'Same as your last full run';
      } else {
        var dt=Math.round(b.t-a.t);
        dir = dt>0 ? 'up' : dt<0 ? 'down' : 'same';
        txt = dt>0 ? secWords(dt)+' faster than your last full run' : dt<0 ? secWords(-dt)+' slower than your last full run' : 'Same time as your last full run';
      }
      trend='<span class="qm-rs-trend '+dir+'">'+(dir==='up'?ICON.up:dir==='down'?ICON.down:ICON.same)+'<span>'+txt+'</span></span>';
    }
    box.innerHTML = '<span class="qm-rs-main">'
      + '<span class="qm-rs-eye"><span class="qm-rs-trophy" aria-hidden="true">'+stkHtml('trophy')+'</span>Best for this setup</span>'
      + '<span class="qm-rs-best">'+bestHtml+'</span>'
      + '<span class="qm-rs-setup"><span class="pill">'+runLen(S.gameMode, setting())+'</span><span class="stk" aria-hidden="true">'+runStickers(keys, 4)+'</span></span>'
      + '</span>' + spark + trend;
    box.hidden=false;
  }
  function renderHistory(){
    var all=getRuns(), host=$('qmHistoryList'), filt=$('qmRunsFilter');
    runsSummary(all);
    if(!all.length){
      filt.hidden=true;
      host.innerHTML='<div class="qm-runs-empty"><span class="qm-runs-empty-stk" aria-hidden="true">'+stkHtml('play')+'</span>'
        + '<b>Your first run starts here</b><span>Finish a round and it shows up here.</span></div>';
      return;
    }
    filt.hidden=false;
    Array.prototype.forEach.call(filt.querySelectorAll('button'), function(b){
      b.setAttribute('aria-pressed', b.getAttribute('data-f')===runsFilter ? 'true' : 'false');
    });
    var runs=all.filter(function(r){ return runsFilter==='all' || r.g===runsFilter; });
    if(!runs.length){
      host.innerHTML='<div class="qm-runs-empty"><b>No '+(runsFilter==='race' ? 'Race' : 'Beat the clock')+' runs yet</b></div>';
      return;
    }
    var best=getBest(), bestShown={}, group='', html='';
    runs.forEach(function(r){
      var g=dayGroup(r.d);
      if(g!==group){ html+='<h3 class="qm-runs-day">'+g+'</h3>'; group=g; }
      var stopped=runStopped(r), keys=runTopicKeys(r), set=Number(r.set);
      var key=r.g+':'+set+':'+r.m, bv=best[key], isBest=false;
      if(!stopped && bv!==undefined && bv!==null && !bestShown[key]){
        isBest = (r.g==='clock') ? r.c===bv : (r.c===set && r.t===bv);
        if(isBest) bestShown[key]=1;
      }
      var big, small;
      if(r.g==='clock'){ big=String(r.c); small='correct'; }
      else if(stopped){ big=r.n+'/'+set; small='answered'; }
      else { big=mss(r.t); small=r.c+' right'; }
      var tag = isBest ? '<em class="tag best">Best</em>' : '', stopTag = stopped ? '<em class="tag stop">Stopped</em>' : '';
      var accv = r.n ? Math.round(r.f/r.n*100) : 0;
      html += '<div class="qm-run'+(stopped?' is-stopped':'')+(isBest?' is-best':'')+'">'
        + '<span class="qm-run-score"><b>'+big+'</b><span>'+small+'</span></span>'
        + '<span class="qm-run-mid"><span class="qm-run-title"><span>'+runLen(r.g, set)+'</span>'+tag+'</span>'
        + '<span class="qm-run-topics"><span class="stk" aria-hidden="true">'+runStickers(keys, 3)+'</span>'+stopTag+'<span class="nm">'+escapeHtml(runTopicNames(keys))+'</span></span></span>'
        + (stopped ? '<span></span>' : runRing(accv))
        + '</div>';
    });
    host.innerHTML=html;
  }
  function openHistory(){ SFX.ui('open'); renderHistory(); renderSavedEntry(getTricky().length); $('qmHistory').classList.add('is-on'); }
  function closeHistory(quiet){
    if(!quiet && $('qmHistory').classList.contains('is-on')) SFX.ui('close');
    $('qmHistory').classList.remove('is-on');
  }
  $('qmHistoryBtn').addEventListener('click', openHistory);
  $('qmHistoryBtn2').addEventListener('click', openHistory);
  $('qmHistoryClose').addEventListener('click', function(){ closeHistory(); });
  $('qmHistory').addEventListener('click', function(e){ if(e.target===$('qmHistory')) closeHistory(); });
  $('qmRunsFilter').addEventListener('click', function(e){
    var b=(e.target && e.target.closest) ? e.target.closest('button[data-f]') : null;
    if(!b) return;
    runsFilter=b.getAttribute('data-f');
    SFX.ui('tab', Array.prototype.indexOf.call(this.querySelectorAll('button[data-f]'), b));
    renderHistory();
  });

  /* ---------------------------------------------------------
     Confetti
     --------------------------------------------------------- */
  var cv=$('qmConfetti'), cx=cv.getContext('2d'), bits=[];
  function sizeCanvas(){ cv.width=window.innerWidth; cv.height=window.innerHeight; }
  window.addEventListener('resize', sizeCanvas);
  sizeCanvas();
  function confettiBurst(){
    sizeCanvas(); cv.style.display='block'; bits=[];
    var cols=['#5BAFD6','#FF8054','#3DD68C','#FBBF24','#ffffff'];
    for(var i=0;i<120;i++){
      bits.push({ x:cv.width/2, y:cv.height*0.34,
        vx:(Math.random()-0.5)*14, vy:(Math.random()-0.5)*13-9,
        c:cols[R(cols.length)], s:Math.random()*6+4, r:Math.random()*Math.PI, life:130 });
    }
    requestAnimationFrame(stepConfetti);
  }
  function stepConfetti(){
    cx.clearRect(0,0,cv.width,cv.height);
    for(var i=bits.length-1;i>=0;i--){
      var p=bits[i];
      p.x+=p.vx; p.y+=p.vy; p.vy+=0.28; p.vx*=0.995; p.r+=0.12; p.life--;
      cx.save(); cx.translate(p.x,p.y); cx.rotate(p.r);
      cx.fillStyle=p.c; cx.fillRect(-p.s/2,-p.s/2,p.s,p.s*0.6); cx.restore();
      if(p.life<=0 || p.y>cv.height+40) bits.splice(i,1);
    }
    if(bits.length) requestAnimationFrame(stepConfetti);
    else { cx.clearRect(0,0,cv.width,cv.height); cv.style.display='none'; }
  }

  /* ---------------------------------------------------------
     Day streak, milestones and icons
     A day counts once a run is finished (ending early does not count).
     Saved in this browser only, the same as runs and personal bests.
     --------------------------------------------------------- */
  var LS_DAYS='qm_days_v1';
  var SK_MILES=[
    { d:1,   k:'spark',   t:'First spark',      i:'Spark' },
    { d:3,   k:'flame',   t:'Warming up',       i:'Flame' },
    { d:7,   k:'rocket',  t:'One whole week',   i:'Rocket' },
    { d:14,  k:'bolt',    t:'Two weeks strong', i:'Lightning' },
    { d:30,  k:'crown',   t:'A whole month',    i:'Crown' },
    { d:50,  k:'planet',  t:'Fifty days',       i:'Planet' },
    { d:100, k:'diamond', t:'A hundred days',   i:'Diamond' },
    { d:365, k:'trophy',  t:'A whole year',     i:'Trophy' }
  ];
  var SK_BONUS=[
    { k:'star',    t:'Perfect run',   i:'Perfect run', s:'Perfect', how:'Every answer right first time in a finished run of 10 or more' },
    { k:'hundred', t:'Hundred club',  i:'100 club', how:'Answer 100 questions', goal:100 },
    { k:'target',  t:'Thousand club', i:'1,000 club', s:'1K club', how:'Answer 1,000 questions', goal:1000 }
  ];
  var SK_NAME={};
  SK_MILES.concat(SK_BONUS).forEach(function(m){ SK_NAME[m.k]=m.i; });
  var ART={};
  try { ART=JSON.parse($('qmArt').textContent); } catch(e){}
  var skHoldConfetti=false, skPendingConfetti=false, skTimer=null, skOpenNow=false;
  var SK_TICK='<svg viewBox="0 0 24 24" fill="none" stroke="#2A1206" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12.5l5 5L20 6.5"/></svg>';

  function skKey(d){ return d.getFullYear()+'-'+pad2(d.getMonth()+1)+'-'+pad2(d.getDate()); }
  function skShift(key, n){ var p=key.split('-'); return skKey(new Date(+p[0], +p[1]-1, +p[2]+n)); }
  function skToday(){ return skKey(new Date()); }
  function skSave(st){ try { localStorage.setItem(LS_DAYS, JSON.stringify(st)); } catch(e){} }
  function skBest(days){
    var best=0, run=0, prev=null;
    days.forEach(function(k){ run = (prev && skShift(prev,1)===k) ? run+1 : 1; if(run>best) best=run; prev=k; });
    return best;
  }
  function skLoad(){
    var st=null;
    try { st=JSON.parse(localStorage.getItem(LS_DAYS)||'null'); } catch(e){}
    if(st && st.v===1 && st.days){ st.won=st.won||{}; st.seen=st.seen||{}; st.q=st.q||0; return st; }
    /* first visit since streaks arrived: rebuild from saved runs, so a child who
       has already been playing starts with the streak they earned */
    st={ v:1, days:[], won:{}, seen:{}, pick:null, q:0 };
    getRuns().forEach(function(r){
      st.q += r.n||0;
      if(runStopped(r) || !r.n || !r.d) return;
      var k=skKey(new Date(r.d));
      if(st.days.indexOf(k)<0) st.days.push(k);
      if(r.n>=10 && r.f===r.n) st.won.star=k;
    });
    st.days.sort();
    var best=skBest(st.days), stamp=skToday();
    SK_MILES.forEach(function(m){ if(best>=m.d) st.won[m.k]=stamp; });
    SK_BONUS.forEach(function(b){ if(b.goal && st.q>=b.goal) st.won[b.k]=stamp; });
    Object.keys(st.won).forEach(function(k){ st.seen[k]=1; });
    skSave(st);
    return st;
  }
  function skNow(st){
    var today=skToday(), yest=skShift(today,-1);
    var has=function(k){ return st.days.indexOf(k)>=0; };
    var end = has(today) ? today : (has(yest) ? yest : null), n=0, k=end;
    while(k && has(k)){ n++; k=skShift(k,-1); }
    return { n:n, today:has(today), alive:!!end };
  }
  function skPick(st){
    if(st.pick && st.won[st.pick]) return st.pick;
    var p=null;
    SK_MILES.forEach(function(m){ if(st.won[m.k]) p=m.k; });
    return p || 'flame';
  }
  function skNext(n){
    for(var i=0;i<SK_MILES.length;i++){ if(SK_MILES[i].d>n) return SK_MILES[i]; }
    return null;
  }
  function skRecord(complete, answered, perfect){
    if(!answered) return null;
    var st=skLoad(), before=skNow(st), today=skToday(), newly=[], moment=null;
    st.q += answered;
    if(complete && st.days.indexOf(today)<0){
      var firstEver = !st.days.length;
      st.days.push(today); st.days.sort();
      if(st.days.length>2000) st.days=st.days.slice(-2000);
      var after=skNow(st);
      SK_MILES.forEach(function(m){ if(after.n>=m.d && !st.won[m.k]){ st.won[m.k]=today; newly.push(m.k); } });
      moment={ from:(before.alive ? before.n : 0), to:after.n, first:firstEver, icon:(newly.length ? newly[newly.length-1] : null) };
    }
    if(complete && perfect && answered>=10 && !st.won.star){ st.won.star=today; newly.push('star'); }
    SK_BONUS.forEach(function(b){ if(b.goal && st.q>=b.goal && !st.won[b.k]){ st.won[b.k]=today; newly.push(b.k); } });
    skSave(st);
    skChip();
    return { moment:moment, newly:newly };
  }
  function skChip(){
    var btn=$('qmStreakBtn'); if(!btn) return;
    var st=skLoad(), now=skNow(st), k=skPick(st);
    $('qmStreakNum').textContent=String(now.n);
    if(ART[k]) $('qmStreakIco').src=ART[k];
    btn.classList.toggle('is-zero', now.n===0);
    btn.classList.toggle('is-pending', now.n>0 && !now.today);
    btn.classList.toggle('has-new', Object.keys(st.won).some(function(x){ return !st.seen[x]; }));
    var label = now.n ? (now.today ? now.n+'-day streak' : 'Play today to keep your '+now.n+'-day streak') : 'Finish a run to start a streak';
    btn.title=label;
    btn.setAttribute('aria-label', label+'. Open your streak and icons');
  }
  function skWeek(st){
    var today=skToday(), L='SMTWTFS', h='';
    for(var i=6;i>=0;i--){
      var k=skShift(today,-i), p=k.split('-'), dow=new Date(+p[0],+p[1]-1,+p[2]).getDay();
      var on=st.days.indexOf(k)>=0;
      h+='<div class="qm-week-d'+(on?' is-on':'')+(i===0?' is-today':'')+'"><b>'+(i===0?'Today':L.charAt(dow))+'</b>'
        +'<span class="qm-week-c">'+(on?SK_TICK:'')+'</span></div>';
    }
    return h;
  }

  function skMoment(mo){
    var el=$('qmMoment'), st=skLoad(), m=null;
    el.classList.toggle('is-first', mo.first);
    $('qmMoLabel').textContent = mo.first ? 'Your very first run' : (mo.to===1 ? 'A new streak starts today' : 'First run of the day done');
    $('qmMoHero').src = mo.first ? (ART.hero_spark||'') : (ART.hero_flame||'');
    var roll=$('qmMoRoll');
    roll.innerHTML='<span>'+(mo.first ? 1 : mo.from)+'</span><span>'+mo.to+'</span>';
    roll.style.transform = reduceMotion ? 'translateY(-84px)' : '';
    $('qmMoSub').textContent = mo.first ? 'Your streak has started!' : 'day streak';
    if(mo.icon){
      SK_MILES.forEach(function(x){ if(x.k===mo.icon) m=x; });
      $('qmMoExtra').innerHTML='<div class="qm-mo-new"><span class="ic"><img src="'+(ART[mo.icon]||'')+'" alt=""></span><span>'
        +'<span class="lb">New icon</span><span class="nm">'+m.i+'</span>'
        +'<span class="hw">'+(mo.first ? 'Every milestone wins another one.' : m.d+' days in a row. Show it next to your streak.')+'</span></span></div>';
    } else {
      m=skNext(mo.to);
      var gap = m ? m.d-mo.to : 0, lead = gap===1 ? 'One more day' : gap+' more days';
      var txt = !m ? 'Every day from here is a new record' : (st.won[m.k] ? lead+' to reach day '+m.d : lead+' for the '+m.i+' icon');
      $('qmMoExtra').innerHTML='<div class="qm-mo-pill">'+(m ? '<img src="'+(ART[m.k]||'')+'" alt="">' : '')+'<span>'+txt+'</span></div>';
    }
    $('qmMoWeek').innerHTML=skWeek(st);
    el.classList.remove('is-play');
    void el.offsetWidth;
    el.classList.add('is-on','is-play');
    skOpenNow=true;
    /* its medal plays from endSounds, as the number lands */
    var dur = mo.icon ? 3400 : 2600, t0=Date.now(), bar=$('qmMoBar');
    bar.style.transform='scaleX(0)';
    clearInterval(skTimer);
    skTimer=setInterval(function(){
      var p=Math.min(1, (Date.now()-t0)/dur);
      bar.style.transform='scaleX('+p+')';
      if(p>=1) skMomentClose();
    }, 50);
  }
  function skMomentClose(){
    if(!skOpenNow) return;
    skOpenNow=false;
    clearInterval(skTimer);
    $('qmMoment').classList.remove('is-on','is-play');
    skHoldConfetti=false;
    if(skPendingConfetti){ skPendingConfetti=false; confettiBurst(); }
    var a=$('qmAgain'); if(a) a.focus();
  }
  $('qmMoment').addEventListener('click', skMomentClose);

  function skUnlocks(award){
    var host=$('qmUnlocks');
    if(!award || !award.newly.length){ host.innerHTML='<span></span>'; host.classList.remove('is-on'); return; }
    host.innerHTML = award.newly.map(function(k){
      return '<div class="qm-unlock"><img src="'+(ART[k]||'')+'" alt=""><span><span class="lb">New icon</span><span class="nm">'+SK_NAME[k]+'</span></span></div>';
    }).join('') + '<button type="button" class="qm-btn qm-btn--ghost qm-btn--sm" id="qmUnlockOpen">See your icons</button>';
    host.classList.add('is-on');
    $('qmUnlockOpen').addEventListener('click', skOpenSheet);
  }

  var skTipKey=null;
  function skTip(st, now){
    var m=null;
    SK_MILES.concat(SK_BONUS).forEach(function(x){ if(x.k===skTipKey) m=x; });
    if(!m){
      return Object.keys(st.won).some(function(x){ return !st.seen[x]; })
        ? 'You won a new icon. Tap it to show it by your streak.'
        : 'Tap an icon you have won to show it by your streak.';
    }
    if(st.won[m.k]) return '<b>'+m.i+'</b> now shows by your streak.';
    if(m.d){
      var gap=m.d-now.n;
      return '<b>'+m.i+'</b> is won on day '+m.d+'. '+(gap===1 ? (now.today ? 'That is tomorrow.' : 'Play today to win it.') : gap+' days to go.');
    }
    if(m.goal) return '<b>'+m.i+'</b> is won after '+m.goal.toLocaleString('en-GB')+' questions. You have done '+Math.min(st.q, m.goal).toLocaleString('en-GB')+'.';
    return '<b>'+m.i+'</b> is won for a perfect run of 10 or more questions.';
  }
  function skSheet(){
    var st=skLoad(), now=skNow(st), pick=skPick(st), best=Math.max(skBest(st.days), now.n), next=skNext(now.n);
    var h='<div class="qm-sk-hero'+(now.n===0 ? ' is-zero' : (now.today ? '' : ' is-pending'))+'">'
      +'<img src="'+(ART[pick]||'')+'" alt="">'
      +'<span><span class="big"><b>'+now.n+'</b><span>day streak</span></span>'
      +'<span class="say">'+(now.n===0 ? 'Finish a run to start one' : (now.today ? 'Done for today' : 'Play today to keep it'))+'</span></span>'
      +'<span class="bst"><b>'+best+'</b><span>Best</span></span></div>';
    if(next){
      var prevD=0;
      SK_MILES.forEach(function(x){ if(x.d<=now.n) prevD=x.d; });
      var gap=next.d-now.n, pct=Math.round((now.n-prevD)/(next.d-prevD)*100), goal;
      if(st.won[next.k]) goal = (gap===1 ? 'One more day' : gap+' more days')+' to reach day '+next.d;
      else if(gap===1) goal = now.today ? 'Come back tomorrow to win '+next.i : 'Play today to win '+next.i;
      else goal = gap+' more days to win '+next.i;
      h+='<div class="qm-sk-goal"><img src="'+(ART[next.k]||'')+'" alt=""><span><span class="txt">'+goal+'</span>'
        +'<span class="trk"><i style="width:'+Math.max(4, pct)+'%"></i></span></span></div>';
    }
    h+='<div class="qm-week qm-sk-week">'+skWeek(st)+'</div><div class="qm-sk-icons">';
    SK_MILES.concat(SK_BONUS).forEach(function(m){
      var has=!!st.won[m.k], isPick=has && m.k===pick, isNext=!has && !!next && next.k===m.k;
      h+='<button type="button" class="qm-sk-icon'+(has?'':' is-locked')+(isNext?' is-next':'')+(skTipKey===m.k?' is-tip':'')+'" data-k="'+m.k+'"'
        +' aria-pressed="'+(isPick?'true':'false')+'" aria-label="'+m.i+(has ? '' : ', not won yet')+'">'
        +'<img src="'+(ART[m.k]||'')+'" alt=""><span class="nm">'+(has ? (m.s||m.i) : (m.d ? 'Day '+m.d : (m.s||m.i)))+'</span>'
        +(isPick ? '<i class="ok">'+SK_TICK+'</i>' : '')
        +(has && !st.seen[m.k] ? '<em class="new">New</em>' : '')+'</button>';
    });
    h+='</div><div class="qm-sk-tip" aria-live="polite"><span>'+skTip(st, now)+'</span></div>';
    $('qmStreakBody').innerHTML=h;
  }
  function skOpenSheet(){
    SFX.ui('open');
    skTipKey=null;
    skSheet();
    var st=skLoad();
    Object.keys(st.won).forEach(function(k){ st.seen[k]=1; });
    skSave(st);
    skChip();
    $('qmStreakSheet').classList.add('is-on');
    $('qmStreakBody').scrollTop=0;
    $('qmStreakClose').focus();
  }
  function skCloseSheet(){ SFX.ui('close'); $('qmStreakSheet').classList.remove('is-on'); }
  $('qmStreakBtn').addEventListener('click', skOpenSheet);
  $('qmStreakClose').addEventListener('click', skCloseSheet);
  $('qmStreakSheet').addEventListener('click', function(e){
    if(e.target===$('qmStreakSheet')){ skCloseSheet(); return; }
    var b = e.target.closest ? e.target.closest('.qm-sk-icon') : null;
    if(!b) return;
    var k=b.getAttribute('data-k'), st=skLoad();
    skTipKey=k;
    /* each icon its own note; one not won yet cannot be picked */
    var at=Array.prototype.indexOf.call($('qmStreakBody').querySelectorAll('.qm-sk-icon'), b);
    if(st.won[k]){ st.pick=k; skSave(st); skChip(); SFX.ui('select', at); }
    else SFX.ui('denied');
    skSheet();
  });
  window.addEventListener('keydown', function(e){
    if(skOpenNow){ e.preventDefault(); e.stopImmediatePropagation(); skMomentClose(); return; }
    if(e.key==='Escape' && $('qmStreakSheet').classList.contains('is-on')){ e.stopImmediatePropagation(); skCloseSheet(); }
  }, true);
  document.addEventListener('visibilitychange', function(){ if(!document.hidden) skChip(); });
  function skBoot(){
    skChip();
    [ART.hero_flame, ART.hero_spark].forEach(function(u){ if(u){ var im=new Image(); im.src=u; } });
  }

  /* ---------------------------------------------------------
     Wire up
     --------------------------------------------------------- */
  $('qmStart').addEventListener('click', function(){ start('play'); });
  $('qmAgain').addEventListener('click', function(){
    if(againPractice){ startTricky('restart'); return; }
    if(S.practice) restoreSavedSettings();
    start('restart');
  });
  $('qmBackToSetup').addEventListener('click', function(){ SFX.ui('back'); showScreen('intro'); });

  /* boot draws the settings controls, and drawing them saves them; on a first visit
     take that save back out, so the launcher still knows nothing was chosen yet */
  var cfgAtBoot=null;
  try { cfgAtBoot=localStorage.getItem(LS_CFG); } catch(e){}
  loadCfg();
  setGameMode(S.gameMode);
  syncModes();
  showBest();
  if(cfgAtBoot===null){ try { localStorage.removeItem(LS_CFG); } catch(e){} }
  skBoot();
  /* Boot on the launcher, not inside the app. #play in the URL still opens
     straight into it, for links meant to drop a child into the challenge. */
  /* sticker placeholders outside the launcher (results buttons and stats) */
  Array.prototype.forEach.call(document.querySelectorAll('#qmShell [data-qm-stk], #qmHistory [data-qm-stk], #qmPlay [data-qm-stk]'), function(el){
    var k=el.getAttribute('data-qm-stk');
    if(!el.firstChild && stkHtml(k)) el.innerHTML=stkHtml(k);
  });
  showScreen(window.location.hash==='#play' ? 'intro' : 'closed', true);
})();
